
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire78e9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire78e9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bgpJv", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $8335265fe8208e1f$export$e926676385687eaf);

var $gGGDG = parcelRequire("gGGDG");
var $e0G4c = parcelRequire("e0G4c");

var $gtcuO = parcelRequire("gtcuO");

var $4tluv = parcelRequire("4tluv");

var $fxaxG = parcelRequire("fxaxG");

var $dszGU = parcelRequire("dszGU");

var $2wHuJ = parcelRequire("2wHuJ");
const $8335265fe8208e1f$export$6ef4c0367e27f2d5 = 'unknown';
const $8335265fe8208e1f$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $8335265fe8208e1f$export$e926676385687eaf extends $4tluv.Component {
    constructor(props){
        super(props);
        this.state = $8335265fe8208e1f$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $gGGDG.getClient)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on('afterSendEvent', (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $e0G4c.showReportDialog)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $gGGDG.withScope)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $dszGU.captureReactException)(error, errorInfo, {
                mechanism: {
                    handled: handled
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $e0G4c.showReportDialog)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) {
            if (this.state === $8335265fe8208e1f$var$INITIAL_STATE) // If the error boundary never encountered an error, call onUnmount with null values
            onUnmount(null, null, null);
            else // `componentStack` and `eventId` are guaranteed to be non-null here because `onUnmount` is only called
            // when the error boundary has already encountered an error.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onUnmount(error, componentStack, eventId);
        }
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    resetErrorBoundary() {
        const { onReset: onReset } = this.props;
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        if (onReset) // `componentStack` and `eventId` are guaranteed to be non-null here because `onReset` is only called
        // when the error boundary has already encountered an error.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onReset(error, componentStack, eventId);
        this.setState($8335265fe8208e1f$var$INITIAL_STATE);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        // `componentStack` is only null in the initial state, when no error has been captured.
        // If an error has been captured, `componentStack` will be a string.
        // We cannot check `state.error` because null can be thrown as an error.
        if (state.componentStack === null) return typeof children === 'function' ? children() : children;
        const element = typeof fallback === 'function' ? $4tluv.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: ()=>this.resetErrorBoundary(),
            eventId: state.eventId
        }) : fallback;
        if ($4tluv.isValidElement(element)) return element;
        if (fallback) (0, $fxaxG.DEBUG_BUILD) && (0, $gtcuO.logger).warn('fallback did not produce a valid ReactElement');
        // Fail gracefully if no fallback provided or is not valid
        return null;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8335265fe8208e1f$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $8335265fe8208e1f$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$4tluv.createElement($8335265fe8208e1f$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $4tluv.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, $2wHuJ.hoistNonReactStatics)(Wrapped, WrappedComponent);
    return Wrapped;
}

});
parcelRegister("gGGDG", function(module, exports) {
$parcel$export(module.exports, "getCurrentScope", () => $c261a4d019149865$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getIsolationScope", () => $c261a4d019149865$export$68f3af03034c9e90);
$parcel$export(module.exports, "getGlobalScope", () => $c261a4d019149865$export$aa55d5ab8e05984f);
$parcel$export(module.exports, "withScope", () => $c261a4d019149865$export$ec58d9285c204497);
$parcel$export(module.exports, "withIsolationScope", () => $c261a4d019149865$export$9a4fed82c350c2bd);
$parcel$export(module.exports, "getClient", () => $c261a4d019149865$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "getTraceContextFromScope", () => $c261a4d019149865$export$1e83db7ee4876dc4);

var $irr6m = parcelRequire("irr6m");

var $9wtZQ = parcelRequire("9wtZQ");

var $e3Oja = parcelRequire("e3Oja");

var $k8n5J = parcelRequire("k8n5J");
/**
 * Get the currently active scope.
 */ function $c261a4d019149865$export$c7be4b0125a10cba() {
    const carrier = (0, $9wtZQ.getMainCarrier)();
    const acs = (0, $irr6m.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $c261a4d019149865$export$68f3af03034c9e90() {
    const carrier = (0, $9wtZQ.getMainCarrier)();
    const acs = (0, $irr6m.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $c261a4d019149865$export$aa55d5ab8e05984f() {
    return (0, $9wtZQ.getGlobalSingleton)('globalScope', ()=>new (0, $e3Oja.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $c261a4d019149865$export$ec58d9285c204497(...rest) {
    const carrier = (0, $9wtZQ.getMainCarrier)();
    const acs = (0, $irr6m.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $c261a4d019149865$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $9wtZQ.getMainCarrier)();
    const acs = (0, $irr6m.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $c261a4d019149865$export$6bb76d6eba7e258c() {
    return $c261a4d019149865$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $c261a4d019149865$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $k8n5J.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

});
parcelRegister("irr6m", function(module, exports) {
$parcel$export(module.exports, "getAsyncContextStrategy", () => $d6cfc5668ad6d0a2$export$f639b0c2752203be);

var $9wtZQ = parcelRequire("9wtZQ");

var $c4XAW = parcelRequire("c4XAW");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $d6cfc5668ad6d0a2$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $9wtZQ.getMainCarrier)();
    const sentry = (0, $9wtZQ.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $d6cfc5668ad6d0a2$export$f639b0c2752203be(carrier) {
    const sentry = (0, $9wtZQ.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $c4XAW.getStackAsyncContextStrategy)();
}

});
parcelRegister("9wtZQ", function(module, exports) {
$parcel$export(module.exports, "getMainCarrier", () => $6eee5ee152dac0a2$export$19eade501500c6c1);
$parcel$export(module.exports, "getSentryCarrier", () => $6eee5ee152dac0a2$export$c8bfa33e4e8ae492);
$parcel$export(module.exports, "getGlobalSingleton", () => $6eee5ee152dac0a2$export$7e223ec222791509);

var $1jIno = parcelRequire("1jIno");

var $hQaCR = parcelRequire("hQaCR");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $6eee5ee152dac0a2$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $6eee5ee152dac0a2$export$c8bfa33e4e8ae492((0, $hQaCR.GLOBAL_OBJ));
    return 0, $hQaCR.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $6eee5ee152dac0a2$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $1jIno.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $1jIno.SDK_VERSION] = __SENTRY__[0, $1jIno.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $6eee5ee152dac0a2$export$7e223ec222791509(name, creator, obj = (0, $hQaCR.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $1jIno.SDK_VERSION] = __SENTRY__[0, $1jIno.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("1jIno", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $0f59fd06b496b7d8$export$31499a9cd224b78c);
// This is a magic string replaced by rollup
const $0f59fd06b496b7d8$export$31499a9cd224b78c = "9.25.1";

});

parcelRegister("hQaCR", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_OBJ", () => $cfcf890b20ccc312$export$f1a6cdb1459e81d1);
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $cfcf890b20ccc312$export$f1a6cdb1459e81d1 = globalThis;

});


parcelRegister("c4XAW", function(module, exports) {
$parcel$export(module.exports, "getStackAsyncContextStrategy", () => $8cb41606035589e3$export$329d4d4d54e42710);

var $lwHsQ = parcelRequire("lwHsQ");

var $e3Oja = parcelRequire("e3Oja");

var $ipyIh = parcelRequire("ipyIh");

var $9wtZQ = parcelRequire("9wtZQ");
/**
 * This is an object that holds a stack of scopes.
 */ class $8cb41606035589e3$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $e3Oja.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $e3Oja.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $ipyIh.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $8cb41606035589e3$var$getAsyncContextStack() {
    const registry = (0, $9wtZQ.getMainCarrier)();
    const sentry = (0, $9wtZQ.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $8cb41606035589e3$export$d36ec451f120cfba((0, $lwHsQ.getDefaultCurrentScope)(), (0, $lwHsQ.getDefaultIsolationScope)());
}
function $8cb41606035589e3$var$withScope(callback) {
    return $8cb41606035589e3$var$getAsyncContextStack().withScope(callback);
}
function $8cb41606035589e3$var$withSetScope(scope, callback) {
    const stack = $8cb41606035589e3$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $8cb41606035589e3$var$withIsolationScope(callback) {
    return $8cb41606035589e3$var$getAsyncContextStack().withScope(()=>{
        return callback($8cb41606035589e3$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $8cb41606035589e3$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $8cb41606035589e3$var$withIsolationScope,
        withScope: $8cb41606035589e3$var$withScope,
        withSetScope: $8cb41606035589e3$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $8cb41606035589e3$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$8cb41606035589e3$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$8cb41606035589e3$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("lwHsQ", function(module, exports) {
$parcel$export(module.exports, "getDefaultCurrentScope", () => $fabe4d3bc72faf38$export$6f1b9191db9c4d5);
$parcel$export(module.exports, "getDefaultIsolationScope", () => $fabe4d3bc72faf38$export$de9862929b76bf57);

var $9wtZQ = parcelRequire("9wtZQ");

var $e3Oja = parcelRequire("e3Oja");
/** Get the default current scope. */ function $fabe4d3bc72faf38$export$6f1b9191db9c4d5() {
    return (0, $9wtZQ.getGlobalSingleton)('defaultCurrentScope', ()=>new (0, $e3Oja.Scope)());
}
/** Get the default isolation scope. */ function $fabe4d3bc72faf38$export$de9862929b76bf57() {
    return (0, $9wtZQ.getGlobalSingleton)('defaultIsolationScope', ()=>new (0, $e3Oja.Scope)());
}

});
parcelRegister("e3Oja", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $a3c85eaac2375497$export$775b6bb06e53a214);

var $k0zpN = parcelRequire("k0zpN");

var $lOSPh = parcelRequire("lOSPh");

var $kTCdD = parcelRequire("kTCdD");

var $ipyIh = parcelRequire("ipyIh");

var $gtcuO = parcelRequire("gtcuO");

var $53EVt = parcelRequire("53EVt");

var $k8n5J = parcelRequire("k8n5J");

var $6YXbs = parcelRequire("6YXbs");

var $kxreP = parcelRequire("kxreP");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $a3c85eaac2375497$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $a3c85eaac2375497$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $k8n5J.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $a3c85eaac2375497$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $kTCdD._setSpanForScope)(newScope, (0, $kTCdD._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $k0zpN.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $a3c85eaac2375497$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $ipyIh.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $kTCdD._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $k8n5J.generateTraceId)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $a3c85eaac2375497$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $kxreP.dateTimestampInSeconds)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $6YXbs.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $kTCdD._getSpanForScope)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $lOSPh.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $53EVt.uuid4)();
        if (!this._client) {
            (0, $gtcuO.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $53EVt.uuid4)();
        if (!this._client) {
            (0, $gtcuO.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $53EVt.uuid4)();
        if (!this._client) {
            (0, $gtcuO.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}

});
parcelRegister("k0zpN", function(module, exports) {
$parcel$export(module.exports, "makeSession", () => $e90f4769d0d5dd3a$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $e90f4769d0d5dd3a$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $e90f4769d0d5dd3a$export$56521d9ba90f62ee);

var $53EVt = parcelRequire("53EVt");

var $kxreP = parcelRequire("kxreP");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $e90f4769d0d5dd3a$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $kxreP.timestampInSeconds)();
    const session = {
        sid: (0, $53EVt.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$e90f4769d0d5dd3a$var$sessionToJSON(session)
    };
    if (context) $e90f4769d0d5dd3a$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $e90f4769d0d5dd3a$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $kxreP.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $53EVt.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $e90f4769d0d5dd3a$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $e90f4769d0d5dd3a$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $e90f4769d0d5dd3a$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

});
parcelRegister("53EVt", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $3aecfa98e64fd574$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $3aecfa98e64fd574$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $3aecfa98e64fd574$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $3aecfa98e64fd574$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $3aecfa98e64fd574$export$6de4ffac6a2f1098);

var $5qWPd = parcelRequire("5qWPd");

var $6YXbs = parcelRequire("6YXbs");

var $hQaCR = parcelRequire("hQaCR");
function $3aecfa98e64fd574$var$getCrypto() {
    const gbl = (0, $hQaCR.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $3aecfa98e64fd574$export$19f53698e68b2496(crypto = $3aecfa98e64fd574$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $3aecfa98e64fd574$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $3aecfa98e64fd574$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $3aecfa98e64fd574$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $3aecfa98e64fd574$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $3aecfa98e64fd574$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $3aecfa98e64fd574$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $3aecfa98e64fd574$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $3aecfa98e64fd574$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $3aecfa98e64fd574$export$d364f2020ab30578(input) {
    const match = input.match($3aecfa98e64fd574$var$SEMVER_REGEXP) || [];
    const major = $3aecfa98e64fd574$var$_parseInt(match[1]);
    const minor = $3aecfa98e64fd574$var$_parseInt(match[2]);
    const patch = $3aecfa98e64fd574$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $3aecfa98e64fd574$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $6YXbs.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $6YXbs.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $6YXbs.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $3aecfa98e64fd574$export$6de4ffac6a2f1098(exception) {
    if ($3aecfa98e64fd574$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $5qWPd.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $3aecfa98e64fd574$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}

});
parcelRegister("5qWPd", function(module, exports) {
$parcel$export(module.exports, "fill", () => $3f4d02e2326f8e09$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $3f4d02e2326f8e09$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $3f4d02e2326f8e09$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $3f4d02e2326f8e09$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "convertToPlainObject", () => $3f4d02e2326f8e09$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $3f4d02e2326f8e09$export$b0244d5063c0b61b);

var $bQQos = parcelRequire("bQQos");

var $bgZ7T = parcelRequire("bgZ7T");

var $ipyIh = parcelRequire("ipyIh");

var $gtcuO = parcelRequire("gtcuO");

var $6YXbs = parcelRequire("6YXbs");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $3f4d02e2326f8e09$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $3f4d02e2326f8e09$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $3f4d02e2326f8e09$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $3f4d02e2326f8e09$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $3f4d02e2326f8e09$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $3f4d02e2326f8e09$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $3f4d02e2326f8e09$export$62ff257738bf57f5(value) {
    if ((0, $ipyIh.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$3f4d02e2326f8e09$var$getOwnProperties(value)
    };
    else if ((0, $ipyIh.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $3f4d02e2326f8e09$var$serializeEventTarget(value.target),
            currentTarget: $3f4d02e2326f8e09$var$serializeEventTarget(value.currentTarget),
            ...$3f4d02e2326f8e09$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $ipyIh.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $3f4d02e2326f8e09$var$serializeEventTarget(target) {
    try {
        return (0, $ipyIh.isElement)(target) ? (0, $bgZ7T.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $3f4d02e2326f8e09$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $3f4d02e2326f8e09$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($3f4d02e2326f8e09$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $6YXbs.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $6YXbs.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $3f4d02e2326f8e09$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $3f4d02e2326f8e09$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $3f4d02e2326f8e09$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($3f4d02e2326f8e09$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($3f4d02e2326f8e09$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $3f4d02e2326f8e09$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $3f4d02e2326f8e09$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $3f4d02e2326f8e09$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $ipyIh.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("bQQos", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $8a0d314eb0f20785$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $8a0d314eb0f20785$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("bgZ7T", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $83509ac00337afe3$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $83509ac00337afe3$export$1cfafeee2987818b);
$parcel$export(module.exports, "getComponentName", () => $83509ac00337afe3$export$26727cfcc4d7e0fc);

var $ipyIh = parcelRequire("ipyIh");

var $hQaCR = parcelRequire("hQaCR");
const $83509ac00337afe3$var$WINDOW = (0, $hQaCR.GLOBAL_OBJ);
const $83509ac00337afe3$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $83509ac00337afe3$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $83509ac00337afe3$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $83509ac00337afe3$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $83509ac00337afe3$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($83509ac00337afe3$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $ipyIh.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $83509ac00337afe3$export$1cfafeee2987818b() {
    try {
        return $83509ac00337afe3$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $83509ac00337afe3$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$83509ac00337afe3$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("ipyIh", function(module, exports) {
$parcel$export(module.exports, "isError", () => $d6757d188fe7c37d$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $d6757d188fe7c37d$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $d6757d188fe7c37d$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $d6757d188fe7c37d$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $d6757d188fe7c37d$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $d6757d188fe7c37d$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $d6757d188fe7c37d$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $d6757d188fe7c37d$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $d6757d188fe7c37d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $d6757d188fe7c37d$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $d6757d188fe7c37d$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $d6757d188fe7c37d$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $d6757d188fe7c37d$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $d6757d188fe7c37d$export$bc2894c7158efbac);
$parcel$export(module.exports, "isVueViewModel", () => $d6757d188fe7c37d$export$7916fad0ebc23f48);
$parcel$export(module.exports, "isRequest", () => $d6757d188fe7c37d$export$6d3d1f317d7cda57);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $d6757d188fe7c37d$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$e6127cc7fe7395c3(wat) {
    switch($d6757d188fe7c37d$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $d6757d188fe7c37d$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$var$isBuiltin(wat, className) {
    return $d6757d188fe7c37d$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$9f9636d330b71954(wat) {
    return $d6757d188fe7c37d$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$ef9e2056653f0c8e(wat) {
    return $d6757d188fe7c37d$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$12e869b2a583f783(wat) {
    return $d6757d188fe7c37d$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$844ec244b1367d54(wat) {
    return $d6757d188fe7c37d$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$c3825b437cbdea5c(wat) {
    return wat === null || $d6757d188fe7c37d$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$53b83ca8eaab0383(wat) {
    return $d6757d188fe7c37d$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $d6757d188fe7c37d$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $d6757d188fe7c37d$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$49841c62b9eff15(wat) {
    return $d6757d188fe7c37d$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $d6757d188fe7c37d$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$bc2894c7158efbac(wat) {
    return $d6757d188fe7c37d$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d6757d188fe7c37d$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $d6757d188fe7c37d$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $d6757d188fe7c37d$export$49034edbe6b62415(request, Request);
}

});


parcelRegister("gtcuO", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $bfd90c3650e7eee0$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $bfd90c3650e7eee0$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $bfd90c3650e7eee0$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $bfd90c3650e7eee0$export$af88d00dbe7f521);

var $9wtZQ = parcelRequire("9wtZQ");

var $bQQos = parcelRequire("bQQos");

var $hQaCR = parcelRequire("hQaCR");
/** Prefix for logging strings */ const $bfd90c3650e7eee0$var$PREFIX = 'Sentry Logger ';
const $bfd90c3650e7eee0$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $bfd90c3650e7eee0$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $bfd90c3650e7eee0$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $hQaCR.GLOBAL_OBJ))) return callback();
    const console = (0, $hQaCR.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($bfd90c3650e7eee0$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $bfd90c3650e7eee0$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $bfd90c3650e7eee0$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $bQQos.DEBUG_BUILD) $bfd90c3650e7eee0$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $bfd90c3650e7eee0$export$cda52e2a8927a2ca(()=>{
                (0, $hQaCR.GLOBAL_OBJ).console[name](`${$bfd90c3650e7eee0$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $bfd90c3650e7eee0$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $bfd90c3650e7eee0$export$af88d00dbe7f521 = (0, $9wtZQ.getGlobalSingleton)('logger', $bfd90c3650e7eee0$var$makeLogger);

});

parcelRegister("6YXbs", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $51564152b322786b$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $51564152b322786b$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $51564152b322786b$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $51564152b322786b$export$a7a5ec66062ea5d);

var $ipyIh = parcelRequire("ipyIh");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $51564152b322786b$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $51564152b322786b$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $51564152b322786b$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $ipyIh.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $51564152b322786b$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $ipyIh.isString)(value)) return false;
    if ((0, $ipyIh.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $ipyIh.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $51564152b322786b$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$51564152b322786b$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("kxreP", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => $ef3c04a4e9e7aa83$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $ef3c04a4e9e7aa83$export$ee52dced521e3e18);

var $hQaCR = parcelRequire("hQaCR");
const $ef3c04a4e9e7aa83$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $ef3c04a4e9e7aa83$export$7740643b9eeaf0c4() {
    return Date.now() / $ef3c04a4e9e7aa83$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $ef3c04a4e9e7aa83$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $hQaCR.GLOBAL_OBJ);
    if (!performance?.now) return $ef3c04a4e9e7aa83$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $ef3c04a4e9e7aa83$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $ef3c04a4e9e7aa83$export$ee52dced521e3e18 = $ef3c04a4e9e7aa83$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $ef3c04a4e9e7aa83$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $ef3c04a4e9e7aa83$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $hQaCR.GLOBAL_OBJ);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $ef3c04a4e9e7aa83$export$baf075a948ffc0bf() {
    if (!$ef3c04a4e9e7aa83$var$cachedTimeOrigin) $ef3c04a4e9e7aa83$var$cachedTimeOrigin = $ef3c04a4e9e7aa83$var$getBrowserTimeOrigin();
    return $ef3c04a4e9e7aa83$var$cachedTimeOrigin[0];
}

});


parcelRegister("lOSPh", function(module, exports) {
$parcel$export(module.exports, "merge", () => $fe28cbcc8eb8884c$export$4950aa0f605343fb);
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $fe28cbcc8eb8884c$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $fe28cbcc8eb8884c$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("kTCdD", function(module, exports) {
$parcel$export(module.exports, "_setSpanForScope", () => $f36697353b11a246$export$3f25fa50c18e20ca);
$parcel$export(module.exports, "_getSpanForScope", () => $f36697353b11a246$export$91f063ebb8eff307);

var $5qWPd = parcelRequire("5qWPd");
const $f36697353b11a246$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $f36697353b11a246$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $5qWPd.addNonEnumerableProperty)(scope, $f36697353b11a246$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$f36697353b11a246$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $f36697353b11a246$export$91f063ebb8eff307(scope) {
    return scope[$f36697353b11a246$var$SCOPE_SPAN_FIELD];
}

});

parcelRegister("k8n5J", function(module, exports) {
$parcel$export(module.exports, "generateTraceId", () => $ea8677755fee20ee$export$dc6d7ea554bcce10);
$parcel$export(module.exports, "generateSpanId", () => $ea8677755fee20ee$export$295213bc4d0c54ad);

var $53EVt = parcelRequire("53EVt");
/**
 * Generate a random, valid trace ID.
 */ function $ea8677755fee20ee$export$dc6d7ea554bcce10() {
    return (0, $53EVt.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $ea8677755fee20ee$export$295213bc4d0c54ad() {
    return (0, $53EVt.uuid4)().substring(16);
}

});






parcelRegister("e0G4c", function(module, exports) {
$parcel$export(module.exports, "showReportDialog", () => $a331b2586bcee0d0$export$3a8fd680da42627b);

var $gGGDG = parcelRequire("gGGDG");
var $ci9Sv = parcelRequire("ci9Sv");
var $9QeFV = parcelRequire("9QeFV");
var $gtcuO = parcelRequire("gtcuO");

var $faoOk = parcelRequire("faoOk");

var $quYvH = parcelRequire("quYvH");
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the current scope.
 */ function $a331b2586bcee0d0$export$3a8fd680da42627b(options = {}) {
    const optionalDocument = (0, $quYvH.WINDOW).document;
    const injectionPoint = optionalDocument?.head || optionalDocument?.body;
    // doesn't work without a document (React Native)
    if (!injectionPoint) {
        (0, $faoOk.DEBUG_BUILD) && (0, $gtcuO.logger).error('[showReportDialog] Global document not defined');
        return;
    }
    const scope = (0, $gGGDG.getCurrentScope)();
    const client = (0, $gGGDG.getClient)();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $faoOk.DEBUG_BUILD) && (0, $gtcuO.logger).error('[showReportDialog] DSN not configured');
        return;
    }
    const mergedOptions = {
        ...options,
        user: {
            ...scope.getUser(),
            ...options.user
        },
        eventId: options.eventId || (0, $9QeFV.lastEventId)()
    };
    const script = (0, $quYvH.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $ci9Sv.getReportDialogEndpoint)(dsn, mergedOptions);
    const { onLoad: onLoad, onClose: onClose } = mergedOptions;
    if (onLoad) script.onload = onLoad;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $quYvH.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $quYvH.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    injectionPoint.appendChild(script);
}

});
parcelRegister("ci9Sv", function(module, exports) {
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $8f2ed41562f8c34b$export$9964600bfe84e6a3);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $8f2ed41562f8c34b$export$671c7ed8e40a7a57);

var $dN60t = parcelRequire("dN60t");
const $8f2ed41562f8c34b$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $8f2ed41562f8c34b$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $8f2ed41562f8c34b$var$_getIngestEndpoint(dsn) {
    return `${$8f2ed41562f8c34b$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $8f2ed41562f8c34b$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $8f2ed41562f8c34b$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $8f2ed41562f8c34b$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$8f2ed41562f8c34b$var$_getIngestEndpoint(dsn)}?${$8f2ed41562f8c34b$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $8f2ed41562f8c34b$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $dN60t.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$8f2ed41562f8c34b$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $dN60t.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("dN60t", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $a0a482c746546f22$export$44d472fbb931a776);
$parcel$export(module.exports, "extractOrgIdFromDsnHost", () => $a0a482c746546f22$export$5914f4e7748c29c9);
$parcel$export(module.exports, "makeDsn", () => $a0a482c746546f22$export$128827c3562ec0cb);

var $bQQos = parcelRequire("bQQos");

var $gtcuO = parcelRequire("gtcuO");
/** Regular expression used to extract org ID from a DSN host. */ const $a0a482c746546f22$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $a0a482c746546f22$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $a0a482c746546f22$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $a0a482c746546f22$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $a0a482c746546f22$export$b892860177f70a30(str) {
    const match = $a0a482c746546f22$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $gtcuO.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $a0a482c746546f22$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $a0a482c746546f22$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $a0a482c746546f22$var$validateDsn(dsn) {
    if (!(0, $bQQos.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $gtcuO.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $gtcuO.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$a0a482c746546f22$var$isValidProtocol(protocol)) {
        (0, $gtcuO.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $gtcuO.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $a0a482c746546f22$export$5914f4e7748c29c9(host) {
    const match = host.match($a0a482c746546f22$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $a0a482c746546f22$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $a0a482c746546f22$export$b892860177f70a30(from) : $a0a482c746546f22$var$dsnFromComponents(from);
    if (!components || !$a0a482c746546f22$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("9QeFV", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $72a45a995a92c3a0$export$f5282963edea4a68);
$parcel$export(module.exports, "captureEvent", () => $72a45a995a92c3a0$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "setContext", () => $72a45a995a92c3a0$export$2f04de43fe27971a);
$parcel$export(module.exports, "setTag", () => $72a45a995a92c3a0$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $72a45a995a92c3a0$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "lastEventId", () => $72a45a995a92c3a0$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "startSession", () => $72a45a995a92c3a0$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $72a45a995a92c3a0$export$667e7b4d445d566b);

var $gGGDG = parcelRequire("gGGDG");

var $bQQos = parcelRequire("bQQos");

var $k0zpN = parcelRequire("k0zpN");

var $bjThL = parcelRequire("bjThL");

var $ipyIh = parcelRequire("ipyIh");

var $gtcuO = parcelRequire("gtcuO");

var $53EVt = parcelRequire("53EVt");

var $kxreP = parcelRequire("kxreP");

var $hQaCR = parcelRequire("hQaCR");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $72a45a995a92c3a0$export$f5282963edea4a68(exception, hint) {
    return (0, $gGGDG.getCurrentScope)().captureException(exception, (0, $bjThL.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $72a45a995a92c3a0$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $gGGDG.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $72a45a995a92c3a0$export$1462b974fdcf6ba2(event, hint) {
    return (0, $gGGDG.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $72a45a995a92c3a0$export$2f04de43fe27971a(name, context) {
    (0, $gGGDG.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $72a45a995a92c3a0$export$bb4922da0dd51b92(extras) {
    (0, $gGGDG.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $72a45a995a92c3a0$export$8e8e7789d42ed61d(key, extra) {
    (0, $gGGDG.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $72a45a995a92c3a0$export$74a8fb34822092e6(tags) {
    (0, $gGGDG.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $72a45a995a92c3a0$export$a37d07ee78eb4569(key, value) {
    (0, $gGGDG.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $72a45a995a92c3a0$export$8b6bb3dd62a01be2(user) {
    (0, $gGGDG.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $72a45a995a92c3a0$export$5d4e9fd7fac8e617() {
    return (0, $gGGDG.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $72a45a995a92c3a0$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $gGGDG.getCurrentScope)();
    const client = (0, $gGGDG.getClient)();
    if (!client) (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $53EVt.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $72a45a995a92c3a0$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $72a45a995a92c3a0$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $kxreP.timestampInSeconds)();
    function finishCheckIn(status) {
        $72a45a995a92c3a0$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $kxreP.timestampInSeconds)() - now
        });
    }
    return (0, $gGGDG.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $ipyIh.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $72a45a995a92c3a0$export$4909b86c8034bf73(timeout) {
    const client = (0, $gGGDG.getClient)();
    if (client) return client.flush(timeout);
    (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $72a45a995a92c3a0$export$8360e631d277ea4d(timeout) {
    const client = (0, $gGGDG.getClient)();
    if (client) return client.close(timeout);
    (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $72a45a995a92c3a0$export$3f95c6f800b78024() {
    return !!(0, $gGGDG.getClient)();
}
/** If the SDK is initialized & enabled. */ function $72a45a995a92c3a0$export$3b029eb57ac4d562() {
    const client = (0, $gGGDG.getClient)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $72a45a995a92c3a0$export$9aac0b9f77928fbf(callback) {
    (0, $gGGDG.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $72a45a995a92c3a0$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $gGGDG.getIsolationScope)();
    const currentScope = (0, $gGGDG.getCurrentScope)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $hQaCR.GLOBAL_OBJ).navigator || {};
    const session = (0, $k0zpN.makeSession)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $k0zpN.updateSession)(currentSession, {
        status: 'exited'
    });
    $72a45a995a92c3a0$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $72a45a995a92c3a0$export$17a5be43989a0bc1() {
    const isolationScope = (0, $gGGDG.getIsolationScope)();
    const currentScope = (0, $gGGDG.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $k0zpN.closeSession)(session);
    $72a45a995a92c3a0$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $72a45a995a92c3a0$var$_sendSessionUpdate() {
    const isolationScope = (0, $gGGDG.getIsolationScope)();
    const client = (0, $gGGDG.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $72a45a995a92c3a0$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $72a45a995a92c3a0$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $72a45a995a92c3a0$var$_sendSessionUpdate();
}

});
parcelRegister("bjThL", function(module, exports) {
$parcel$export(module.exports, "prepareEvent", () => $83dc5a9f09233bca$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $83dc5a9f09233bca$export$76b5f966996d1653);

var $bj6HP = parcelRequire("bj6HP");

var $gGGDG = parcelRequire("gGGDG");

var $7GUfT = parcelRequire("7GUfT");

var $e3Oja = parcelRequire("e3Oja");

var $3uAEn = parcelRequire("3uAEn");

var $53EVt = parcelRequire("53EVt");

var $kTrk3 = parcelRequire("kTrk3");

var $6YXbs = parcelRequire("6YXbs");

var $kxreP = parcelRequire("kxreP");

var $7Yg8V = parcelRequire("7Yg8V");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $83dc5a9f09233bca$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $53EVt.uuid4)(),
        timestamp: event.timestamp || (0, $kxreP.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $83dc5a9f09233bca$export$d7e04067a6fbc882(prepared, options);
    $83dc5a9f09233bca$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $83dc5a9f09233bca$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $83dc5a9f09233bca$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $53EVt.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $gGGDG.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $7Yg8V.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $7Yg8V.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $7Yg8V.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $7GUfT.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $83dc5a9f09233bca$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $83dc5a9f09233bca$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $83dc5a9f09233bca$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $bj6HP.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $6YXbs.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $83dc5a9f09233bca$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $3uAEn.getFilenameToDebugIdMap)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $83dc5a9f09233bca$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $83dc5a9f09233bca$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $83dc5a9f09233bca$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $kTrk3.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $kTrk3.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $kTrk3.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $kTrk3.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $kTrk3.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $kTrk3.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $kTrk3.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $83dc5a9f09233bca$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $e3Oja.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $83dc5a9f09233bca$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($83dc5a9f09233bca$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($83dc5a9f09233bca$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $83dc5a9f09233bca$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $e3Oja.Scope) || typeof hint === 'function';
}
const $83dc5a9f09233bca$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $83dc5a9f09233bca$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$83dc5a9f09233bca$var$captureContextKeys.includes(key));
}

});
parcelRegister("bj6HP", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $83b6abb670e0f38f$export$849dbeeeda01ae98);
const $83b6abb670e0f38f$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("7GUfT", function(module, exports) {
$parcel$export(module.exports, "notifyEventProcessors", () => $599817cf159137d4$export$bf2a096c3e883e79);

var $bQQos = parcelRequire("bQQos");

var $ipyIh = parcelRequire("ipyIh");

var $gtcuO = parcelRequire("gtcuO");

var $h8Lht = parcelRequire("h8Lht");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $599817cf159137d4$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $h8Lht.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $bQQos.DEBUG_BUILD) && processor.id && result === null && (0, $gtcuO.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $ipyIh.isThenable)(result)) result.then((final)=>$599817cf159137d4$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $599817cf159137d4$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("h8Lht", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $03386284210a29e2$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $03386284210a29e2$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $03386284210a29e2$export$78e43115b553f358);

var $ipyIh = parcelRequire("ipyIh");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $03386284210a29e2$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($03386284210a29e2$var$States || ($03386284210a29e2$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $03386284210a29e2$export$1fda8aa4d135f8aa(value) {
    return new $03386284210a29e2$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $03386284210a29e2$export$78e43115b553f358(reason) {
    return new $03386284210a29e2$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $03386284210a29e2$export$6f292d4960313241 {
    constructor(executor){
        this._state = $03386284210a29e2$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $03386284210a29e2$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $03386284210a29e2$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $03386284210a29e2$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $03386284210a29e2$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $03386284210a29e2$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $03386284210a29e2$var$States.PENDING) return;
            if ((0, $ipyIh.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($03386284210a29e2$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($03386284210a29e2$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}

});


parcelRegister("3uAEn", function(module, exports) {
$parcel$export(module.exports, "getFilenameToDebugIdMap", () => $28b09a6815051949$export$e069fee9c632ed00);

var $hQaCR = parcelRequire("hQaCR");
let $28b09a6815051949$var$parsedStackResults;
let $28b09a6815051949$var$lastKeysCount;
let $28b09a6815051949$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $28b09a6815051949$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $hQaCR.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($28b09a6815051949$var$cachedFilenameDebugIds && debugIdKeys.length === $28b09a6815051949$var$lastKeysCount) return $28b09a6815051949$var$cachedFilenameDebugIds;
    $28b09a6815051949$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $28b09a6815051949$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$28b09a6815051949$var$parsedStackResults) $28b09a6815051949$var$parsedStackResults = {};
        const result = $28b09a6815051949$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $28b09a6815051949$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $28b09a6815051949$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $28b09a6815051949$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $28b09a6815051949$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}

});

parcelRegister("kTrk3", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $f35e23651b5df1eb$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $f35e23651b5df1eb$export$23fbbb20bed71033);

var $ipyIh = parcelRequire("ipyIh");

var $5qWPd = parcelRequire("5qWPd");

var $e19TC = parcelRequire("e19TC");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f35e23651b5df1eb$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $f35e23651b5df1eb$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $f35e23651b5df1eb$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $f35e23651b5df1eb$export$a3295358bff77e(object, depth);
    if ($f35e23651b5df1eb$var$jsonSize(normalized) > maxSize) return $f35e23651b5df1eb$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $f35e23651b5df1eb$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $f35e23651b5df1eb$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $f35e23651b5df1eb$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $f35e23651b5df1eb$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $5qWPd.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $f35e23651b5df1eb$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $f35e23651b5df1eb$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $ipyIh.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $ipyIh.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $e19TC.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $f35e23651b5df1eb$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $f35e23651b5df1eb$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $f35e23651b5df1eb$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f35e23651b5df1eb$var$jsonSize(value) {
    return $f35e23651b5df1eb$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $f35e23651b5df1eb$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $f35e23651b5df1eb$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});
parcelRegister("e19TC", function(module, exports) {
$parcel$export(module.exports, "UNKNOWN_FUNCTION", () => $a348d5d603ef8a7b$export$27c7e15d453fc0ac);
$parcel$export(module.exports, "createStackParser", () => $a348d5d603ef8a7b$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $a348d5d603ef8a7b$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $a348d5d603ef8a7b$export$aad197c7121a6651);
$parcel$export(module.exports, "getFramesFromEvent", () => $a348d5d603ef8a7b$export$91d8ca51bd9f6a47);
const $a348d5d603ef8a7b$var$STACKTRACE_FRAME_LIMIT = 50;
const $a348d5d603ef8a7b$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $a348d5d603ef8a7b$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $a348d5d603ef8a7b$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $a348d5d603ef8a7b$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $a348d5d603ef8a7b$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($a348d5d603ef8a7b$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $a348d5d603ef8a7b$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $a348d5d603ef8a7b$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $a348d5d603ef8a7b$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $a348d5d603ef8a7b$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $a348d5d603ef8a7b$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($a348d5d603ef8a7b$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($a348d5d603ef8a7b$var$STRIP_FRAME_REGEXP.test($a348d5d603ef8a7b$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($a348d5d603ef8a7b$var$STRIP_FRAME_REGEXP.test($a348d5d603ef8a7b$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $a348d5d603ef8a7b$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $a348d5d603ef8a7b$var$getLastStackFrame(localStack).filename,
            function: frame.function || $a348d5d603ef8a7b$export$27c7e15d453fc0ac
        }));
}
function $a348d5d603ef8a7b$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $a348d5d603ef8a7b$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $a348d5d603ef8a7b$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $a348d5d603ef8a7b$var$defaultFunctionName;
        return fn.name || $a348d5d603ef8a7b$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $a348d5d603ef8a7b$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $a348d5d603ef8a7b$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}

});


parcelRegister("7Yg8V", function(module, exports) {
$parcel$export(module.exports, "applyScopeDataToEvent", () => $5cdaa8ad6fbf096e$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $5cdaa8ad6fbf096e$export$25ac7e259a513db4);

var $l37aq = parcelRequire("l37aq");

var $lOSPh = parcelRequire("lOSPh");

var $LH0Iq = parcelRequire("LH0Iq");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $5cdaa8ad6fbf096e$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $5cdaa8ad6fbf096e$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $5cdaa8ad6fbf096e$var$applySpanToEvent(event, span);
    $5cdaa8ad6fbf096e$var$applyFingerprintToEvent(event, fingerprint);
    $5cdaa8ad6fbf096e$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $5cdaa8ad6fbf096e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $5cdaa8ad6fbf096e$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $5cdaa8ad6fbf096e$export$b1a120a2871faa46(data, 'extra', extra);
    $5cdaa8ad6fbf096e$export$b1a120a2871faa46(data, 'tags', tags);
    $5cdaa8ad6fbf096e$export$b1a120a2871faa46(data, 'user', user);
    $5cdaa8ad6fbf096e$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $lOSPh.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $5cdaa8ad6fbf096e$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $lOSPh.merge)(data[prop], mergeVal, 1);
}
function $5cdaa8ad6fbf096e$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $5cdaa8ad6fbf096e$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $5cdaa8ad6fbf096e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $5cdaa8ad6fbf096e$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $LH0Iq.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $l37aq.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $LH0Iq.getRootSpan)(span);
    const transactionName = (0, $LH0Iq.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $5cdaa8ad6fbf096e$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("l37aq", function(module, exports) {
$parcel$export(module.exports, "getDynamicSamplingContextFromScope", () => $f52f700dafe12148$export$89ef1736f08c6b2b);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $f52f700dafe12148$export$a117f995597e25df);

var $bj6HP = parcelRequire("bj6HP");

var $gGGDG = parcelRequire("gGGDG");

var $5F3Lb = parcelRequire("5F3Lb");

var $j2Y24 = parcelRequire("j2Y24");

var $LH0Iq = parcelRequire("LH0Iq");

var $9EFXu = parcelRequire("9EFXu");

var $dN60t = parcelRequire("dN60t");

var $5qWPd = parcelRequire("5qWPd");

var $hcyv4 = parcelRequire("hcyv4");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $f52f700dafe12148$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $f52f700dafe12148$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $5qWPd.addNonEnumerableProperty)(spanWithMaybeDsc, $f52f700dafe12148$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $f52f700dafe12148$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key, host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = (0, $dN60t.extractOrgIdFromDsnHost)(host);
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $bj6HP.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: org_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $f52f700dafe12148$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $f52f700dafe12148$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $f52f700dafe12148$export$a117f995597e25df(span) {
    const client = (0, $gGGDG.getClient)();
    if (!client) return {};
    const rootSpan = (0, $LH0Iq.getRootSpan)(span);
    const rootSpanJson = (0, $LH0Iq.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $5F3Lb.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[0, $5F3Lb.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$f52f700dafe12148$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $9EFXu.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $f52f700dafe12148$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $5F3Lb.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $j2Y24.hasSpansEnabled)()) {
        dsc.sampled = String((0, $LH0Iq.spanIsSampled)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $hcyv4.getCapturedScopesOnSpan)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $f52f700dafe12148$export$95cf936fdacaff7b(span) {
    const dsc = $f52f700dafe12148$export$a117f995597e25df(span);
    return (0, $9EFXu.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("5F3Lb", function(module, exports) {
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $41f3b2c08b6fcffd$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $41f3b2c08b6fcffd$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", () => $41f3b2c08b6fcffd$export$889fb736668e1ecc);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $41f3b2c08b6fcffd$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $41f3b2c08b6fcffd$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", () => $41f3b2c08b6fcffd$export$165ce9a229f6f050);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", () => $41f3b2c08b6fcffd$export$1efec95406bbe327);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", () => $41f3b2c08b6fcffd$export$fea48ba9f4550879);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", () => $41f3b2c08b6fcffd$export$be7a251980e7e946);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_URL_FULL", () => $41f3b2c08b6fcffd$export$25dfd73e0e32c6e1);
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $41f3b2c08b6fcffd$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $41f3b2c08b6fcffd$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $41f3b2c08b6fcffd$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $41f3b2c08b6fcffd$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $41f3b2c08b6fcffd$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $41f3b2c08b6fcffd$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $41f3b2c08b6fcffd$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $41f3b2c08b6fcffd$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $41f3b2c08b6fcffd$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $41f3b2c08b6fcffd$export$1efec95406bbe327 = 'sentry.profile_id';
const $41f3b2c08b6fcffd$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $41f3b2c08b6fcffd$export$b016f89ac1066ec = 'cache.hit';
const $41f3b2c08b6fcffd$export$3110e4c3f4386399 = 'cache.key';
const $41f3b2c08b6fcffd$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $41f3b2c08b6fcffd$export$be7a251980e7e946 = 'http.request.method';
const $41f3b2c08b6fcffd$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $41f3b2c08b6fcffd$export$ff77b5fd5b2d627b = 'sentry.link.type';

});

parcelRegister("j2Y24", function(module, exports) {
$parcel$export(module.exports, "hasSpansEnabled", () => $dddcc56dc647ff0d$export$1f70765132c3c225);

var $gGGDG = parcelRequire("gGGDG");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $dddcc56dc647ff0d$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $gGGDG.getClient)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $dddcc56dc647ff0d$export$5008da00b1b6dee6 = $dddcc56dc647ff0d$export$1f70765132c3c225;

});

parcelRegister("LH0Iq", function(module, exports) {
$parcel$export(module.exports, "spanToJSON", () => $08f5c0e5e73863ec$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceContext", () => $08f5c0e5e73863ec$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanIsSampled", () => $08f5c0e5e73863ec$export$5caecac1caaf3a71);
$parcel$export(module.exports, "getRootSpan", () => $08f5c0e5e73863ec$export$c4c6a79b1260ca1b);
$parcel$export(module.exports, "getActiveSpan", () => $08f5c0e5e73863ec$export$1be426a8e585c83e);
$parcel$export(module.exports, "showSpanDropWarning", () => $08f5c0e5e73863ec$export$d11691ff45a3e535);

var $irr6m = parcelRequire("irr6m");

var $9wtZQ = parcelRequire("9wtZQ");

var $gGGDG = parcelRequire("gGGDG");

var $5F3Lb = parcelRequire("5F3Lb");

var $jsAoS = parcelRequire("jsAoS");

var $hcyv4 = parcelRequire("hcyv4");

var $gtcuO = parcelRequire("gtcuO");

var $5qWPd = parcelRequire("5qWPd");

var $k8n5J = parcelRequire("k8n5J");

var $kxreP = parcelRequire("kxreP");

var $1b3Yz = parcelRequire("1b3Yz");

var $kTCdD = parcelRequire("kTCdD");
// These are aligned with OpenTelemetry trace flags
const $08f5c0e5e73863ec$export$208d5b368507fb8b = 0x0;
const $08f5c0e5e73863ec$export$eb571cd9b5d98de8 = 0x1;
let $08f5c0e5e73863ec$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $08f5c0e5e73863ec$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $08f5c0e5e73863ec$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $08f5c0e5e73863ec$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $08f5c0e5e73863ec$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $hcyv4.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $k8n5J.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $08f5c0e5e73863ec$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $08f5c0e5e73863ec$export$5caecac1caaf3a71(span);
    return (0, $1b3Yz.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $08f5c0e5e73863ec$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $08f5c0e5e73863ec$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $08f5c0e5e73863ec$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $08f5c0e5e73863ec$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $08f5c0e5e73863ec$var$ensureTimestampInSeconds(input.getTime());
    return (0, $kxreP.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $08f5c0e5e73863ec$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $08f5c0e5e73863ec$export$92d8c23565496537(span) {
    if ($08f5c0e5e73863ec$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($08f5c0e5e73863ec$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $08f5c0e5e73863ec$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $08f5c0e5e73863ec$export$3f7581298f56c6d7(endTime) || undefined,
            status: $08f5c0e5e73863ec$export$e238a77ea3a8cd66(status),
            op: attributes[0, $5F3Lb.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $5F3Lb.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $08f5c0e5e73863ec$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $08f5c0e5e73863ec$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $08f5c0e5e73863ec$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $08f5c0e5e73863ec$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $08f5c0e5e73863ec$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $08f5c0e5e73863ec$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $jsAoS.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $jsAoS.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'unknown_error';
}
const $08f5c0e5e73863ec$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $08f5c0e5e73863ec$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $08f5c0e5e73863ec$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$08f5c0e5e73863ec$var$ROOT_SPAN_FIELD] || span;
    (0, $5qWPd.addNonEnumerableProperty)(childSpan, $08f5c0e5e73863ec$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$08f5c0e5e73863ec$var$CHILD_SPANS_FIELD]) span[$08f5c0e5e73863ec$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $5qWPd.addNonEnumerableProperty)(span, $08f5c0e5e73863ec$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $08f5c0e5e73863ec$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$08f5c0e5e73863ec$var$CHILD_SPANS_FIELD]) span[$08f5c0e5e73863ec$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $08f5c0e5e73863ec$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($08f5c0e5e73863ec$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$08f5c0e5e73863ec$var$CHILD_SPANS_FIELD] ? Array.from(span[$08f5c0e5e73863ec$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $08f5c0e5e73863ec$export$c4c6a79b1260ca1b(span) {
    return span[$08f5c0e5e73863ec$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $08f5c0e5e73863ec$export$1be426a8e585c83e() {
    const carrier = (0, $9wtZQ.getMainCarrier)();
    const acs = (0, $irr6m.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $kTCdD._getSpanForScope)((0, $gGGDG.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $08f5c0e5e73863ec$export$d11691ff45a3e535() {
    if (!$08f5c0e5e73863ec$var$hasShownSpanDropWarning) {
        (0, $gtcuO.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $08f5c0e5e73863ec$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $08f5c0e5e73863ec$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $5F3Lb.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
        [(0, $5F3Lb.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("jsAoS", function(module, exports) {
$parcel$export(module.exports, "SPAN_STATUS_UNSET", () => $e2acde337c135a0e$export$136e25984ba4a383);
$parcel$export(module.exports, "SPAN_STATUS_OK", () => $e2acde337c135a0e$export$58f7963109c806fc);
const $e2acde337c135a0e$export$136e25984ba4a383 = 0;
const $e2acde337c135a0e$export$58f7963109c806fc = 1;
const $e2acde337c135a0e$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $e2acde337c135a0e$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $e2acde337c135a0e$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $e2acde337c135a0e$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $e2acde337c135a0e$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $e2acde337c135a0e$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $e2acde337c135a0e$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

});

parcelRegister("hcyv4", function(module, exports) {
$parcel$export(module.exports, "getCapturedScopesOnSpan", () => $c85e51aeb171d9a5$export$c08fbc656a245d03);

var $5qWPd = parcelRequire("5qWPd");
const $c85e51aeb171d9a5$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $c85e51aeb171d9a5$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $c85e51aeb171d9a5$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $5qWPd.addNonEnumerableProperty)(span, $c85e51aeb171d9a5$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $5qWPd.addNonEnumerableProperty)(span, $c85e51aeb171d9a5$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $c85e51aeb171d9a5$export$c08fbc656a245d03(span) {
    return {
        scope: span[$c85e51aeb171d9a5$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$c85e51aeb171d9a5$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});

parcelRegister("1b3Yz", function(module, exports) {
$parcel$export(module.exports, "generateSentryTraceHeader", () => $0db9e7146f0268b2$export$f35d907436da45cf);

var $5h8Gr = parcelRequire("5h8Gr");

var $9EFXu = parcelRequire("9EFXu");

var $k8n5J = parcelRequire("k8n5J");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $0db9e7146f0268b2$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $0db9e7146f0268b2$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($0db9e7146f0268b2$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $0db9e7146f0268b2$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $0db9e7146f0268b2$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9EFXu.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $k8n5J.generateTraceId)(),
        sampleRand: Math.random()
    };
    const sampleRand = $0db9e7146f0268b2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $0db9e7146f0268b2$export$f35d907436da45cf(traceId = (0, $k8n5J.generateTraceId)(), spanId = (0, $k8n5J.generateSpanId)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $0db9e7146f0268b2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $5h8Gr.parseSampleRate)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $5h8Gr.parseSampleRate)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}

});
parcelRegister("5h8Gr", function(module, exports) {
$parcel$export(module.exports, "parseSampleRate", () => $3d7546a81a1cfa21$export$a5bd2d81656d9546);
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $3d7546a81a1cfa21$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

});

parcelRegister("9EFXu", function(module, exports) {
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $7078658b91aeb9e1$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $7078658b91aeb9e1$export$56766feef403f365);

var $bQQos = parcelRequire("bQQos");

var $ipyIh = parcelRequire("ipyIh");

var $gtcuO = parcelRequire("gtcuO");
const $7078658b91aeb9e1$export$6e69537d67fa20f = 'sentry-';
const $7078658b91aeb9e1$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $7078658b91aeb9e1$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $7078658b91aeb9e1$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $7078658b91aeb9e1$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($7078658b91aeb9e1$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($7078658b91aeb9e1$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $7078658b91aeb9e1$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$7078658b91aeb9e1$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $7078658b91aeb9e1$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $7078658b91aeb9e1$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $ipyIh.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $7078658b91aeb9e1$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $7078658b91aeb9e1$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $7078658b91aeb9e1$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        })).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $7078658b91aeb9e1$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $7078658b91aeb9e1$export$bdd844ddb2def819) {
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});







parcelRegister("faoOk", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $b0ab0910e356b031$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b0ab0910e356b031$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("quYvH", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $04fa74ce7d33a07a$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $04fa74ce7d33a07a$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $04fa74ce7d33a07a$export$4997ffc0176396a6);
$parcel$export(module.exports, "getHttpRequestData", () => $04fa74ce7d33a07a$export$a3c4a8453e8936f0);

var $53EVt = parcelRequire("53EVt");
var $5qWPd = parcelRequire("5qWPd");
var $9QeFV = parcelRequire("9QeFV");
var $bgZ7T = parcelRequire("bgZ7T");
var $hQaCR = parcelRequire("hQaCR");
var $gGGDG = parcelRequire("gGGDG");
const $04fa74ce7d33a07a$export$56d8a8a25bd48b81 = (0, $hQaCR.GLOBAL_OBJ);
let $04fa74ce7d33a07a$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $04fa74ce7d33a07a$export$b79738ab10c590b2() {
    return $04fa74ce7d33a07a$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $04fa74ce7d33a07a$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $04fa74ce7d33a07a$var$ignoreOnError++;
    setTimeout(()=>{
        $04fa74ce7d33a07a$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $04fa74ce7d33a07a$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $5qWPd.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$04fa74ce7d33a07a$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $04fa74ce7d33a07a$export$1265a142ff5ba165();
            (0, $gGGDG.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $53EVt.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $53EVt.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $9QeFV.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $5qWPd.markFunctionWrapped)(sentryWrapped, fn);
    (0, $5qWPd.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $04fa74ce7d33a07a$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $bgZ7T.getLocationHref)();
    const { referrer: referrer } = $04fa74ce7d33a07a$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $04fa74ce7d33a07a$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}

});


parcelRegister("fxaxG", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $b4f21d8cfbedb473$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b4f21d8cfbedb473$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("dszGU", function(module, exports) {
$parcel$export(module.exports, "captureReactException", () => $9cc9936977f1ff89$export$270be4195468cda9);

var $9QeFV = parcelRequire("9QeFV");
var $gGGDG = parcelRequire("gGGDG");

var $ipyIh = parcelRequire("ipyIh");

var $4tluv = parcelRequire("4tluv");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $9cc9936977f1ff89$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $9cc9936977f1ff89$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $9cc9936977f1ff89$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($9cc9936977f1ff89$export$a87138b73900f5b((0, $4tluv.version)) && (0, $ipyIh.isError)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $9cc9936977f1ff89$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $gGGDG.withScope)((scope)=>{
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, $9QeFV.captureException)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $9cc9936977f1ff89$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $9cc9936977f1ff89$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}

});

parcelRegister("2wHuJ", function(module, exports) {
$parcel$export(module.exports, "hoistNonReactStatics", () => $1d704f0f6e1125c6$export$6c1f0397687d8b2);

var $523n4 = parcelRequire("523n4");
// Ensure we use the default export from hoist-non-react-statics if available,
// falling back to the module itself. This handles both ESM and CJS usage.
const $1d704f0f6e1125c6$export$6c1f0397687d8b2 = $523n4.default || $523n4;

});


parcelRegister("1IBIv", function(module, exports) {
$parcel$export(module.exports, "context", () => (parcelRequire("jhSG3")).context);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $S8N63 = parcelRequire("S8N63");















var $jhSG3 = parcelRequire("jhSG3");

var $9nwvE = parcelRequire("9nwvE");

var $hsH1V = parcelRequire("hsH1V");

var $knuXW = parcelRequire("knuXW");

var $6PhAz = parcelRequire("6PhAz");
var // Default export.
$140728495e6c503f$export$2e2bcd8739ae039 = {
    context: (0, $jhSG3.context),
    diag: (0, $9nwvE.diag),
    metrics: (0, $hsH1V.metrics),
    propagation: (0, $knuXW.propagation),
    trace: (0, $6PhAz.trace)
};

});
parcelRegister("S8N63", function(module, exports) {
$parcel$export(module.exports, "createContextKey", () => $0a2bdcf24a4bae56$export$b8c322c5a7cfce78);
$parcel$export(module.exports, "ROOT_CONTEXT", () => $0a2bdcf24a4bae56$export$78df28f9b2f9a7dc);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $0a2bdcf24a4bae56$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $0a2bdcf24a4bae56$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $0a2bdcf24a4bae56$export$78df28f9b2f9a7dc = new $0a2bdcf24a4bae56$var$BaseContext();

});

parcelRegister("jhSG3", function(module, exports) {
$parcel$export(module.exports, "context", () => $e0aa049d2eaea6a2$export$a078c61943f9dbbe);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $eP2dJ = parcelRequire("eP2dJ");
var $e0aa049d2eaea6a2$export$a078c61943f9dbbe = (0, $eP2dJ.ContextAPI).getInstance();

});
parcelRegister("eP2dJ", function(module, exports) {
$parcel$export(module.exports, "ContextAPI", () => $02c8e55f1652e728$export$4148866f0a453927);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fzmtN = parcelRequire("fzmtN");

var $5UVOI = parcelRequire("5UVOI");

var $55rm7 = parcelRequire("55rm7");
var $02c8e55f1652e728$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $02c8e55f1652e728$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $02c8e55f1652e728$var$API_NAME = 'context';
var $02c8e55f1652e728$var$NOOP_CONTEXT_MANAGER = new (0, $fzmtN.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $02c8e55f1652e728$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $5UVOI.registerGlobal)($02c8e55f1652e728$var$API_NAME, contextManager, (0, $55rm7.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $02c8e55f1652e728$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $02c8e55f1652e728$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $5UVOI.getGlobal)($02c8e55f1652e728$var$API_NAME) || $02c8e55f1652e728$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $5UVOI.unregisterGlobal)($02c8e55f1652e728$var$API_NAME, (0, $55rm7.DiagAPI).instance());
    };
    return ContextAPI;
}();

});
parcelRegister("fzmtN", function(module, exports) {
$parcel$export(module.exports, "NoopContextManager", () => $b55b8fdb93bc41d5$export$a27e5df35d1539a6);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $S8N63 = parcelRequire("S8N63");
var $b55b8fdb93bc41d5$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b55b8fdb93bc41d5$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $b55b8fdb93bc41d5$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $S8N63.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $b55b8fdb93bc41d5$var$__spreadArray([
            thisArg
        ], $b55b8fdb93bc41d5$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

});

parcelRegister("5UVOI", function(module, exports) {
$parcel$export(module.exports, "registerGlobal", () => $44ef07fabb14432f$export$d586ae880b433238);
$parcel$export(module.exports, "getGlobal", () => $44ef07fabb14432f$export$a4e55266d2135a7f);
$parcel$export(module.exports, "unregisterGlobal", () => $44ef07fabb14432f$export$d42ac835f38d1fb2);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3UDXJ = parcelRequire("3UDXJ");

var $3R6PI = parcelRequire("3R6PI");

var $l842r = parcelRequire("l842r");
var $44ef07fabb14432f$var$major = (0, $3R6PI.VERSION).split('.')[0];
var $44ef07fabb14432f$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $44ef07fabb14432f$var$major);
var $44ef07fabb14432f$var$_global = (0, $3UDXJ._globalThis);
function $44ef07fabb14432f$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $44ef07fabb14432f$var$_global[$44ef07fabb14432f$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $44ef07fabb14432f$var$_global[$44ef07fabb14432f$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $3R6PI.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $3R6PI.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $3R6PI.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $3R6PI.VERSION) + ".");
    return true;
}
function $44ef07fabb14432f$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $44ef07fabb14432f$var$_global[$44ef07fabb14432f$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $l842r.isCompatible)(globalVersion)) return;
    return (_b = $44ef07fabb14432f$var$_global[$44ef07fabb14432f$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $44ef07fabb14432f$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $3R6PI.VERSION) + ".");
    var api = $44ef07fabb14432f$var$_global[$44ef07fabb14432f$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("3UDXJ", function(module, exports) {
$parcel$export(module.exports, "_globalThis", () => $2d9599c92c5bec59$export$5c524ddf7208c00c);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $2d9599c92c5bec59$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

});

parcelRegister("3R6PI", function(module, exports) {
$parcel$export(module.exports, "VERSION", () => $2ceb9f462362b5e4$export$a4ad2735b021c132);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $2ceb9f462362b5e4$export$a4ad2735b021c132 = '1.9.0';

});

parcelRegister("l842r", function(module, exports) {
$parcel$export(module.exports, "isCompatible", () => $f61d7a4962937cf3$export$7fc0d8c3ab188c4c);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3R6PI = parcelRequire("3R6PI");
var $f61d7a4962937cf3$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $f61d7a4962937cf3$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($f61d7a4962937cf3$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($f61d7a4962937cf3$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $f61d7a4962937cf3$export$7fc0d8c3ab188c4c = $f61d7a4962937cf3$export$a5733a4d26a1ec61((0, $3R6PI.VERSION));

});


parcelRegister("55rm7", function(module, exports) {
$parcel$export(module.exports, "DiagAPI", () => $3b42a3a7b154092c$export$5c8937ffc688cfd3);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gnF1O = parcelRequire("gnF1O");

var $jObAC = parcelRequire("jObAC");

var $l72zi = parcelRequire("l72zi");

var $5UVOI = parcelRequire("5UVOI");
var $3b42a3a7b154092c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $3b42a3a7b154092c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $3b42a3a7b154092c$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $3b42a3a7b154092c$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $5UVOI.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $3b42a3a7b154092c$var$__spreadArray([], $3b42a3a7b154092c$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $l72zi.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $5UVOI.getGlobal)('diag');
            var newLogger = (0, $jObAC.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $l72zi.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $5UVOI.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $5UVOI.unregisterGlobal)($3b42a3a7b154092c$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $gnF1O.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

});
parcelRegister("gnF1O", function(module, exports) {
$parcel$export(module.exports, "DiagComponentLogger", () => $bece9eb163e9e6c3$export$b4bccc12f5b13129);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5UVOI = parcelRequire("5UVOI");
var $bece9eb163e9e6c3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $bece9eb163e9e6c3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $bece9eb163e9e6c3$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $bece9eb163e9e6c3$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $bece9eb163e9e6c3$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $bece9eb163e9e6c3$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $bece9eb163e9e6c3$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $bece9eb163e9e6c3$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $bece9eb163e9e6c3$var$logProxy(funcName, namespace, args) {
    var logger = (0, $5UVOI.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $bece9eb163e9e6c3$var$__spreadArray([], $bece9eb163e9e6c3$var$__read(args), false));
}

});

parcelRegister("jObAC", function(module, exports) {
$parcel$export(module.exports, "createLogLevelDiagLogger", () => $e6bbad50dec11736$export$9a9cc475abb19689);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $l72zi = parcelRequire("l72zi");
function $e6bbad50dec11736$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $l72zi.DiagLogLevel).NONE) maxLevel = (0, $l72zi.DiagLogLevel).NONE;
    else if (maxLevel > (0, $l72zi.DiagLogLevel).ALL) maxLevel = (0, $l72zi.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $l72zi.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $l72zi.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $l72zi.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $l72zi.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $l72zi.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("l72zi", function(module, exports) {
$parcel$export(module.exports, "DiagLogLevel", () => $f5ec3e6cced21407$export$b7d7b4c0f3c95263);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $f5ec3e6cced21407$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($f5ec3e6cced21407$export$b7d7b4c0f3c95263 || ($f5ec3e6cced21407$export$b7d7b4c0f3c95263 = {}));

});





parcelRegister("9nwvE", function(module, exports) {
$parcel$export(module.exports, "diag", () => $6d3f7ac09904cd71$export$c042e7c2f59bc046);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $55rm7 = parcelRequire("55rm7");
var $6d3f7ac09904cd71$export$c042e7c2f59bc046 = (0, $55rm7.DiagAPI).instance();

});

parcelRegister("hsH1V", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $cb666e14f395a1ea$export$b0c5c2fac8144e54);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $dpTMg = parcelRequire("dpTMg");
var $cb666e14f395a1ea$export$b0c5c2fac8144e54 = (0, $dpTMg.MetricsAPI).getInstance();

});
parcelRegister("dpTMg", function(module, exports) {
$parcel$export(module.exports, "MetricsAPI", () => $9c48e06451881f53$export$1339f6eb6111c638);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $aimrr = parcelRequire("aimrr");

var $5UVOI = parcelRequire("5UVOI");

var $55rm7 = parcelRequire("55rm7");
var $9c48e06451881f53$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $9c48e06451881f53$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $5UVOI.registerGlobal)($9c48e06451881f53$var$API_NAME, provider, (0, $55rm7.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $5UVOI.getGlobal)($9c48e06451881f53$var$API_NAME) || (0, $aimrr.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $5UVOI.unregisterGlobal)($9c48e06451881f53$var$API_NAME, (0, $55rm7.DiagAPI).instance());
    };
    return MetricsAPI;
}();

});
parcelRegister("aimrr", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER_PROVIDER", () => $77ecfe424650ad93$export$d21fe83355c56e18);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1lVtP = parcelRequire("1lVtP");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $77ecfe424650ad93$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $1lVtP.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var $77ecfe424650ad93$export$d21fe83355c56e18 = new $77ecfe424650ad93$export$51c513ea08316108();

});
parcelRegister("1lVtP", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER", () => $0fc456f1f32f8887$export$65e277d35235a01f);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0fc456f1f32f8887$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $0fc456f1f32f8887$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $0fc456f1f32f8887$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $0fc456f1f32f8887$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $0fc456f1f32f8887$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $0fc456f1f32f8887$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $0fc456f1f32f8887$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $0fc456f1f32f8887$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $0fc456f1f32f8887$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $0fc456f1f32f8887$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $0fc456f1f32f8887$export$b556ba0f560c45b = /** @class */ function(_super) {
    $0fc456f1f32f8887$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($0fc456f1f32f8887$export$834a616d1cf278b);
var $0fc456f1f32f8887$export$df09a35db160df98 = /** @class */ function(_super) {
    $0fc456f1f32f8887$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($0fc456f1f32f8887$export$834a616d1cf278b);
var $0fc456f1f32f8887$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $0fc456f1f32f8887$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($0fc456f1f32f8887$export$834a616d1cf278b);
var $0fc456f1f32f8887$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $0fc456f1f32f8887$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($0fc456f1f32f8887$export$834a616d1cf278b);
var $0fc456f1f32f8887$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $0fc456f1f32f8887$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $0fc456f1f32f8887$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($0fc456f1f32f8887$export$a5a3e7829c289482);
var $0fc456f1f32f8887$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $0fc456f1f32f8887$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($0fc456f1f32f8887$export$a5a3e7829c289482);
var $0fc456f1f32f8887$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $0fc456f1f32f8887$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($0fc456f1f32f8887$export$a5a3e7829c289482);
var $0fc456f1f32f8887$export$65e277d35235a01f = new $0fc456f1f32f8887$export$c23c6f85dd4fc1e9();
var $0fc456f1f32f8887$export$e6d19fe5233efc54 = new $0fc456f1f32f8887$export$b556ba0f560c45b();
var $0fc456f1f32f8887$export$dd01300aacbcec1c = new $0fc456f1f32f8887$export$b7f4a3c7ea16c24();
var $0fc456f1f32f8887$export$689c32a6a552e1a6 = new $0fc456f1f32f8887$export$ef064c3e0426c607();
var $0fc456f1f32f8887$export$2f189cd99d2b7429 = new $0fc456f1f32f8887$export$df09a35db160df98();
var $0fc456f1f32f8887$export$163422b94c3edbcb = new $0fc456f1f32f8887$export$7a7e4b169d5c93a8();
var $0fc456f1f32f8887$export$ea67e3c6ff624776 = new $0fc456f1f32f8887$export$6990a2f90809ffc1();
var $0fc456f1f32f8887$export$5b8be9ab17b673b3 = new $0fc456f1f32f8887$export$3ec3555bc6f693a4();
function $0fc456f1f32f8887$export$bc3a498ccbb5c2b5() {
    return $0fc456f1f32f8887$export$65e277d35235a01f;
}

});




parcelRegister("knuXW", function(module, exports) {
$parcel$export(module.exports, "propagation", () => $ed5df9cac0e807f1$export$3e49040daa9dba20);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $glYH6 = parcelRequire("glYH6");
var $ed5df9cac0e807f1$export$3e49040daa9dba20 = (0, $glYH6.PropagationAPI).getInstance();

});
parcelRegister("glYH6", function(module, exports) {
$parcel$export(module.exports, "PropagationAPI", () => $be7db01bf264c575$export$471eda0a6213cac9);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5UVOI = parcelRequire("5UVOI");

var $2Nb9V = parcelRequire("2Nb9V");

var $e5qND = parcelRequire("e5qND");

var $32oyC = parcelRequire("32oyC");

var $fD3ja = parcelRequire("fD3ja");

var $55rm7 = parcelRequire("55rm7");
var $be7db01bf264c575$var$API_NAME = 'propagation';
var $be7db01bf264c575$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $2Nb9V.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $be7db01bf264c575$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $fD3ja.createBaggage);
        this.getBaggage = (0, $32oyC.getBaggage);
        this.getActiveBaggage = (0, $32oyC.getActiveBaggage);
        this.setBaggage = (0, $32oyC.setBaggage);
        this.deleteBaggage = (0, $32oyC.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $5UVOI.registerGlobal)($be7db01bf264c575$var$API_NAME, propagator, (0, $55rm7.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $e5qND.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $e5qND.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $5UVOI.unregisterGlobal)($be7db01bf264c575$var$API_NAME, (0, $55rm7.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $5UVOI.getGlobal)($be7db01bf264c575$var$API_NAME) || $be7db01bf264c575$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

});
parcelRegister("2Nb9V", function(module, exports) {
$parcel$export(module.exports, "NoopTextMapPropagator", () => $2088d057d1195ac3$export$8356c7eb3af7963b);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $2088d057d1195ac3$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

});

parcelRegister("e5qND", function(module, exports) {
$parcel$export(module.exports, "defaultTextMapGetter", () => $a41652292e4c0002$export$a0f575f55f38720a);
$parcel$export(module.exports, "defaultTextMapSetter", () => $a41652292e4c0002$export$f70f1d111fccf1c1);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a41652292e4c0002$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $a41652292e4c0002$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("32oyC", function(module, exports) {
$parcel$export(module.exports, "getBaggage", () => $23649b95a5a28df0$export$f3bffa0b5dd10d1e);
$parcel$export(module.exports, "getActiveBaggage", () => $23649b95a5a28df0$export$120a1756099436ee);
$parcel$export(module.exports, "setBaggage", () => $23649b95a5a28df0$export$adc9ca19eab3f500);
$parcel$export(module.exports, "deleteBaggage", () => $23649b95a5a28df0$export$4ca3a8a743c9f633);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $eP2dJ = parcelRequire("eP2dJ");

var $S8N63 = parcelRequire("S8N63");
/**
 * Baggage key
 */ var $23649b95a5a28df0$var$BAGGAGE_KEY = (0, $S8N63.createContextKey)('OpenTelemetry Baggage Key');
function $23649b95a5a28df0$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($23649b95a5a28df0$var$BAGGAGE_KEY) || undefined;
}
function $23649b95a5a28df0$export$120a1756099436ee() {
    return $23649b95a5a28df0$export$f3bffa0b5dd10d1e((0, $eP2dJ.ContextAPI).getInstance().active());
}
function $23649b95a5a28df0$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($23649b95a5a28df0$var$BAGGAGE_KEY, baggage);
}
function $23649b95a5a28df0$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($23649b95a5a28df0$var$BAGGAGE_KEY);
}

});

parcelRegister("fD3ja", function(module, exports) {
$parcel$export(module.exports, "createBaggage", () => $b60d107a7795c5cf$export$1034a425c7384452);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $55rm7 = parcelRequire("55rm7");

var $ca22o = parcelRequire("ca22o");

var $8Ywob = parcelRequire("8Ywob");
var $b60d107a7795c5cf$var$diag = (0, $55rm7.DiagAPI).instance();
function $b60d107a7795c5cf$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $ca22o.BaggageImpl)(new Map(Object.entries(entries)));
}
function $b60d107a7795c5cf$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $b60d107a7795c5cf$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $8Ywob.baggageEntryMetadataSymbol),
        toString: function() {
            return str;
        }
    };
}

});
parcelRegister("ca22o", function(module, exports) {
$parcel$export(module.exports, "BaggageImpl", () => $8da7ffd3a0e09d29$export$b8c511fa1a5f4987);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8da7ffd3a0e09d29$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8da7ffd3a0e09d29$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $8da7ffd3a0e09d29$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $8da7ffd3a0e09d29$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $8da7ffd3a0e09d29$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

});

parcelRegister("8Ywob", function(module, exports) {
$parcel$export(module.exports, "baggageEntryMetadataSymbol", () => $688d0d22278b3624$export$92dd2fe8ddb5cb7);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $688d0d22278b3624$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});




parcelRegister("6PhAz", function(module, exports) {
$parcel$export(module.exports, "trace", () => $4f8526491c3ddc30$export$357889f174732d38);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $a5Kp5 = parcelRequire("a5Kp5");
var $4f8526491c3ddc30$export$357889f174732d38 = (0, $a5Kp5.TraceAPI).getInstance();

});
parcelRegister("a5Kp5", function(module, exports) {
$parcel$export(module.exports, "TraceAPI", () => $758e5dd4bc7c1fe9$export$2cccde6fcc7b568a);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5UVOI = parcelRequire("5UVOI");

var $3uILs = parcelRequire("3uILs");

var $A0F8w = parcelRequire("A0F8w");

var $dWQXQ = parcelRequire("dWQXQ");

var $55rm7 = parcelRequire("55rm7");
var $758e5dd4bc7c1fe9$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $758e5dd4bc7c1fe9$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $3uILs.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $A0F8w.wrapSpanContext);
        this.isSpanContextValid = (0, $A0F8w.isSpanContextValid);
        this.deleteSpan = (0, $dWQXQ.deleteSpan);
        this.getSpan = (0, $dWQXQ.getSpan);
        this.getActiveSpan = (0, $dWQXQ.getActiveSpan);
        this.getSpanContext = (0, $dWQXQ.getSpanContext);
        this.setSpan = (0, $dWQXQ.setSpan);
        this.setSpanContext = (0, $dWQXQ.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $5UVOI.registerGlobal)($758e5dd4bc7c1fe9$var$API_NAME, this._proxyTracerProvider, (0, $55rm7.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $5UVOI.getGlobal)($758e5dd4bc7c1fe9$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $5UVOI.unregisterGlobal)($758e5dd4bc7c1fe9$var$API_NAME, (0, $55rm7.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $3uILs.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

});
parcelRegister("3uILs", function(module, exports) {
$parcel$export(module.exports, "ProxyTracerProvider", () => $28b6e5b8214b6553$export$4137aabcb4254962);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4q7GT = parcelRequire("4q7GT");

var $fkPgs = parcelRequire("fkPgs");
var $28b6e5b8214b6553$var$NOOP_TRACER_PROVIDER = new (0, $fkPgs.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $28b6e5b8214b6553$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $4q7GT.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $28b6e5b8214b6553$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

});
parcelRegister("4q7GT", function(module, exports) {
$parcel$export(module.exports, "ProxyTracer", () => $337f8e5ca2c07f66$export$df2c38268c6bb6b3);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dzGRG = parcelRequire("dzGRG");
var $337f8e5ca2c07f66$var$NOOP_TRACER = new (0, $dzGRG.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $337f8e5ca2c07f66$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $337f8e5ca2c07f66$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

});
parcelRegister("dzGRG", function(module, exports) {
$parcel$export(module.exports, "NoopTracer", () => $9e1fcb4a23f8edc9$export$714c1036cabcd223);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $eP2dJ = parcelRequire("eP2dJ");

var $dWQXQ = parcelRequire("dWQXQ");

var $j6T2q = parcelRequire("j6T2q");

var $A0F8w = parcelRequire("A0F8w");
var $9e1fcb4a23f8edc9$var$contextApi = (0, $eP2dJ.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $9e1fcb4a23f8edc9$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $9e1fcb4a23f8edc9$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $j6T2q.NonRecordingSpan)();
        var parentFromContext = context && (0, $dWQXQ.getSpanContext)(context);
        if ($9e1fcb4a23f8edc9$var$isSpanContext(parentFromContext) && (0, $A0F8w.isSpanContextValid)(parentFromContext)) return new (0, $j6T2q.NonRecordingSpan)(parentFromContext);
        else return new (0, $j6T2q.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $9e1fcb4a23f8edc9$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $dWQXQ.setSpan)(parentContext, span);
        return $9e1fcb4a23f8edc9$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $9e1fcb4a23f8edc9$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("dWQXQ", function(module, exports) {
$parcel$export(module.exports, "getSpan", () => $a279c6bea7337e9a$export$246e04ba06066af1);
$parcel$export(module.exports, "getActiveSpan", () => $a279c6bea7337e9a$export$1be426a8e585c83e);
$parcel$export(module.exports, "setSpan", () => $a279c6bea7337e9a$export$8ab2f2e6ee8ed0a8);
$parcel$export(module.exports, "deleteSpan", () => $a279c6bea7337e9a$export$a6bbfe9a17f7941c);
$parcel$export(module.exports, "setSpanContext", () => $a279c6bea7337e9a$export$c90bf5428c14cdb1);
$parcel$export(module.exports, "getSpanContext", () => $a279c6bea7337e9a$export$1a635f8f0b912781);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $S8N63 = parcelRequire("S8N63");

var $j6T2q = parcelRequire("j6T2q");

var $eP2dJ = parcelRequire("eP2dJ");
/**
 * span key
 */ var $a279c6bea7337e9a$var$SPAN_KEY = (0, $S8N63.createContextKey)('OpenTelemetry Context Key SPAN');
function $a279c6bea7337e9a$export$246e04ba06066af1(context) {
    return context.getValue($a279c6bea7337e9a$var$SPAN_KEY) || undefined;
}
function $a279c6bea7337e9a$export$1be426a8e585c83e() {
    return $a279c6bea7337e9a$export$246e04ba06066af1((0, $eP2dJ.ContextAPI).getInstance().active());
}
function $a279c6bea7337e9a$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($a279c6bea7337e9a$var$SPAN_KEY, span);
}
function $a279c6bea7337e9a$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($a279c6bea7337e9a$var$SPAN_KEY);
}
function $a279c6bea7337e9a$export$c90bf5428c14cdb1(context, spanContext) {
    return $a279c6bea7337e9a$export$8ab2f2e6ee8ed0a8(context, new (0, $j6T2q.NonRecordingSpan)(spanContext));
}
function $a279c6bea7337e9a$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $a279c6bea7337e9a$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});
parcelRegister("j6T2q", function(module, exports) {
$parcel$export(module.exports, "NonRecordingSpan", () => $de994543e1e3b54a$export$972d28f7c6a8c6c7);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $7eOZf = parcelRequire("7eOZf");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $de994543e1e3b54a$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $7eOZf.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

});
parcelRegister("7eOZf", function(module, exports) {
$parcel$export(module.exports, "INVALID_SPANID", () => $5451642457378ca4$export$55cc39fb0d4bb4c0);
$parcel$export(module.exports, "INVALID_TRACEID", () => $5451642457378ca4$export$22be96e88d95e128);
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", () => $5451642457378ca4$export$8591e4c852b66703);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $7twEs = parcelRequire("7twEs");
var $5451642457378ca4$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $5451642457378ca4$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $5451642457378ca4$export$8591e4c852b66703 = {
    traceId: $5451642457378ca4$export$22be96e88d95e128,
    spanId: $5451642457378ca4$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $7twEs.TraceFlags).NONE
};

});
parcelRegister("7twEs", function(module, exports) {
$parcel$export(module.exports, "TraceFlags", () => $571491c6f4e30587$export$bf9049ad2b0883ff);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $571491c6f4e30587$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($571491c6f4e30587$export$bf9049ad2b0883ff || ($571491c6f4e30587$export$bf9049ad2b0883ff = {}));

});




parcelRegister("A0F8w", function(module, exports) {
$parcel$export(module.exports, "isSpanContextValid", () => $06c3e076d38e53af$export$e4373b9a2c09216c);
$parcel$export(module.exports, "wrapSpanContext", () => $06c3e076d38e53af$export$c19cc0f1911bdb85);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $7eOZf = parcelRequire("7eOZf");

var $j6T2q = parcelRequire("j6T2q");
var $06c3e076d38e53af$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $06c3e076d38e53af$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $06c3e076d38e53af$export$29dd34cf1269f6da(traceId) {
    return $06c3e076d38e53af$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $7eOZf.INVALID_TRACEID);
}
function $06c3e076d38e53af$export$8e51c6d8f0586aff(spanId) {
    return $06c3e076d38e53af$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $7eOZf.INVALID_SPANID);
}
function $06c3e076d38e53af$export$e4373b9a2c09216c(spanContext) {
    return $06c3e076d38e53af$export$29dd34cf1269f6da(spanContext.traceId) && $06c3e076d38e53af$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $06c3e076d38e53af$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $j6T2q.NonRecordingSpan)(spanContext);
}

});



parcelRegister("fkPgs", function(module, exports) {
$parcel$export(module.exports, "NoopTracerProvider", () => $b2a07d4f8f801b03$export$87d8e93756f9e86e);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dzGRG = parcelRequire("dzGRG");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $b2a07d4f8f801b03$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $dzGRG.NoopTracer)();
    };
    return NoopTracerProvider;
}();

});





parcelRegister("dBXpK", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e6ec38021dd127c$export$2e2bcd8739ae039);

var $kDPHl = parcelRequire("kDPHl");

var $fBMYg = parcelRequire("fBMYg");

var $b4QJt = parcelRequire("b4QJt");

var $f4OJN = parcelRequire("f4OJN");

var $hULEn = parcelRequire("hULEn");

var $cWu4D = parcelRequire("cWu4D");

var $giuYb = parcelRequire("giuYb");

var $8U1ie = parcelRequire("8U1ie");

var $d7z1e = parcelRequire("d7z1e");

var $7UFOP = parcelRequire("7UFOP");

var $73oS7 = parcelRequire("73oS7");

var $6trHC = parcelRequire("6trHC");

var $geknN = parcelRequire("geknN");

var $1khbe = parcelRequire("1khbe");

var $cgqme = parcelRequire("cgqme");

var $3hIGA = parcelRequire("3hIGA");

var $6413a = parcelRequire("6413a");

var $lXZCR = parcelRequire("lXZCR");

var $fZmq3 = parcelRequire("fZmq3");

var $amSXO = parcelRequire("amSXO");

var $62IYf = parcelRequire("62IYf");

var $d4fyI = parcelRequire("d4fyI");

var $6zAAP = parcelRequire("6zAAP");

var $3N69E = parcelRequire("3N69E");

var $efrw7 = parcelRequire("efrw7");
const $2e6ec38021dd127c$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $2e6ec38021dd127c$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $2e6ec38021dd127c$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $2e6ec38021dd127c$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $f4OJN.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $f4OJN.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($2e6ec38021dd127c$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch  {
                this._safeSessionStorage.removeItem($2e6ec38021dd127c$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($2e6ec38021dd127c$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $fBMYg.eventType).UI:
                case (0, $fBMYg.eventType).OPERATIONAL:
                case (0, $fBMYg.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $fBMYg.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $fBMYg.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
    * Calling this function in the intialisation of the client in product
    * captures specified 'origin tracing' URL params and fires a single origin landed event
    * <p>
    * This function expects a mapping between the keys for any URL parameters
    *  that should be captured and removed for origin tracing
    * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
    * Each handler function should return an object with two items
    * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
    * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
    *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
    * </p>
    * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
    * e.g. from a share or email
    *
    * An example calling this function using an external decoding library, with taskSessionId specified to persist
    * analyticsWebClient.setOriginTracingHandlers({
         atlOrigin: encodedOrigin => {
             const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
             return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
         },
     });
    *
    * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
    * @this {AnalyticsWebClient}
    */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            const keys = Object.keys(capturedOriginTraces);
            keys.forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            keys.forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (keys.length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $fBMYg.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $fBMYg.isType)((0, $fBMYg.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $fBMYg.objectValues)((0, $fBMYg.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setCollaborationContextInfo = (collaborationContextAri)=>{
            if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
            this._collaborationContextInfo = {
                collaborationContextAri: collaborationContextAri
            };
        };
        this.clearCollaborationContextInfo = ()=>{
            this._collaborationContextInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $d7z1e.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $fBMYg.isType)((0, $fBMYg.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $fBMYg.objectValues)((0, $fBMYg.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $fBMYg.isType)((0, $fBMYg.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $fBMYg.objectValues)((0, $fBMYg.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $fBMYg.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
   * @deprecated
   * please use {@link sendScreenEvent instead)
   */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
   * send screen event
   * @param event The event / For retrocompatibility event name is still supported here.
   * @param callback
   * @param attributes. Deprecated, will get ignored if using an event object as first param.
   */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $d7z1e.validateScreenEvent)(screenName);
            (0, $d7z1e.validateContainers)(screenContainers);
            const builtEvent = (0, $giuYb.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $3N69E.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $d7z1e.validateTrackEvent)(event);
            const builtEvent = (0, $giuYb.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $fBMYg.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $giuYb.buildActionName)(event), builtEvent, this._context, (0, $3N69E.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $d7z1e.validateUIEvent)(event);
            const builtEvent = (0, $giuYb.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $fBMYg.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $giuYb.buildActionName)(event), builtEvent, this._context, (0, $3N69E.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $d7z1e.validateOperationalEvent)(event);
            const builtEvent = (0, $giuYb.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $fBMYg.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $giuYb.buildActionName)(event), builtEvent, this._context, (0, $3N69E.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.signalUserActive = ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        };
        this.createUIViewedEvent = (callback)=>{
            return new (0, $amSXO.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $fBMYg.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $fBMYg.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $fBMYg.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $fBMYg.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $fBMYg.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $fBMYg.objectValues)((0, $fBMYg.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $fBMYg.isType)((0, $fBMYg.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $fBMYg.objectValues)((0, $fBMYg.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $fBMYg.originType).WEB;
        else if (!(0, $fBMYg.isType)((0, $fBMYg.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $fBMYg.objectValues)((0, $fBMYg.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $fBMYg.originType).WEB ? (0, $fBMYg.platformType).WEB : (0, $fBMYg.platformType).DESKTOP;
        else (0, $d7z1e.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $kDPHl.isFedrampModerate)()) productInfo.perimeter = (0, $fBMYg.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $fBMYg.perimeterType).COMMERCIAL;
        if (!(0, $fBMYg.isType)((0, $fBMYg.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $fBMYg.objectValues)((0, $fBMYg.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $kDPHl.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo?.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $cWu4D.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $cWu4D.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $giuYb.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $3hIGA.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $1khbe.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $efrw7.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $73oS7.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $7UFOP.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $2e6ec38021dd127c$export$48361b6ed38f1b0.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $geknN.default)();
        this._tabTracking = new (0, $6413a.default)();
        this._sessionTracking = new (0, $cgqme.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $lXZCR.default)();
        this._originTracing = new (0, $6trHC.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $b4QJt.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $62IYf.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $8U1ie.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $fZmq3.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $6zAAP.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $hULEn.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $d4fyI.TestSupport).isGeminiVREnvironment() && !(0, $d4fyI.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $d4fyI.TestSupport).isGeminiVREnvironment() && !(0, $d4fyI.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("fBMYg", function(module, exports) {
$parcel$export(module.exports, "envType", () => $10c6aa777c9794f5$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $10c6aa777c9794f5$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $10c6aa777c9794f5$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $10c6aa777c9794f5$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $10c6aa777c9794f5$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $10c6aa777c9794f5$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $10c6aa777c9794f5$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $10c6aa777c9794f5$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $10c6aa777c9794f5$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $10c6aa777c9794f5$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $10c6aa777c9794f5$export$62a500c02dc63ee);
$parcel$export(module.exports, "objectValues", () => $10c6aa777c9794f5$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "isType", () => $10c6aa777c9794f5$export$26b9f946b448f23e);
$parcel$export(module.exports, "perimeterType", () => $10c6aa777c9794f5$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $10c6aa777c9794f5$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $10c6aa777c9794f5$export$e73680b18d9b7c6e);
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $10c6aa777c9794f5$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $10c6aa777c9794f5$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $10c6aa777c9794f5$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $10c6aa777c9794f5$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $10c6aa777c9794f5$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $10c6aa777c9794f5$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $10c6aa777c9794f5$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $10c6aa777c9794f5$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $10c6aa777c9794f5$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $10c6aa777c9794f5$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $10c6aa777c9794f5$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $10c6aa777c9794f5$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $10c6aa777c9794f5$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $10c6aa777c9794f5$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $10c6aa777c9794f5$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $10c6aa777c9794f5$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $10c6aa777c9794f5$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("b4QJt", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fe626b360e77f5d$export$2e2bcd8739ae039);

var $fBMYg = parcelRequire("fBMYg");

var $geknN = parcelRequire("geknN");

var $dgpmj = parcelRequire("dgpmj");
class $6fe626b360e77f5d$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $fBMYg.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
     * For initialLoad type:
     * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
     *
     * For transition type:
     * 1. active status is tracked in active events map (_isActiveEvents)
     *
     * For any type, if startTime or stopTime is specified:
     * 1. If currently active (!_isHidden)
     */ if (event.type === (0, $fBMYg.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $fBMYg.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $fBMYg.isType)((0, $fBMYg.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
     * For a transition, if the startTime was not specified,
     * the start event should have been present.
     */ if (!event.startTime && event.type === (0, $fBMYg.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $geknN.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $dgpmj.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("geknN", function(module, exports) {
$parcel$export(module.exports, "default", () => $c91f63c164194358$export$2e2bcd8739ae039);
class $c91f63c164194358$export$2e2bcd8739ae039 {
    constructor(){
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("dgpmj", function(module, exports) {
$parcel$export(module.exports, "default", () => $38de88948a7e03da$export$2e2bcd8739ae039);
class $38de88948a7e03da$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("f4OJN", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ebbb23f83fdce45$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $0ebbb23f83fdce45$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $0ebbb23f83fdce45$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($0ebbb23f83fdce45$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("hULEn", function(module, exports) {
$parcel$export(module.exports, "default", () => $36324d87e6315026$export$2e2bcd8739ae039);

var $l5btC = parcelRequire("l5btC");
var $et0fg = parcelRequire("et0fg");
var $3QDmS = parcelRequire("3QDmS");

var $fBMYg = parcelRequire("fBMYg");

var $62IYf = parcelRequire("62IYf");
const $36324d87e6315026$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $et0fg.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $36324d87e6315026$export$2e2bcd8739ae039 {
    constructor(options){
        this.validProduct = false;
        this.isEnabled = options.perimeter !== (0, $fBMYg.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $3QDmS.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $62IYf.default)($36324d87e6315026$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $et0fg.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $et0fg.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $l5btC.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("l5btC", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b6cc1bc0e1f4646$export$2e2bcd8739ae039);

var $cn7A7 = parcelRequire("cn7A7");

var $kDPHl = parcelRequire("kDPHl");

var $3X3Vo = parcelRequire("3X3Vo");

var $dMK3L = parcelRequire("dMK3L");

var $7ZKus = parcelRequire("7ZKus");
const $0b6cc1bc0e1f4646$export$b9dd752fb13352ce = 'interactionSession.source';
const $0b6cc1bc0e1f4646$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $0b6cc1bc0e1f4646$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($0b6cc1bc0e1f4646$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($0b6cc1bc0e1f4646$export$b9dd752fb13352ce) : null;
        const shouldDisable = (0, $3X3Vo.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $cn7A7.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $kDPHl.isFedrampModerate)();
        this.isEnabled = !shouldDisable;
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $dMK3L.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $7ZKus.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($0b6cc1bc0e1f4646$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($0b6cc1bc0e1f4646$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}

});
parcelRegister("dMK3L", function(module, exports) {
$parcel$export(module.exports, "default", () => $e52f827f85172273$export$2e2bcd8739ae039);

var $bIAtc = parcelRequire("bIAtc");
const $e52f827f85172273$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $e52f827f85172273$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($e52f827f85172273$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$e52f827f85172273$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$e52f827f85172273$export$7bc189309d2ad463] = new (0, $bIAtc.default)();
                interactionSessionTracking = window[$e52f827f85172273$export$7bc189309d2ad463];
            }
        } catch (error) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("bIAtc", function(module, exports) {
$parcel$export(module.exports, "INTERACTION_SESSION_ID_UPDATED_EVENT", () => $006a41db2c12ecbb$export$5d4c4eab0863aae3);
$parcel$export(module.exports, "default", () => $006a41db2c12ecbb$export$2e2bcd8739ae039);

var $7ZKus = parcelRequire("7ZKus");
const $006a41db2c12ecbb$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $006a41db2c12ecbb$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $006a41db2c12ecbb$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $006a41db2c12ecbb$export$285f6bddd927a06d = 1800000; // 30 minutes
const $006a41db2c12ecbb$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $006a41db2c12ecbb$export$a92e915d70316eb2 = 5000; // 5 seconds
const $006a41db2c12ecbb$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $006a41db2c12ecbb$var$INTEGER_REGEX = /^\d+$/;
const $006a41db2c12ecbb$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $006a41db2c12ecbb$export$2e2bcd8739ae039 {
    constructor(){
        this.analyticsReady = false;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($006a41db2c12ecbb$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($006a41db2c12ecbb$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            const { isValidSession: isValidSession } = this.getCurrentSessionParams();
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($006a41db2c12ecbb$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($006a41db2c12ecbb$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($006a41db2c12ecbb$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $006a41db2c12ecbb$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $006a41db2c12ecbb$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $006a41db2c12ecbb$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $7ZKus.default)();
    }
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
        // Silently swallow exception
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($006a41db2c12ecbb$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($006a41db2c12ecbb$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($006a41db2c12ecbb$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($006a41db2c12ecbb$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($006a41db2c12ecbb$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $006a41db2c12ecbb$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $006a41db2c12ecbb$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem($006a41db2c12ecbb$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($006a41db2c12ecbb$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
   * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
   *
   * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
   * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
   *
   * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
   */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("7ZKus", function(module, exports) {
$parcel$export(module.exports, "default", () => $96469e26e07f869b$export$2e2bcd8739ae039);

var $2BDMW = parcelRequire("2BDMW");

var $c3iDr = parcelRequire("c3iDr");
class $96469e26e07f869b$export$2e2bcd8739ae039 extends (0, $c3iDr.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $2BDMW.default);
        } catch (err) {
            storageToUse = (0, $2BDMW.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("2BDMW", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a2bb8d1d3b5b999$export$2e2bcd8739ae039);
class $4a2bb8d1d3b5b999$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $4a2bb8d1d3b5b999$var$inmemorystorage = new $4a2bb8d1d3b5b999$export$90e3e001bcac59c7();
var $4a2bb8d1d3b5b999$export$2e2bcd8739ae039 = $4a2bb8d1d3b5b999$var$inmemorystorage;

});

parcelRegister("c3iDr", function(module, exports) {
$parcel$export(module.exports, "default", () => $194afa00f951a402$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $2BDMW = parcelRequire("2BDMW");
const $194afa00f951a402$export$41c06fdd37b7e9a5 = 'awc';
const $194afa00f951a402$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
var $194afa00f951a402$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});
function $194afa00f951a402$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $194afa00f951a402$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this.store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $2BDMW.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ($194afa00f951a402$export$48c17662a6902497(window[$194afa00f951a402$export$770aa8bc07b3de03])) inMemoryStorage = window[$194afa00f951a402$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $2BDMW.default);
                if (!window[$194afa00f951a402$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$194afa00f951a402$export$770aa8bc07b3de03] = (0, $2BDMW.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($194afa00f951a402$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== "prod") prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ($194afa00f951a402$export$48c17662a6902497(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

});





parcelRegister("et0fg", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $454df57bc2855f1d$export$81d16f1428ce0486);
$parcel$export(module.exports, "generateUrlWithParams", () => $454df57bc2855f1d$export$2e3999ec51334ffe);
const $454df57bc2855f1d$export$81d16f1428ce0486 = 'xpis';
const $454df57bc2855f1d$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($454df57bc2855f1d$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("3QDmS", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $a3e4cc431d3eb25e$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $a3e4cc431d3eb25e$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom'
];

});

parcelRegister("62IYf", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $9a511a705458cf0f$export$600dd5bf1b049f11);
$parcel$export(module.exports, "default", () => $9a511a705458cf0f$export$2e2bcd8739ae039);

var $42rJW = parcelRequire("42rJW");

var $hLVFP = parcelRequire("hLVFP");
const $9a511a705458cf0f$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $9a511a705458cf0f$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $9a511a705458cf0f$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $42rJW.parseUrl)(removedFragmentURL);
    const captureParams = (0, $hLVFP.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $hLVFP.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $42rJW.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $9a511a705458cf0f$export$2e2bcd8739ae039 = $9a511a705458cf0f$var$urlParamExtractor;

});
parcelRegister("hLVFP", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $3dd9fd83372a2eca$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $3dd9fd83372a2eca$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $3dd9fd83372a2eca$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $3dd9fd83372a2eca$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $3dd9fd83372a2eca$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $3dd9fd83372a2eca$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $3dd9fd83372a2eca$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $3dd9fd83372a2eca$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $3dd9fd83372a2eca$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $3dd9fd83372a2eca$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $3dd9fd83372a2eca$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $3dd9fd83372a2eca$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $3dd9fd83372a2eca$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$3dd9fd83372a2eca$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $3dd9fd83372a2eca$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("cWu4D", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $974d024b653ee095$export$f56713ced121eb91);
$parcel$export(module.exports, "isThirdParty", () => $974d024b653ee095$export$ab34f90cc32c8960);

var $fBMYg = parcelRequire("fBMYg");
const $974d024b653ee095$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $fBMYg.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $974d024b653ee095$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $fBMYg.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("giuYb", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $5b71e6ddc3091e2c$export$655ecf7241feac42);
$parcel$export(module.exports, "buildScreenEvent", () => $5b71e6ddc3091e2c$export$c7d9a5f56acc4b19);
$parcel$export(module.exports, "buildActionName", () => $5b71e6ddc3091e2c$export$9c5623a792efc9b0);
$parcel$export(module.exports, "buildContext", () => $5b71e6ddc3091e2c$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "buildActionEvent", () => $5b71e6ddc3091e2c$export$7bf451af4a8e3dd9);

var $fBMYg = parcelRequire("fBMYg");

var $29O58 = parcelRequire("29O58");
const $5b71e6ddc3091e2c$var$libraryVersion = undefined;
function $5b71e6ddc3091e2c$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $5b71e6ddc3091e2c$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $5b71e6ddc3091e2c$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $5b71e6ddc3091e2c$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $5b71e6ddc3091e2c$var$buildCollaborationContextFields(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}
function $5b71e6ddc3091e2c$var$buildAliases(aliases) {
    if ($5b71e6ddc3091e2c$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $5b71e6ddc3091e2c$var$buildGroups(groups) {
    if ($5b71e6ddc3091e2c$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $5b71e6ddc3091e2c$var$buildEventOverrides(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}
function $5b71e6ddc3091e2c$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $5b71e6ddc3091e2c$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $5b71e6ddc3091e2c$var$getProductField(productInfo.env, overrides.env);
    const product = $5b71e6ddc3091e2c$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $5b71e6ddc3091e2c$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $5b71e6ddc3091e2c$var$getProductField(productInfo.version, overrides.version);
    const origin = $5b71e6ddc3091e2c$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $5b71e6ddc3091e2c$var$getProductField(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    const cdp = productInfo.cdp;
    const csp = productInfo.csp;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}
function $5b71e6ddc3091e2c$var$isNotEmptyObject(obj) {
    return (0, $29O58.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $5b71e6ddc3091e2c$var$buildAttributesWithName(name, attrObject) {
    return $5b71e6ddc3091e2c$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $5b71e6ddc3091e2c$var$buildAttributes(attributes) {
    return $5b71e6ddc3091e2c$var$buildAttributesWithName('attributes', attributes);
}
function $5b71e6ddc3091e2c$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $5b71e6ddc3091e2c$export$f045f238d77c002a(containers) {
    if ($5b71e6ddc3091e2c$var$isNotEmptyObject(containers)) {
        const validContainers = $5b71e6ddc3091e2c$export$3f5115a568819c1a(containers);
        return $5b71e6ddc3091e2c$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $5b71e6ddc3091e2c$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...$5b71e6ddc3091e2c$export$f045f238d77c002a(event.containers)
    };
}
function $5b71e6ddc3091e2c$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $5b71e6ddc3091e2c$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $5b71e6ddc3091e2c$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    const productFields = $5b71e6ddc3091e2c$var$buildProductFields(productInfo);
    const tenantFields = $5b71e6ddc3091e2c$var$buildTenantFields(tenantInfo);
    const userFields = $5b71e6ddc3091e2c$var$buildUserFields(userInfo);
    const orgFields = $5b71e6ddc3091e2c$var$buildOrgFields(orgInfo);
    const workspaceFields = $5b71e6ddc3091e2c$var$buildWorkspaceFields(workspaceInfo);
    const collaborationContextFields = $5b71e6ddc3091e2c$var$buildCollaborationContextFields(collaborationContextInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $fBMYg.eventType).SCREEN
    };
    return {
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...overrides,
        ...$5b71e6ddc3091e2c$var$buildAttributes(attributes),
        ...$5b71e6ddc3091e2c$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...$5b71e6ddc3091e2c$export$f045f238d77c002a(containers),
        ...$5b71e6ddc3091e2c$var$buildEventOverrides(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...$5b71e6ddc3091e2c$var$buildAliases(aliases),
        ...$5b71e6ddc3091e2c$var$buildGroups(groups)
    };
}
function $5b71e6ddc3091e2c$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
var $5b71e6ddc3091e2c$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $5b71e6ddc3091e2c$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function $5b71e6ddc3091e2c$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $5b71e6ddc3091e2c$var$libraryVersion
            },
            validationMode: $5b71e6ddc3091e2c$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $5b71e6ddc3091e2c$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $5b71e6ddc3091e2c$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    const productFields = $5b71e6ddc3091e2c$var$buildProductFields(productInfo, $5b71e6ddc3091e2c$export$e3d99b4bfec06f6e(event));
    const tenantFields = $5b71e6ddc3091e2c$var$buildTenantFields(tenantInfo);
    const orgFields = $5b71e6ddc3091e2c$var$buildOrgFields(orgInfo);
    const workspaceFields = $5b71e6ddc3091e2c$var$buildWorkspaceFields(workspaceInfo);
    const collaborationContextFields = $5b71e6ddc3091e2c$var$buildCollaborationContextFields(collaborationContextInfo);
    const userFields = $5b71e6ddc3091e2c$var$buildUserFields(userInfo);
    const actionFields = $5b71e6ddc3091e2c$export$655ecf7241feac42(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...$5b71e6ddc3091e2c$var$buildEventOverrides(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...$5b71e6ddc3091e2c$var$buildAliases(aliases),
        ...$5b71e6ddc3091e2c$var$buildGroups(groups)
    };
}

});
parcelRegister("29O58", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $7a4fd32a7a395e0e$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $7a4fd32a7a395e0e$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $7a4fd32a7a395e0e$var$isObjectObject(o) {
    return $7a4fd32a7a395e0e$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $7a4fd32a7a395e0e$export$53b83ca8eaab0383(o) {
    if ($7a4fd32a7a395e0e$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($7a4fd32a7a395e0e$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("8U1ie", function(module, exports) {
$parcel$export(module.exports, "default", () => $405ccefa32b3d051$export$2e2bcd8739ae039);

var $fr37h = parcelRequire("fr37h");

var $cxlgZ = parcelRequire("cxlgZ");

var $fCsR9 = parcelRequire("fCsR9");
class $405ccefa32b3d051$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $fr37h.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $fr37h.MAX_DELAY_TIMEOUT)) : (0, $fr37h.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $fCsR9.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $fCsR9.StopLowPriorityEventDelayReason).MANUAL)=>{
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            this.delayCallback?.(reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $cxlgZ.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("fr37h", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $293b736cd0caf4bb$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $293b736cd0caf4bb$export$8575e30be0feb909);
const $293b736cd0caf4bb$export$cf090d5281b5ae06 = 10000;
const $293b736cd0caf4bb$export$8575e30be0feb909 = 30000;

});

parcelRegister("cxlgZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c070d54ff88a5c6$export$2e2bcd8739ae039);

var $giuYb = parcelRequire("giuYb");

var $hLVFP = parcelRequire("hLVFP");

var $apEmh = parcelRequire("apEmh");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $0c070d54ff88a5c6$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $0c070d54ff88a5c6$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $0c070d54ff88a5c6$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $0c070d54ff88a5c6$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $0c070d54ff88a5c6$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $hLVFP.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $hLVFP.equals)(group.userInfo, args.userInfo) && (0, $hLVFP.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $giuYb.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $apEmh.default)(compressionRules);
    }
}

});
parcelRegister("apEmh", function(module, exports) {
$parcel$export(module.exports, "default", () => $62aaf97d25389c87$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $giuYb = parcelRequire("giuYb");

var $hLVFP = parcelRequire("hLVFP");

var $4f4Xi = parcelRequire("4f4Xi");
class $62aaf97d25389c87$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $giuYb.buildActionFields)(event, event.eventType);
                    contextFields = (0, $hLVFP.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $hLVFP.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $4f4Xi.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("4f4Xi", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $1b896f37892a0ac3$export$89b3253ddfd2e6e8);

var $d7z1e = parcelRequire("d7z1e");

var $hLVFP = parcelRequire("hLVFP");
class $1b896f37892a0ac3$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
   * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
   * @param event
   * @returns {boolean}
   */ this.canCompress = (event)=>{
            try {
                return event && (0, $d7z1e.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
   * This function compresses as many events in the given collection as possible.<p>
   * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
   * appended to the end of the resulting array.
   *
   * @param events A collection of analytic events to compress
   * @returns {Array.<Object>} The action fields for the resulting compressed events
   */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $hLVFP.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $d7z1e.validateActionEventType)(event.eventType);
                (0, $d7z1e.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("d7z1e", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $43151de753e38418$export$e63ea5d8477971d3);
$parcel$export(module.exports, "isActionEventType", () => $43151de753e38418$export$d19cebda16f7579a);
$parcel$export(module.exports, "validateActionEventType", () => $43151de753e38418$export$4a8d7476662aebcc);
$parcel$export(module.exports, "validateActionEvent", () => $43151de753e38418$export$e0c121325c66ed4c);
$parcel$export(module.exports, "validateScreenEvent", () => $43151de753e38418$export$dc993432a592dc27);
$parcel$export(module.exports, "validateTrackEvent", () => $43151de753e38418$export$8c014fd74b0c8b99);
$parcel$export(module.exports, "validateUIEvent", () => $43151de753e38418$export$e5bac0930c812e90);
$parcel$export(module.exports, "validateOperationalEvent", () => $43151de753e38418$export$1e561554275607ef);
$parcel$export(module.exports, "validateIdentifyEvent", () => $43151de753e38418$export$c16a4e16aa4026c0);
$parcel$export(module.exports, "validatePlatform", () => $43151de753e38418$export$801b46c35394d316);

var $fBMYg = parcelRequire("fBMYg");

var $29O58 = parcelRequire("29O58");
const $43151de753e38418$var$actionEventTypes = Object.freeze([
    (0, $fBMYg.eventType).OPERATIONAL,
    (0, $fBMYg.eventType).TRACK,
    (0, $fBMYg.eventType).UI
]);
function $43151de753e38418$export$df8ff30e3c960006(container) {
    if (!(0, $29O58.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $43151de753e38418$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$43151de753e38418$export$df8ff30e3c960006(container));
}
function $43151de753e38418$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $fBMYg.eventType).OPERATIONAL:
        case (0, $fBMYg.eventType).TRACK:
        case (0, $fBMYg.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $43151de753e38418$export$4a8d7476662aebcc(type) {
    if (!$43151de753e38418$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$43151de753e38418$var$actionEventTypes}]`);
    return true;
}
function $43151de753e38418$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $43151de753e38418$export$e63ea5d8477971d3(event.containers);
}
function $43151de753e38418$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $43151de753e38418$export$8c014fd74b0c8b99(event) {
    $43151de753e38418$export$e0c121325c66ed4c(event);
}
function $43151de753e38418$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $43151de753e38418$export$e5bac0930c812e90(event) {
    $43151de753e38418$export$e0c121325c66ed4c(event);
}
function $43151de753e38418$export$1e561554275607ef(event) {
    $43151de753e38418$export$e0c121325c66ed4c(event);
}
function $43151de753e38418$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $fBMYg.isType)((0, $fBMYg.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $fBMYg.objectValues)((0, $fBMYg.userType))}]`);
}
function $43151de753e38418$export$801b46c35394d316(productInfo) {
    if (!(0, $fBMYg.isType)((0, $fBMYg.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $fBMYg.objectValues)((0, $fBMYg.platformType))}]`);
    if (productInfo.origin === (0, $fBMYg.originType).DESKTOP && !(0, $fBMYg.isType)((0, $fBMYg.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $fBMYg.originType).WEB && !(0, $fBMYg.isType)((0, $fBMYg.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("fCsR9", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $ad3d143691a373c9$export$fa6e3729c21cb8f);
var $ad3d143691a373c9$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("7UFOP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f75535ad4098d837$export$2e2bcd8739ae039);

var $dd6wx = parcelRequire("dd6wx");

var $67HYK = parcelRequire("67HYK");

var $6zAAP = parcelRequire("6zAAP");

var $7TOaN = parcelRequire("7TOaN");

var $77neH = parcelRequire("77neH");

var $fMtGC = parcelRequire("fMtGC");

var $iJiFZ = parcelRequire("iJiFZ");

var $a8bF2 = parcelRequire("a8bF2");

var $bF2Yo = parcelRequire("bF2Yo");

var $cF8l4 = parcelRequire("cF8l4");
class $f75535ad4098d837$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $f75535ad4098d837$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $f75535ad4098d837$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $f75535ad4098d837$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $f75535ad4098d837$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $f75535ad4098d837$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $f75535ad4098d837$export$2e2bcd8739ae039 {
    constructor(options){
        this.originTracingClient = null;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: this.lastSendEventsError?.message || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: metadataInfo?.props || null,
                metadataClientMetrics: this.metadataClient?.metrics || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $iJiFZ.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                this.originTracingClient?.cleanupOriginParameters(items);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $a8bF2.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $a8bF2.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $a8bF2.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $a8bF2.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $77neH.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $bF2Yo.default)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $67HYK.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $dd6wx.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $a8bF2.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $a8bF2.SegmentEventTypes).TRACK,
            properties: (0, $cF8l4.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $a8bF2.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $a8bF2.SegmentEventTypes).PAGE,
            properties: (0, $cF8l4.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $a8bF2.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $a8bF2.SegmentEventTypes).IDENTIFY,
            traits: (0, $cF8l4.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $cF8l4.prepareEventContext)(context);
        const segmentContext = (0, $cF8l4.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $6zAAP.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = msg.context?.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo?.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch  {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $f75535ad4098d837$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $f75535ad4098d837$var$Message(responseObject.message?.error || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $f75535ad4098d837$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $7TOaN.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $f75535ad4098d837$var$BatchInterceptor {
    static{
        this.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;
    }
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $f75535ad4098d837$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $f75535ad4098d837$export$133650fcdde1b226(success, statusCode, (0, $fMtGC.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $fMtGC.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $fMtGC.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $fMtGC.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $f75535ad4098d837$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $f75535ad4098d837$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error?.message) {
            const match = error.message.match($f75535ad4098d837$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $f75535ad4098d837$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $f75535ad4098d837$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $f75535ad4098d837$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $f75535ad4098d837$export$133650fcdde1b226(false, -1, (0, $fMtGC.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}

});
parcelRegister("dd6wx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8dfa2fc15a4be50$export$2e2bcd8739ae039);

var $1Yf20 = parcelRequire("1Yf20");

var $c8dfa2fc15a4be50$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $1Yf20.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("1Yf20", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $d323dbac4aa01018$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $d323dbac4aa01018$export$2e2bcd8739ae039);

var $3P2un = parcelRequire("3P2un");
var $8sfXM = parcelRequire("8sfXM");

var $aNK4N = parcelRequire("aNK4N");
var $girQD = parcelRequire("girQD");
var $bbWOC = parcelRequire("bbWOC");

var $67HYK = parcelRequire("67HYK");

var $lH3a9 = parcelRequire("lH3a9");

var $jauoR = parcelRequire("jauoR");
var $hOroi = parcelRequire("hOroi");

var $gjBjm = parcelRequire("gjBjm");
const $d323dbac4aa01018$var$ONE_MINUTE = 60000;
const $d323dbac4aa01018$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $d323dbac4aa01018$var$ONE_MINUTE,
    minRetryDelay: $d323dbac4aa01018$var$ONE_MINUTE,
    maxRetryDelay: $d323dbac4aa01018$var$ONE_MINUTE
};
const $d323dbac4aa01018$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $d323dbac4aa01018$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $girQD.default)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxQueueSize || $d323dbac4aa01018$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $jauoR.default)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $jauoR.default)({
            ...$d323dbac4aa01018$var$LONG_POLLING_OPTIONS,
            waitInterval: $d323dbac4aa01018$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $67HYK.default)();
        this.networkStatus = new (0, $lH3a9.default)((status)=>{
            if (status === (0, $gjBjm.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $bbWOC.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $gjBjm.NetworkStatusEnum).OFFLINE) {
            done((0, $hOroi.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $aNK4N.CallbackProcessingErrorName)) {
                done((0, $hOroi.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $3P2un.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $8sfXM.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $bbWOC.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $hOroi.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $hOroi.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $hOroi.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $d323dbac4aa01018$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $d323dbac4aa01018$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $d323dbac4aa01018$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $d323dbac4aa01018$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $d323dbac4aa01018$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: options?.maxQueueSize || $d323dbac4aa01018$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: options?.maxAttempts || $d323dbac4aa01018$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $d323dbac4aa01018$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $d323dbac4aa01018$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("3P2un", function(module, exports) {
$parcel$export(module.exports, "default", () => $0602d00cfb0649e4$export$2e2bcd8739ae039);

var $2MvtK = parcelRequire("2MvtK");

var $9Ldsy = parcelRequire("9Ldsy");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $0602d00cfb0649e4$var$validSuffixs = Object.values((0, $2MvtK.LocalStorageKeySuffix));
var $0602d00cfb0649e4$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $0602d00cfb0649e4$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $2MvtK.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $9Ldsy.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("2MvtK", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $65318fadd72f3575$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $65318fadd72f3575$export$8bb2c1fb2b1765a9);
var $65318fadd72f3575$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $65318fadd72f3575$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("9Ldsy", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $5b475769a68781ff$export$8433d54f767cbec5);

var $2MvtK = parcelRequire("2MvtK");
const $5b475769a68781ff$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $2MvtK.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $2MvtK.LocalStorageKeySuffix).ACK}`,
        [(0, $2MvtK.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $2MvtK.LocalStorageKeySuffix).QUEUE}`,
        [(0, $2MvtK.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $2MvtK.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $2MvtK.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $2MvtK.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $2MvtK.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $2MvtK.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("8sfXM", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcdb71982a52f504$export$2e2bcd8739ae039);

var $6zAAP = parcelRequire("6zAAP");

var $2MvtK = parcelRequire("2MvtK");

var $9Ldsy = parcelRequire("9Ldsy");
const $dcdb71982a52f504$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $dcdb71982a52f504$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $2MvtK.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $2MvtK.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch  {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch  {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $dcdb71982a52f504$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $dcdb71982a52f504$var$promisedSetTimeout((0, $2MvtK.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $2MvtK.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $dcdb71982a52f504$var$promisedSetTimeout((0, $2MvtK.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $2MvtK.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $dcdb71982a52f504$var$reclaim(options, callback);
};
const $dcdb71982a52f504$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $dcdb71982a52f504$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $dcdb71982a52f504$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $dcdb71982a52f504$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $dcdb71982a52f504$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $6zAAP.default)();
    const queuesToReclaim = $dcdb71982a52f504$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$dcdb71982a52f504$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $9Ldsy.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("6zAAP", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5531f0463abe504$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $e5531f0463abe504$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch  {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("aNK4N", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $afe77db7deba6102$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $afe77db7deba6102$export$2e2bcd8739ae039);
const $afe77db7deba6102$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $afe77db7deba6102$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $afe77db7deba6102$export$2e2bcd8739ae039.prototype);
        this.name = $afe77db7deba6102$export$a409c8de90e11e14;
    }
}

});

parcelRegister("girQD", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0c5f740026c1e0d$export$2e2bcd8739ae039);

var $lsfC1 = parcelRequire("lsfC1");

var $bbWOC = parcelRequire("bbWOC");

var $aNK4N = parcelRequire("aNK4N");
var $e0c5f740026c1e0d$export$2e2bcd8739ae039 = (0, $lsfC1.default);

});
parcelRegister("lsfC1", function(module, exports) {
$parcel$export(module.exports, "default", () => $931b552d3b05c5ec$export$2e2bcd8739ae039);

var $bbWOC = parcelRequire("bbWOC");

var $LnkNr = parcelRequire("LnkNr");
var $335KS = parcelRequire("335KS");

var $4Xof2 = parcelRequire("4Xof2");

var $lfpVe = parcelRequire("lfpVe");

var $gcHMe = parcelRequire("gcHMe");
class $931b552d3b05c5ec$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $gcHMe.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $4Xof2.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $LnkNr.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $lfpVe.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $bbWOC.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $bbWOC.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $335KS.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $bbWOC.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $lfpVe.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $bbWOC.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("bbWOC", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $545c6917acad8f22$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $545c6917acad8f22$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $545c6917acad8f22$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $545c6917acad8f22$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $545c6917acad8f22$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $545c6917acad8f22$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $545c6917acad8f22$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $545c6917acad8f22$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $545c6917acad8f22$export$7710d69e6f450f20);
const $545c6917acad8f22$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $545c6917acad8f22$export$8cad224051643259 = 'analytics-web-client';
const $545c6917acad8f22$export$3d8420be07b276ab = 'analytics-resilience';
const $545c6917acad8f22$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $545c6917acad8f22$export$89d9c1ff8ac91862 = 'timeAdded';
const $545c6917acad8f22$export$a37d385bcd713809 = 'retryAttempts';
const $545c6917acad8f22$export$6d8635fed0e4b14d = 15000;
var $545c6917acad8f22$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $545c6917acad8f22$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("LnkNr", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd36513b44ad855c$export$2e2bcd8739ae039);
const $dd36513b44ad855c$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $dd36513b44ad855c$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $dd36513b44ad855c$export$2e2bcd8739ae039.prototype);
        this.name = $dd36513b44ad855c$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("335KS", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $2532432c9591bc45$export$74101021e0969375);

var $eINKf = parcelRequire("eINKf");

var $aNK4N = parcelRequire("aNK4N");

var $aqVVT = parcelRequire("aqVVT");
const $2532432c9591bc45$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $eINKf.AbandonWriteErrorName) || errorWithName.name === (0, $aNK4N.CallbackProcessingErrorName) || errorWithName.name === (0, $aqVVT.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("eINKf", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $908d63189cc61284$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $908d63189cc61284$export$2e2bcd8739ae039);
const $908d63189cc61284$export$ba95206613c96b28 = 'AbandonWriteError';
class $908d63189cc61284$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $908d63189cc61284$export$2e2bcd8739ae039.prototype);
        this.name = $908d63189cc61284$export$ba95206613c96b28;
    }
}

});

parcelRegister("aqVVT", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $0b93fbd2ffa00fd3$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $0b93fbd2ffa00fd3$export$2e2bcd8739ae039);
const $0b93fbd2ffa00fd3$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $0b93fbd2ffa00fd3$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $0b93fbd2ffa00fd3$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("4Xof2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6ce0b384ff68d76$export$2e2bcd8739ae039);

var $bbWOC = parcelRequire("bbWOC");

var $6K4Bk = parcelRequire("6K4Bk");

var $aNK4N = parcelRequire("aNK4N");
var $aqVVT = parcelRequire("aqVVT");
var $LnkNr = parcelRequire("LnkNr");
var $335KS = parcelRequire("335KS");

var $2Ej8K = parcelRequire("2Ej8K");

var $gcHMe = parcelRequire("gcHMe");
class $e6ce0b384ff68d76$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $LnkNr.default)());
                    }, (0, $bbWOC.INDEXEDDB_TIMEOUT));
                    /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how AWC is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ const request = window.indexedDB.open((0, $bbWOC.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $bbWOC.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $bbWOC.TIME_TO_PROCESS_AFTER_INDEX), (0, $bbWOC.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $bbWOC.RETRY_INDEX), (0, $bbWOC.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $bbWOC.TIME_ADDED_INDEX), (0, $bbWOC.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $bbWOC.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $LnkNr.default)());
                    };
                    try {
                        await (0, $gcHMe.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $LnkNr.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $LnkNr.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $bbWOC.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $gcHMe.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $bbWOC.GuardPolicy).IGNORE) throw new (0, $aqVVT.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $335KS.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $bbWOC.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $gcHMe.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $335KS.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $6K4Bk.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $6K4Bk.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $bbWOC.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $6K4Bk.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $gcHMe.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $gcHMe.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $gcHMe.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $gcHMe.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $bbWOC.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $gcHMe.requestToPromise)(request);
            await (0, $gcHMe.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $6K4Bk.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $aNK4N.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $gcHMe.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $bbWOC.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $bbWOC.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $gcHMe.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $LnkNr.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $2Ej8K.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $bbWOC.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("6K4Bk", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $21a612bbc3c27a35$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $21a612bbc3c27a35$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $21a612bbc3c27a35$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $21a612bbc3c27a35$export$1188664dfff364c8);
const $21a612bbc3c27a35$export$b6df3d334cec060f = 7;
const $21a612bbc3c27a35$export$14ef152a03a4b6ee = 60000;
const $21a612bbc3c27a35$export$da9ab7b2fd5998e8 = 10;
const $21a612bbc3c27a35$export$1188664dfff364c8 = 8000;

});

parcelRegister("2Ej8K", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e8636f2c16860dc$export$2e2bcd8739ae039);

var $bbWOC = parcelRequire("bbWOC");

var $eINKf = parcelRequire("eINKf");

var $gcHMe = parcelRequire("gcHMe");
class $5e8636f2c16860dc$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
   * This query fetches the oldest events currently stored in AWC IndexedDb object store
   * and deletes them sequentially
   */ this.deleteOldestNEvents = async (objectStore, count)=>{
            const productTimeAddedIndex = objectStore.index((0, $bbWOC.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $gcHMe.requestToPromise)(getAllRequest);
            const result = event?.target?.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $bbWOC.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $bbWOC.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $bbWOC.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $bbWOC.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $gcHMe.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $gcHMe.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $eINKf.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $bbWOC.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $gcHMe.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("gcHMe", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $9b8c033e94cd4e80$export$aec476f33d77be11);
$parcel$export(module.exports, "createOptionsWithDefaults", () => $9b8c033e94cd4e80$export$ddc6718318090f71);
$parcel$export(module.exports, "requestToPromise", () => $9b8c033e94cd4e80$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $9b8c033e94cd4e80$export$feab8418f018df89);
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $9b8c033e94cd4e80$export$342d941b6f724995);

var $6zAAP = parcelRequire("6zAAP");

var $6K4Bk = parcelRequire("6K4Bk");
const $9b8c033e94cd4e80$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $6zAAP.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $9b8c033e94cd4e80$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $6K4Bk.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $6K4Bk.EVENT_COUNT_LIMIT)
    });
const $9b8c033e94cd4e80$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $9b8c033e94cd4e80$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $9b8c033e94cd4e80$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $9b8c033e94cd4e80$export$2a5213bce1720b42(transaction);
};
const $9b8c033e94cd4e80$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("lfpVe", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3c46acfcaba1e23$export$2e2bcd8739ae039);

var $bbWOC = parcelRequire("bbWOC");

var $6K4Bk = parcelRequire("6K4Bk");

var $aNK4N = parcelRequire("aNK4N");
var $aqVVT = parcelRequire("aqVVT");

var $2u2KB = parcelRequire("2u2KB");

var $gcHMe = parcelRequire("gcHMe");
class $a3c46acfcaba1e23$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $gcHMe.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $2u2KB.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $bbWOC.GuardPolicy).ABANDON) {
        if (policy === (0, $bbWOC.GuardPolicy).IGNORE) throw new (0, $aqVVT.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $gcHMe.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $bbWOC.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $gcHMe.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $bbWOC.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $6K4Bk.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $6K4Bk.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $6K4Bk.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $6K4Bk.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $aNK4N.default)(error);
        }
    }
    storeType() {
        return (0, $bbWOC.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("2u2KB", function(module, exports) {
$parcel$export(module.exports, "default", () => $66787dd4a5a3e1e0$export$2e2bcd8739ae039);

var $bbWOC = parcelRequire("bbWOC");

var $eINKf = parcelRequire("eINKf");
class $66787dd4a5a3e1e0$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
   * Unlike IndexedDb, we cannot take advantage of any index. So we are,
   * treating the memory store as a sorted set when adding items.
   */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $bbWOC.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $bbWOC.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $bbWOC.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $eINKf.default)((0, $bbWOC.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("67HYK", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e91dc597e2bb24a$export$2e2bcd8739ae039);

var $gjBjm = parcelRequire("gjBjm");
class $8e91dc597e2bb24a$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $gjBjm.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}
let $8e91dc597e2bb24a$var$cachedMetricsClient = null;
var $8e91dc597e2bb24a$export$2e2bcd8739ae039 = ()=>{
    if (!$8e91dc597e2bb24a$var$cachedMetricsClient) $8e91dc597e2bb24a$var$cachedMetricsClient = new $8e91dc597e2bb24a$export$4b62ee5120ab50a8();
    return $8e91dc597e2bb24a$var$cachedMetricsClient;
};

});
parcelRegister("gjBjm", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $ddb9ca3de347dd25$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $ddb9ca3de347dd25$export$ee138fa712d11b84);
var $ddb9ca3de347dd25$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $ddb9ca3de347dd25$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("lH3a9", function(module, exports) {
$parcel$export(module.exports, "default", () => $04a565f3d308e667$export$2e2bcd8739ae039);

var $gjBjm = parcelRequire("gjBjm");
class $04a565f3d308e667$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $gjBjm.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $gjBjm.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $gjBjm.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $gjBjm.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $gjBjm.NetworkStatusEnum).ONLINE;
        return (0, $gjBjm.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("jauoR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ea82427e68d6885$export$2e2bcd8739ae039);

var $eWpzv = parcelRequire("eWpzv");

var $hOroi = parcelRequire("hOroi");
const $2ea82427e68d6885$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $2ea82427e68d6885$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $2ea82427e68d6885$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $hOroi.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $hOroi.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $eWpzv.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $hOroi.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $2ea82427e68d6885$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $2ea82427e68d6885$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $2ea82427e68d6885$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $2ea82427e68d6885$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $2ea82427e68d6885$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $2ea82427e68d6885$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $eWpzv.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("eWpzv", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $710029bdf557760b$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $710029bdf557760b$export$590a718599f8f8b3);
var $710029bdf557760b$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $710029bdf557760b$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $710029bdf557760b$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("hOroi", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $ed029aa403923fee$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $ed029aa403923fee$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("7TOaN", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $42b4a973f4ff9033$export$c21270cab66ab290);

var $a8bF2 = parcelRequire("a8bF2");
function $42b4a973f4ff9033$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $a8bF2.SegmentEventTypes).PAGE || item.msg.type === (0, $a8bF2.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $a8bF2.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}
async function $42b4a973f4ff9033$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$42b4a973f4ff9033$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("a8bF2", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $ea7eeadc59a023f7$export$a63e16b3351b8c36);
$parcel$export(module.exports, "FetchError", () => $ea7eeadc59a023f7$export$26e841bcf1aeb894);
$parcel$export(module.exports, "SegmentEventTypes", () => $ea7eeadc59a023f7$export$ddf929981dc6feb3);
$parcel$export(module.exports, "MetadataResponse", () => $ea7eeadc59a023f7$export$4b1a5e5486cc0d80);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $ea7eeadc59a023f7$export$96f086dcf574a9e2);
class $ea7eeadc59a023f7$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof $ea7eeadc59a023f7$export$26e841bcf1aeb894 ? error.statusCode : null;
    }
}
var $ea7eeadc59a023f7$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $ea7eeadc59a023f7$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $ea7eeadc59a023f7$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class $ea7eeadc59a023f7$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json?.url) ? json.url.trim() : '';
        return new $ea7eeadc59a023f7$export$4b1a5e5486cc0d80(json?.props || null, url.startsWith('http') ? url : null);
    }
}
class $ea7eeadc59a023f7$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const $ea7eeadc59a023f7$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});


parcelRegister("77neH", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $cd769a9ca328a476$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $cd769a9ca328a476$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $cd769a9ca328a476$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $cd769a9ca328a476$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $cd769a9ca328a476$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $cd769a9ca328a476$export$6f1c008dd0c3b67e);
const $cd769a9ca328a476$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $cd769a9ca328a476$export$8fddcd1eff390364 = 60000; // 60 seconds
const $cd769a9ca328a476$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $cd769a9ca328a476$export$6649d5c857717efe = 5000; // 5 seconds
const $cd769a9ca328a476$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $cd769a9ca328a476$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("fMtGC", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $f7710dc1e62a6353$export$ba118f9de1e5ac63);
const $f7710dc1e62a6353$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("iJiFZ", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $48c6c638f385eef3$export$8e8f0180c1b41fad);

var $ife0G = parcelRequire("ife0G");

var $a8bF2 = parcelRequire("a8bF2");
const $48c6c638f385eef3$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $48c6c638f385eef3$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $48c6c638f385eef3$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status !== 200) throw new (0, $a8bF2.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch  {}
    throw new (0, $a8bF2.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const $48c6c638f385eef3$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $48c6c638f385eef3$var$getCorsForUrl = (0, $ife0G.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("bF2Yo", function(module, exports) {
$parcel$export(module.exports, "default", () => $68aef56444cf4cc4$export$2e2bcd8739ae039);

var $76EzV = parcelRequire("76EzV");

var $8yynh = parcelRequire("8yynh");
var $hYm3l = parcelRequire("hYm3l");

var $5y352 = parcelRequire("5y352");

var $6zAAP = parcelRequire("6zAAP");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $68aef56444cf4cc4$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $68aef56444cf4cc4$var$SAFE = 'SAFE';
const $68aef56444cf4cc4$var$UNSAFE = 'UNSAFE';
const $68aef56444cf4cc4$var$NOT_FOUND = 'NOT_FOUND';
const $68aef56444cf4cc4$var$COOKIE = 'COOKIE';
const $68aef56444cf4cc4$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $68aef56444cf4cc4$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $5y352.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $hYm3l.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $8yynh.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $8yynh.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $68aef56444cf4cc4$var$LOCAL_STORAGE ? this.store.getItem((0, $8yynh.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $8yynh.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $68aef56444cf4cc4$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $68aef56444cf4cc4$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch  {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $68aef56444cf4cc4$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($68aef56444cf4cc4$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $76EzV.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $68aef56444cf4cc4$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $68aef56444cf4cc4$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $68aef56444cf4cc4$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $68aef56444cf4cc4$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($68aef56444cf4cc4$var$COOKIE);
        switch(cookieValue.type){
            case $68aef56444cf4cc4$var$SAFE:
            case $68aef56444cf4cc4$var$UNSAFE:
                this.store.setItem((0, $8yynh.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $68aef56444cf4cc4$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $6zAAP.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("8yynh", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $9c013c531773b1de$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $9c013c531773b1de$export$d4cb17942ea57c95);
var $9c013c531773b1de$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $9c013c531773b1de$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $9c013c531773b1de$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $9c013c531773b1de$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $9c013c531773b1de$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $9c013c531773b1de$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $9c013c531773b1de$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $9c013c531773b1de$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $9c013c531773b1de$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $9c013c531773b1de$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("hYm3l", function(module, exports) {
$parcel$export(module.exports, "default", () => $80406087b884f022$export$2e2bcd8739ae039);

var $lQcwb = parcelRequire("lQcwb");

var $8yynh = parcelRequire("8yynh");

var $jzHS5 = parcelRequire("jzHS5");

var $3uIHT = parcelRequire("3uIHT");
class $80406087b884f022$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $3uIHT.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($lQcwb))) : new (0, $jzHS5.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $8yynh.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $8yynh.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $8yynh.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $3uIHT.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $8yynh.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $8yynh.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $8yynh.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $8yynh.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
}

});
parcelRegister("jzHS5", function(module, exports) {
$parcel$export(module.exports, "default", () => $392abcf48c2fe896$export$2e2bcd8739ae039);

var $5y352 = parcelRequire("5y352");
class $392abcf48c2fe896$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $5y352.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("5y352", function(module, exports) {
$parcel$export(module.exports, "default", () => $06302e85e26f0495$export$2e2bcd8739ae039);

var $9P0t3 = parcelRequire("9P0t3");

var $lsJsw = parcelRequire("lsJsw");
class $06302e85e26f0495$export$2e2bcd8739ae039 extends (0, $lsJsw.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.localStorage || (0, $9P0t3.default);
        } catch (err) {
            storageToUse = (0, $9P0t3.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("9P0t3", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f3789b9e16ec6ed$export$2e2bcd8739ae039);
class $3f3789b9e16ec6ed$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $3f3789b9e16ec6ed$var$inmemorystorage = new $3f3789b9e16ec6ed$export$90e3e001bcac59c7();
var $3f3789b9e16ec6ed$export$2e2bcd8739ae039 = $3f3789b9e16ec6ed$var$inmemorystorage;

});

parcelRegister("lsJsw", function(module, exports) {
$parcel$export(module.exports, "default", () => $4daaf141c8a402ad$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $fBMYg = parcelRequire("fBMYg");

var $9P0t3 = parcelRequire("9P0t3");
const $4daaf141c8a402ad$export$41c06fdd37b7e9a5 = 'awc';
const $4daaf141c8a402ad$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $4daaf141c8a402ad$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $4daaf141c8a402ad$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $9P0t3.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($4daaf141c8a402ad$export$48c17662a6902497(globalThis[$4daaf141c8a402ad$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$4daaf141c8a402ad$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $9P0t3.default);
                if (!globalThis[$4daaf141c8a402ad$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$4daaf141c8a402ad$export$770aa8bc07b3de03] = (0, $9P0t3.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($4daaf141c8a402ad$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $fBMYg.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($4daaf141c8a402ad$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("3uIHT", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $f0469c5b3e970e72$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $f0469c5b3e970e72$export$de6821eed3d5f32d);

var $lQcwb = parcelRequire("lQcwb");

var $ife0G = parcelRequire("ife0G");

var $8yynh = parcelRequire("8yynh");
const $f0469c5b3e970e72$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $f0469c5b3e970e72$export$eb80e1beaa8dacf8 = (0, $8yynh.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $f0469c5b3e970e72$export$19164982d36535d8 = 'tld_test';
const $f0469c5b3e970e72$export$de6821eed3d5f32d = (0, $ife0G.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($lQcwb))).set($f0469c5b3e970e72$export$eb80e1beaa8dacf8, $f0469c5b3e970e72$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lQcwb))).get($f0469c5b3e970e72$export$eb80e1beaa8dacf8) === $f0469c5b3e970e72$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($lQcwb))).remove($f0469c5b3e970e72$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("cF8l4", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $d6bf4b63939ebe8d$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "prepareEventContext", () => $d6bf4b63939ebe8d$export$6b26e26d40264200);
$parcel$export(module.exports, "prepareEventProperties", () => $d6bf4b63939ebe8d$export$44d22e5fb02cc68e);
// @ts-ignore

var $dzE3p = parcelRequire("dzE3p");
const $d6bf4b63939ebe8d$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = {
        ...context.context,
        userAgent: navigator.userAgent
    };
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides?.excludedProperties) result.excludedProperties = {
        ...result.excludedProperties,
        ...$d6bf4b63939ebe8d$var$nestedRemoveUndefinedValues(overrides.excludedProperties, '$.excludedProperties')
    };
    if (overrides?.userConsents) result.userConsents = {
        ...result.userConsents,
        ...$d6bf4b63939ebe8d$var$nestedRemoveUndefinedValues(overrides.userConsents, '$.userConsents')
    };
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $d6bf4b63939ebe8d$var$removeFalseyProperties(result.excludedProperties);
    return result;
};
const $d6bf4b63939ebe8d$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = $d6bf4b63939ebe8d$var$nestedRemoveUndefinedValues(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($dzE3p)))(propertiesWithoutUndefined);
};
const $d6bf4b63939ebe8d$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $d6bf4b63939ebe8d$var$nestedRemoveUndefinedValues(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dzE3p)))(propertiesWithoutUndefined);
};
// Shallow removal of all falsey properties from an object, returning a new object.
const $d6bf4b63939ebe8d$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
// This function will essentially deepClone as well
const $d6bf4b63939ebe8d$var$nestedRemoveUndefinedValues = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});


parcelRegister("73oS7", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $470ef49369727cf6$export$1ac223ae496131c9);

var $lH3a9 = parcelRequire("lH3a9");

var $1Yf20 = parcelRequire("1Yf20");

var $jauoR = parcelRequire("jauoR");
var $hOroi = parcelRequire("hOroi");

var $gjBjm = parcelRequire("gjBjm");

var $1khbe = parcelRequire("1khbe");

var $d4fyI = parcelRequire("d4fyI");

var $77neH = parcelRequire("77neH");

var $d96ph = parcelRequire("d96ph");

var $a8bF2 = parcelRequire("a8bF2");
class $470ef49369727cf6$export$1ac223ae496131c9 {
    static{
        this.INITIAL_REFRESH_DELAY = 1;
    }
    static{
        this.Factory = (apiHostProtocol, apiHost, product)=>{
            return new $470ef49369727cf6$export$1ac223ae496131c9(apiHostProtocol, apiHost, product);
        };
    }
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $1khbe.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $77neH.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $77neH.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $jauoR.default)({
            ...this._options,
            waitInterval: (0, $77neH.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $470ef49369727cf6$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        this._fetchAbortController?.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $lH3a9.default)((status)=>{
            if (status === (0, $gjBjm.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        if ((0, $d4fyI.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        this._fetchAbortController?.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $d96ph.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $77neH.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $a8bF2.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $a8bF2.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $a8bF2.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        if (this._userInfo?.userId === userInfo?.userId && this._userInfo?.userIdType === userInfo?.userIdType) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        if (this._tenantInfo?.tenantId === tenantInfo?.tenantId && this._tenantInfo?.tenantIdType === tenantInfo?.tenantIdType) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        if (this._networkStatus?.getNetworkStatus() === (0, $gjBjm.NetworkStatusEnum).OFFLINE) {
            done((0, $hOroi.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $hOroi.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch  {
            done((0, $hOroi.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $77neH.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || (0, $1Yf20.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : (0, $1Yf20.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: options?.maxRetryDelay || (0, $1Yf20.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || (0, $1Yf20.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}

});
parcelRegister("1khbe", function(module, exports) {
$parcel$export(module.exports, "selectHost", () => $16c680d8e42edf26$export$18c0b81944902eae);
$parcel$export(module.exports, "isStargateProxyPath", () => $16c680d8e42edf26$export$83a9dd8d74be72c);

var $fBMYg = parcelRequire("fBMYg");
const $16c680d8e42edf26$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $16c680d8e42edf26$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $16c680d8e42edf26$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $16c680d8e42edf26$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $16c680d8e42edf26$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $16c680d8e42edf26$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $16c680d8e42edf26$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $16c680d8e42edf26$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $16c680d8e42edf26$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
 * Returns the full Stargate proxy URL (host + proxy path) for the current host.
 *
 * This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
 * and Oasis IC environments. Using the first-party proxy works around browser
 * restrictions with third-party cookies.
 *
 * In non-browser environments (e.g. SSR) where `window` is not defined, the host
 * portion is omitted and the function returns only `STARGATE_PROXY_PATH`
 * (i.e. `/gateway/api/gasv3/api/v1`).
 */ function $16c680d8e42edf26$var$stargateProxyUrl() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $16c680d8e42edf26$export$5df9262e102d0c32;
}
const $16c680d8e42edf26$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $fBMYg.envType).LOCAL || env === (0, $fBMYg.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $fBMYg.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $fBMYg.envType).PROD ? $16c680d8e42edf26$var$FEDRAMP_PROD_HOST : $16c680d8e42edf26$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $fBMYg.envType).PROD ? $16c680d8e42edf26$var$STARGATE_FEDRAMP_PROD_HOST : $16c680d8e42edf26$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $16c680d8e42edf26$var$stargateProxyUrl();
};
const $16c680d8e42edf26$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $fBMYg.envType).PROD ? $16c680d8e42edf26$var$PROD_HOST : $16c680d8e42edf26$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $fBMYg.envType).PROD ? $16c680d8e42edf26$var$STARGATE_PROD_HOST : $16c680d8e42edf26$var$STARGATE_STAGING_HOST;
    return $16c680d8e42edf26$var$stargateProxyUrl();
};
function $16c680d8e42edf26$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $16c680d8e42edf26$var$stargateProxyUrl();
    }
    if (perimeter === (0, $fBMYg.perimeterType).FEDRAMP_MODERATE) return $16c680d8e42edf26$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $16c680d8e42edf26$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function $16c680d8e42edf26$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === $16c680d8e42edf26$var$stargateProxyUrl();
}

});

parcelRegister("d4fyI", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $51bfdb2868049348$export$44b578549c42d779);
class $51bfdb2868049348$export$44b578549c42d779 {
    static{
        this.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
    }
    static{
        this.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
    }
    static{
        this.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
    }
    static{
        this.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';
    }
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($51bfdb2868049348$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($51bfdb2868049348$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($51bfdb2868049348$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($51bfdb2868049348$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}

});

parcelRegister("d96ph", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $51a1a0eb580a313e$export$55b0d0261469055);

var $ife0G = parcelRequire("ife0G");

var $a8bF2 = parcelRequire("a8bF2");
const $51a1a0eb580a313e$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    const requestAbortController = $51a1a0eb580a313e$var$createRequestAbortController(timeout, signal);
    const corsOptions = $51a1a0eb580a313e$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${params.userInfo?.userId || ''}`,
        userIdType: `${params.userInfo?.userIdType || ''}`,
        tenantId: `${params.tenantInfo?.tenantId || ''}`,
        tenantIdType: `${params.tenantInfo?.tenantIdType || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $a8bF2.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $51a1a0eb580a313e$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal?.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $51a1a0eb580a313e$var$getCorsForUrl = (0, $ife0G.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});


parcelRegister("6trHC", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d52c64e120f6970$export$2e2bcd8739ae039);

var $fBMYg = parcelRequire("fBMYg");

var $62IYf = parcelRequire("62IYf");
class $3d52c64e120f6970$export$2e2bcd8739ae039 {
    static{
        this.messageEvent = 'origin landed';
    }
    constructor(){
        this.pendingCleanup = null;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $fBMYg.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            const paramExtractorReplace = ()=>{};
            const capturedURLParams = (0, $62IYf.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
                (0, $62IYf.default)(isCaptureParam, historyReplaceFn);
            };
            return capturedOriginTraces;
        };
        this._originStore = {};
    }
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
   * Designed to be invoked after a successful flush with the batch of flushed events.
   */ cleanupOriginParameters(events) {
        try {
            if (this.pendingCleanup) {
                const hasOriginLanded = events.some((item)=>'event' in item.msg && item.msg.event === $3d52c64e120f6970$export$2e2bcd8739ae039.messageEvent);
                if (hasOriginLanded) this._cleanupOriginParams();
            }
        } catch  {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
}

});

parcelRegister("cgqme", function(module, exports) {
$parcel$export(module.exports, "default", () => $c75230aa40e142d9$export$2e2bcd8739ae039);

var $5y352 = parcelRequire("5y352");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $c75230aa40e142d9$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $c75230aa40e142d9$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $c75230aa40e142d9$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $c75230aa40e142d9$export$285f6bddd927a06d = 1800000; // 30 minutes
const $c75230aa40e142d9$export$a92e915d70316eb2 = 5000; // 5 seconds
const $c75230aa40e142d9$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $c75230aa40e142d9$export$5702a91a6f42969f = ()=>{};
class $c75230aa40e142d9$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($c75230aa40e142d9$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($c75230aa40e142d9$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $c75230aa40e142d9$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $c75230aa40e142d9$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $c75230aa40e142d9$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $c75230aa40e142d9$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $5y352.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($c75230aa40e142d9$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($c75230aa40e142d9$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$c75230aa40e142d9$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("3hIGA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1a598db70f048fc$export$2e2bcd8739ae039);

var $9P0t3 = parcelRequire("9P0t3");

var $lsJsw = parcelRequire("lsJsw");
class $b1a598db70f048fc$export$2e2bcd8739ae039 extends (0, $lsJsw.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.sessionStorage || (0, $9P0t3.default);
        } catch (err) {
            storageToUse = (0, $9P0t3.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("6413a", function(module, exports) {
$parcel$export(module.exports, "default", () => $d315018d74c62bc8$export$2e2bcd8739ae039);

var $3hIGA = parcelRequire("3hIGA");

var $6zAAP = parcelRequire("6zAAP");
const $d315018d74c62bc8$var$STORAGE_KEY = 'tab.id';
class $d315018d74c62bc8$export$2e2bcd8739ae039 {
    constructor(){
        this._generateNewTabId = ()=>{
            const newTabId = (0, $6zAAP.default)();
            this._safeSessionStorage.setItem($d315018d74c62bc8$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $3hIGA.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($d315018d74c62bc8$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("lXZCR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e647cf94d450a758$export$2e2bcd8739ae039);

var $42rJW = parcelRequire("42rJW");

var $fBMYg = parcelRequire("fBMYg");

var $hLVFP = parcelRequire("hLVFP");

var $3hIGA = parcelRequire("3hIGA");

var $62IYf = parcelRequire("62IYf");

var $6zAAP = parcelRequire("6zAAP");
const $e647cf94d450a758$var$STORAGE_KEY = 'taskSessions';
const $e647cf94d450a758$var$INIT_KEY = 'taskSessionsInit';
const $e647cf94d450a758$var$AWC_PARAM_PREFIX = 'awc.';
const $e647cf94d450a758$var$TASK_SESSION_RELOAD_TIME = 3000;
class $e647cf94d450a758$export$2e2bcd8739ae039 {
    constructor(){
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($e647cf94d450a758$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($e647cf94d450a758$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($e647cf94d450a758$var$INIT_KEY) || '0', 10) < currentTimestamp - $e647cf94d450a758$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($e647cf94d450a758$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($e647cf94d450a758$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($e647cf94d450a758$var$STORAGE_KEY) || '');
            } catch  {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($e647cf94d450a758$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch  {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, $6zAAP.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $42rJW.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $hLVFP.pick)(currentState, includedTaskSessions) : (0, $hLVFP.omit)(currentState, Object.values((0, $fBMYg.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $hLVFP.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$e647cf94d450a758$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $42rJW.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $hLVFP.mapKeys)((0, $62IYf.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $3hIGA.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($e647cf94d450a758$var$INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch  {}
    }
}

});

parcelRegister("fZmq3", function(module, exports) {
$parcel$export(module.exports, "default", () => $89e3d1c741a19a7d$export$2e2bcd8739ae039);

var $lQcwb = parcelRequire("lQcwb");

var $8yynh = parcelRequire("8yynh");

var $d4fyI = parcelRequire("d4fyI");
const $89e3d1c741a19a7d$var$MAX_CACHE_SIZE = 100;
const $89e3d1c741a19a7d$var$COOKIE_NAME = (0, $8yynh.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $89e3d1c741a19a7d$var$DEBUG_TAG = 'synthetic';
class $89e3d1c741a19a7d$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $89e3d1c741a19a7d$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $89e3d1c741a19a7d$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($89e3d1c741a19a7d$var$DEBUG_TAG)) event.tags.push($89e3d1c741a19a7d$var$DEBUG_TAG);
        } else event.tags = [
            $89e3d1c741a19a7d$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $d4fyI.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($lQcwb))).get($89e3d1c741a19a7d$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, (/*@__PURE__*/$parcel$interopDefault($lQcwb))).remove($89e3d1c741a19a7d$var$COOKIE_NAME);
        }
        return false;
    }
}
var $89e3d1c741a19a7d$export$2e2bcd8739ae039 = $89e3d1c741a19a7d$var$TestingCache;

});

parcelRegister("amSXO", function(module, exports) {
$parcel$export(module.exports, "default", () => $4149cc84ba7f8a3f$export$2e2bcd8739ae039);

var $fBMYg = parcelRequire("fBMYg");

var $7BoZN = parcelRequire("7BoZN");

var $5y352 = parcelRequire("5y352");
const $4149cc84ba7f8a3f$var$DEFAULT_DELAY = 2000; // 2 seconds
const $4149cc84ba7f8a3f$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $4149cc84ba7f8a3f$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $4149cc84ba7f8a3f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $4149cc84ba7f8a3f$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($4149cc84ba7f8a3f$var$SendEventDecision || {});
class $4149cc84ba7f8a3f$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this.signalUserActive = ()=>{
            this._sendUserActiveEvents();
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch  {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._handleDwellTimerTriggered = ()=>{
            const document = (0, $7BoZN.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        };
        this._sendUserActiveEvents = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case 3:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 1:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $fBMYg.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 1;
                return 2;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 3;
            return 4;
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $4149cc84ba7f8a3f$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $4149cc84ba7f8a3f$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $4149cc84ba7f8a3f$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $4149cc84ba7f8a3f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $5y352.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("7BoZN", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $0212a0eaac2c2723$export$f65ca476c09acec0);
const $0212a0eaac2c2723$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("3N69E", function(module, exports) {
$parcel$export(module.exports, "default", () => $49e41797d416ac43$export$2e2bcd8739ae039);
function $49e41797d416ac43$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("efrw7", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $f6e060c5f63128dc$export$fbe53bbbe682bcdd);

var $fOb5y = parcelRequire("fOb5y");
const $f6e060c5f63128dc$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $fOb5y.createTimeoutXid)()), (0, $fOb5y.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $fOb5y.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("fOb5y", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $36b1f48b703c5acd$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $36b1f48b703c5acd$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $36b1f48b703c5acd$export$fa341d0c750d705b);

var $bijjs = parcelRequire("bijjs");
const $36b1f48b703c5acd$export$545bcbd53afabfa3 = 5000;
const $36b1f48b703c5acd$export$af4087e36d63846 = ()=>[
        {
            type: (0, $bijjs.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $bijjs.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $36b1f48b703c5acd$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $bijjs.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $bijjs.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("bijjs", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $101184601ef17ec6$export$92ca0438bcb0d396);
var $101184601ef17ec6$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $101184601ef17ec6$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("55xCb", function(module, exports) {
$parcel$export(module.exports, "httpClientIntegration", () => $3b477e9c00863677$export$8a3b7aeb379b3907);

var $53EVt = parcelRequire("53EVt");
var $lHL6l = parcelRequire("lHL6l");
var $9QeFV = parcelRequire("9QeFV");
var $byod0 = parcelRequire("byod0");
var $gGGDG = parcelRequire("gGGDG");
var $hQaCR = parcelRequire("hQaCR");
var $cizHV = parcelRequire("cizHV");
var $gtcuO = parcelRequire("gtcuO");
var $aQI6w = parcelRequire("aQI6w");

var $i7ndJ = parcelRequire("i7ndJ");

var $faoOk = parcelRequire("faoOk");
const $3b477e9c00863677$var$INTEGRATION_NAME = 'HttpClient';
const $3b477e9c00863677$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $3b477e9c00863677$var$INTEGRATION_NAME,
        setup (client) {
            $3b477e9c00863677$var$_wrapFetch(client, _options);
            $3b477e9c00863677$var$_wrapXHR(client, _options);
        }
    };
};
/**
 * Create events for failed client side HTTP requests.
 */ const $3b477e9c00863677$export$8a3b7aeb379b3907 = (0, $byod0.defineIntegration)($3b477e9c00863677$var$_httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function $3b477e9c00863677$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error) {
    if ($3b477e9c00863677$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $3b477e9c00863677$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        if ($3b477e9c00863677$var$_shouldSendDefaultPii()) {
            [requestHeaders, requestCookies] = $3b477e9c00863677$var$_parseCookieHeaders('Cookie', request);
            [responseHeaders, responseCookies] = $3b477e9c00863677$var$_parseCookieHeaders('Set-Cookie', response);
        }
        const event = $3b477e9c00863677$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies,
            error: error
        });
        (0, $9QeFV.captureEvent)(event);
    }
}
function $3b477e9c00863677$var$_parseCookieHeaders(cookieHeader, obj) {
    const headers = $3b477e9c00863677$var$_extractFetchHeaders(obj.headers);
    let cookies;
    try {
        const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
        if (cookieString) cookies = $3b477e9c00863677$var$_parseCookieString(cookieString);
    } catch  {
    // ignore it if parsing fails
    }
    return [
        headers,
        cookies
    ];
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function $3b477e9c00863677$var$_xhrResponseHandler(options, xhr, method, headers, error) {
    if ($3b477e9c00863677$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        if ($3b477e9c00863677$var$_shouldSendDefaultPii()) {
            try {
                const cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;
                if (cookieString) responseCookies = $3b477e9c00863677$var$_parseCookieString(cookieString);
            } catch  {
            // ignore it if parsing fails
            }
            try {
                responseHeaders = $3b477e9c00863677$var$_getXHRResponseHeaders(xhr);
            } catch  {
            // ignore it if parsing fails
            }
            requestHeaders = headers;
        }
        const event = $3b477e9c00863677$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies,
            error: error
        });
        (0, $9QeFV.captureEvent)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function $3b477e9c00863677$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers['Content-Length'] || headers['content-length'];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function $3b477e9c00863677$var$_parseCookieString(cookieString) {
    return cookieString.split('; ').reduce((acc, cookie)=>{
        const [key, value] = cookie.split('=');
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function $3b477e9c00863677$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function $3b477e9c00863677$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function $3b477e9c00863677$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === 'string') return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function $3b477e9c00863677$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === 'number') return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function $3b477e9c00863677$var$_wrapFetch(client, options) {
    if (!(0, $aQI6w.supportsNativeFetch)()) return;
    (0, $lHL6l.addFetchInstrumentationHandler)((handlerData)=>{
        if ((0, $gGGDG.getClient)() !== client) return;
        const { response: response, args: args, error: error, virtualError: virtualError } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $3b477e9c00863677$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
    }, false);
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function $3b477e9c00863677$var$_wrapXHR(client, options) {
    if (!('XMLHttpRequest' in (0, $hQaCR.GLOBAL_OBJ))) return;
    (0, $i7ndJ.addXhrInstrumentationHandler)((handlerData)=>{
        if ((0, $gGGDG.getClient)() !== client) return;
        const { error: error, virtualError: virtualError } = handlerData;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $i7ndJ.SENTRY_XHR_DATA_KEY];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $3b477e9c00863677$var$_xhrResponseHandler(options, xhr, method, headers, error || virtualError);
        } catch (e) {
            (0, $faoOk.DEBUG_BUILD) && (0, $gtcuO.logger).warn('Error while extracting response event form XHR response', e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function $3b477e9c00863677$var$_shouldCaptureResponse(options, status, url) {
    return $3b477e9c00863677$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $3b477e9c00863677$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $cizHV.isSentryRequestUrl)(url, (0, $gGGDG.getClient)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function $3b477e9c00863677$var$_createEvent(data) {
    const client = (0, $gGGDG.getClient)();
    const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : undefined;
    // Remove the first frame from the stack as it's the HttpClient call
    const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : undefined;
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: 'Error',
                    value: message,
                    stacktrace: stack ? {
                        frames: stack
                    } : undefined
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $3b477e9c00863677$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $53EVt.addExceptionMechanism)(event, {
        type: 'http.client',
        handled: false
    });
    return event;
}
function $3b477e9c00863677$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $3b477e9c00863677$var$_shouldSendDefaultPii() {
    const client = (0, $gGGDG.getClient)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}

});
parcelRegister("lHL6l", function(module, exports) {
$parcel$export(module.exports, "addFetchInstrumentationHandler", () => $fcd2267c2a0896ab$export$f75d3c772c923df0);

var $ipyIh = parcelRequire("ipyIh");

var $5qWPd = parcelRequire("5qWPd");

var $aQI6w = parcelRequire("aQI6w");

var $kxreP = parcelRequire("kxreP");

var $hQaCR = parcelRequire("hQaCR");

var $7L3j6 = parcelRequire("7L3j6");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $fcd2267c2a0896ab$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $7L3j6.addHandler)(type, handler);
    (0, $7L3j6.maybeInstrument)(type, ()=>$fcd2267c2a0896ab$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $fcd2267c2a0896ab$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $7L3j6.addHandler)(type, handler);
    (0, $7L3j6.maybeInstrument)(type, ()=>$fcd2267c2a0896ab$var$instrumentFetch($fcd2267c2a0896ab$var$streamHandler));
}
function $fcd2267c2a0896ab$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $aQI6w.supportsNativeFetch)()) return;
    (0, $5qWPd.fill)((0, $hQaCR.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $fcd2267c2a0896ab$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $kxreP.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $fcd2267c2a0896ab$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $7L3j6.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $hQaCR.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $7L3j6.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $kxreP.timestampInSeconds)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $7L3j6.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $kxreP.timestampInSeconds)() * 1000,
                    error: error
                });
                if ((0, $ipyIh.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $5qWPd.addNonEnumerableProperty)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $fcd2267c2a0896ab$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $fcd2267c2a0896ab$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $fcd2267c2a0896ab$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $7L3j6.triggerHandlers)('fetch-body-resolved', {
            endTimestamp: (0, $kxreP.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $fcd2267c2a0896ab$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $fcd2267c2a0896ab$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($fcd2267c2a0896ab$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $fcd2267c2a0896ab$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $fcd2267c2a0896ab$var$getUrlFromResource(url),
            method: $fcd2267c2a0896ab$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $fcd2267c2a0896ab$var$getUrlFromResource(arg),
        method: $fcd2267c2a0896ab$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $fcd2267c2a0896ab$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $ipyIh.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

});
parcelRegister("aQI6w", function(module, exports) {
$parcel$export(module.exports, "supportsHistory", () => $7e60f8e326328ee4$export$67fc34576016d6ec);
$parcel$export(module.exports, "isNativeFunction", () => $7e60f8e326328ee4$export$d5f608b368e73f38);
$parcel$export(module.exports, "supportsNativeFetch", () => $7e60f8e326328ee4$export$c82d238e23c40b21);

var $bQQos = parcelRequire("bQQos");

var $gtcuO = parcelRequire("gtcuO");

var $hQaCR = parcelRequire("hQaCR");
const $7e60f8e326328ee4$var$WINDOW = (0, $hQaCR.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $7e60f8e326328ee4$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $7e60f8e326328ee4$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $7e60f8e326328ee4$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $7e60f8e326328ee4$export$67fc34576016d6ec() {
    return 'history' in $7e60f8e326328ee4$var$WINDOW && !!$7e60f8e326328ee4$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $7e60f8e326328ee4$export$edf3cb81fd7d2a3e = $7e60f8e326328ee4$var$_isFetchSupported;
function $7e60f8e326328ee4$var$_isFetchSupported() {
    if (!('fetch' in $7e60f8e326328ee4$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $7e60f8e326328ee4$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $7e60f8e326328ee4$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$7e60f8e326328ee4$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($7e60f8e326328ee4$export$d5f608b368e73f38($7e60f8e326328ee4$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $7e60f8e326328ee4$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $7e60f8e326328ee4$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $7e60f8e326328ee4$export$531055a6c684a70a() {
    return 'ReportingObserver' in $7e60f8e326328ee4$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $7e60f8e326328ee4$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$7e60f8e326328ee4$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("7L3j6", function(module, exports) {
$parcel$export(module.exports, "addHandler", () => $5a5f7cee41a4a44a$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $5a5f7cee41a4a44a$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $5a5f7cee41a4a44a$export$b18c893e424d3127);

var $bQQos = parcelRequire("bQQos");

var $gtcuO = parcelRequire("gtcuO");

var $e19TC = parcelRequire("e19TC");
// We keep the handlers globally
const $5a5f7cee41a4a44a$var$handlers = {};
const $5a5f7cee41a4a44a$var$instrumented = {};
/** Add a handler function. */ function $5a5f7cee41a4a44a$export$a4e09611e30da72e(type, handler) {
    $5a5f7cee41a4a44a$var$handlers[type] = $5a5f7cee41a4a44a$var$handlers[type] || [];
    $5a5f7cee41a4a44a$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $5a5f7cee41a4a44a$export$b17eab759a1cb5fe() {
    Object.keys($5a5f7cee41a4a44a$var$handlers).forEach((key)=>{
        $5a5f7cee41a4a44a$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $5a5f7cee41a4a44a$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$5a5f7cee41a4a44a$var$instrumented[type]) {
        $5a5f7cee41a4a44a$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $5a5f7cee41a4a44a$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $5a5f7cee41a4a44a$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $e19TC.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("byod0", function(module, exports) {
$parcel$export(module.exports, "getIntegrationsToSetup", () => $8695a60807df65db$export$68bc4c01ab8ae766);
$parcel$export(module.exports, "setupIntegrations", () => $8695a60807df65db$export$51abed9797baa598);
$parcel$export(module.exports, "setupIntegration", () => $8695a60807df65db$export$e7390a03b70a6f2f);
$parcel$export(module.exports, "afterSetupIntegrations", () => $8695a60807df65db$export$35abcfd71227c6ca);
$parcel$export(module.exports, "defineIntegration", () => $8695a60807df65db$export$2323046b9414659f);

var $gGGDG = parcelRequire("gGGDG");

var $bQQos = parcelRequire("bQQos");

var $gtcuO = parcelRequire("gtcuO");
const $8695a60807df65db$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $8695a60807df65db$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $8695a60807df65db$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $8695a60807df65db$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $8695a60807df65db$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $8695a60807df65db$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $8695a60807df65db$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $8695a60807df65db$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($8695a60807df65db$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $8695a60807df65db$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $8695a60807df65db$export$2d8f5188773bcddd(integration) {
    const client = (0, $gGGDG.getClient)();
    if (!client) {
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $8695a60807df65db$export$2323046b9414659f(fn) {
    return fn;
}

});

parcelRegister("cizHV", function(module, exports) {
$parcel$export(module.exports, "isSentryRequestUrl", () => $8f42dd4181b8333f$export$d92e61f5600202af);
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $8f42dd4181b8333f$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $8f42dd4181b8333f$var$checkDsn(url, dsn) || $8f42dd4181b8333f$var$checkTunnel(url, tunnel);
}
function $8f42dd4181b8333f$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $8f42dd4181b8333f$var$removeTrailingSlash(url) === $8f42dd4181b8333f$var$removeTrailingSlash(tunnel);
}
function $8f42dd4181b8333f$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $8f42dd4181b8333f$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}

});

parcelRegister("i7ndJ", function(module, exports) {
$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", () => $d30ae48a4fa383dd$export$55b6bb1e45c6cf59);
$parcel$export(module.exports, "addXhrInstrumentationHandler", () => $d30ae48a4fa383dd$export$26ace48dd54c9aea);

var $7L3j6 = parcelRequire("7L3j6");
var $ipyIh = parcelRequire("ipyIh");
var $kxreP = parcelRequire("kxreP");

var $bw7iO = parcelRequire("bw7iO");
const $d30ae48a4fa383dd$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d30ae48a4fa383dd$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $7L3j6.addHandler)(type, handler);
    (0, $7L3j6.maybeInstrument)(type, $d30ae48a4fa383dd$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $d30ae48a4fa383dd$export$c67d533bf77cbf54() {
    if (!(0, $bw7iO.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $kxreP.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $ipyIh.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $d30ae48a4fa383dd$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$d30ae48a4fa383dd$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$d30ae48a4fa383dd$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $kxreP.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $7L3j6.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$d30ae48a4fa383dd$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $ipyIh.isString)(header) && (0, $ipyIh.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$d30ae48a4fa383dd$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $kxreP.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $7L3j6.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $d30ae48a4fa383dd$var$parseXhrUrlArg(url) {
    if ((0, $ipyIh.isString)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}

});
parcelRegister("bw7iO", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $862858f628afdc6f$export$56d8a8a25bd48b81);

var $hQaCR = parcelRequire("hQaCR");
const $862858f628afdc6f$export$56d8a8a25bd48b81 = (0, $hQaCR.GLOBAL_OBJ);

});



parcelRegister("65z9B", function(module, exports) {
$parcel$export(module.exports, "init", () => $46ee7a84c76ec37d$export$2cd8252107eb640b);

var $7IvSs = parcelRequire("7IvSs");
var $9QeFV = parcelRequire("9QeFV");

var $iPHMx = parcelRequire("iPHMx");

var $4tluv = parcelRequire("4tluv");
/**
 * Inits the React SDK
 */ function $46ee7a84c76ec37d$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $iPHMx.applySdkMetadata)(opts, 'react');
    (0, $9QeFV.setContext)('react', {
        version: $4tluv.version
    });
    return (0, $7IvSs.init)(opts);
}

});
parcelRegister("7IvSs", function(module, exports) {
$parcel$export(module.exports, "init", () => $59e55ea6d0405d3a$export$2cd8252107eb640b);

var $2G4uP = parcelRequire("2G4uP");
var $ifzY8 = parcelRequire("ifzY8");
var $byod0 = parcelRequire("byod0");
var $6ugFe = parcelRequire("6ugFe");
var $5fV9k = parcelRequire("5fV9k");
var $e19TC = parcelRequire("e19TC");

var $7bsnO = parcelRequire("7bsnO");

var $6akPy = parcelRequire("6akPy");

var $kueAu = parcelRequire("kueAu");

var $aMtRl = parcelRequire("aMtRl");

var $lfYGT = parcelRequire("lfYGT");

var $l7aEi = parcelRequire("l7aEi");

var $8hb3R = parcelRequire("8hb3R");

var $7vT6J = parcelRequire("7vT6J");

var $4OMEk = parcelRequire("4OMEk");

var $cYOqF = parcelRequire("cYOqF");
/** Get the default integrations for the browser SDK. */ function $59e55ea6d0405d3a$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $6ugFe.inboundFiltersIntegration)(),
        (0, $ifzY8.functionToStringIntegration)(),
        (0, $kueAu.browserApiErrorsIntegration)(),
        (0, $6akPy.breadcrumbsIntegration)(),
        (0, $lfYGT.globalHandlersIntegration)(),
        (0, $8hb3R.linkedErrorsIntegration)(),
        (0, $2G4uP.dedupeIntegration)(),
        (0, $l7aEi.httpContextIntegration)(),
        (0, $aMtRl.browserSessionIntegration)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $59e55ea6d0405d3a$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $cYOqF.checkAndWarnIfIsEmbeddedBrowserExtension)();
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $e19TC.stackParserFromStackParserOptions)(options.stackParser || (0, $7vT6J.defaultStackParser)),
        integrations: (0, $byod0.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: options.defaultIntegrations == null ? $59e55ea6d0405d3a$export$5783b2920b1d62b9() : options.defaultIntegrations
        }),
        transport: options.transport || (0, $4OMEk.makeFetchTransport)
    };
    return (0, $5fV9k.initAndBind)((0, $7bsnO.BrowserClient), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $59e55ea6d0405d3a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $59e55ea6d0405d3a$export$4e4d8b287d028b6b(callback) {
    callback();
}

});
parcelRegister("2G4uP", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", () => $1f32fddf6d3b3306$export$6d39aa44cd0c7567);

var $bQQos = parcelRequire("bQQos");

var $byod0 = parcelRequire("byod0");

var $gtcuO = parcelRequire("gtcuO");

var $e19TC = parcelRequire("e19TC");
const $1f32fddf6d3b3306$var$INTEGRATION_NAME = 'Dedupe';
const $1f32fddf6d3b3306$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $1f32fddf6d3b3306$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($1f32fddf6d3b3306$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $1f32fddf6d3b3306$export$6d39aa44cd0c7567 = (0, $byod0.defineIntegration)($1f32fddf6d3b3306$var$_dedupeIntegration);
/** only exported for tests. */ function $1f32fddf6d3b3306$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($1f32fddf6d3b3306$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($1f32fddf6d3b3306$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $1f32fddf6d3b3306$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$1f32fddf6d3b3306$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$1f32fddf6d3b3306$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $1f32fddf6d3b3306$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $1f32fddf6d3b3306$var$_getExceptionFromEvent(previousEvent);
    const currentException = $1f32fddf6d3b3306$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$1f32fddf6d3b3306$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$1f32fddf6d3b3306$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $1f32fddf6d3b3306$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $e19TC.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $e19TC.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $1f32fddf6d3b3306$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $1f32fddf6d3b3306$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}

});

parcelRegister("ifzY8", function(module, exports) {
$parcel$export(module.exports, "functionToStringIntegration", () => $d4958764cf44aab8$export$7918117e9202e4fb);

var $gGGDG = parcelRequire("gGGDG");

var $byod0 = parcelRequire("byod0");

var $5qWPd = parcelRequire("5qWPd");
let $d4958764cf44aab8$var$originalFunctionToString;
const $d4958764cf44aab8$var$INTEGRATION_NAME = 'FunctionToString';
const $d4958764cf44aab8$var$SETUP_CLIENTS = new WeakMap();
const $d4958764cf44aab8$var$_functionToStringIntegration = ()=>{
    return {
        name: $d4958764cf44aab8$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $d4958764cf44aab8$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $5qWPd.getOriginalFunction)(this);
                    const context = $d4958764cf44aab8$var$SETUP_CLIENTS.has((0, $gGGDG.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $d4958764cf44aab8$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $d4958764cf44aab8$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $d4958764cf44aab8$export$7918117e9202e4fb = (0, $byod0.defineIntegration)($d4958764cf44aab8$var$_functionToStringIntegration);

});

parcelRegister("6ugFe", function(module, exports) {
$parcel$export(module.exports, "inboundFiltersIntegration", () => $4b9278870268bcdf$export$cb3c5c2ceb9818ba);

var $bQQos = parcelRequire("bQQos");

var $byod0 = parcelRequire("byod0");

var $7aWfK = parcelRequire("7aWfK");

var $gtcuO = parcelRequire("gtcuO");

var $53EVt = parcelRequire("53EVt");

var $6YXbs = parcelRequire("6YXbs");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $4b9278870268bcdf$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $4b9278870268bcdf$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $4b9278870268bcdf$export$9a84f518c163c552 = (0, $byod0.defineIntegration)((options = {})=>{
    let mergedOptions;
    return {
        name: $4b9278870268bcdf$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $4b9278870268bcdf$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $4b9278870268bcdf$var$_mergeOptions(options, clientOptions);
            }
            return $4b9278870268bcdf$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $4b9278870268bcdf$export$cb3c5c2ceb9818ba = (0, $byod0.defineIntegration)((options = {})=>{
    return {
        ...$4b9278870268bcdf$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $4b9278870268bcdf$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $4b9278870268bcdf$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $4b9278870268bcdf$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($4b9278870268bcdf$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $53EVt.getEventDescription)(event)}`);
            return true;
        }
        if ($4b9278870268bcdf$var$_isUselessError(event)) {
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $53EVt.getEventDescription)(event)}`);
            return true;
        }
        if ($4b9278870268bcdf$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $53EVt.getEventDescription)(event)}.\nUrl: ${$4b9278870268bcdf$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$4b9278870268bcdf$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $53EVt.getEventDescription)(event)}.\nUrl: ${$4b9278870268bcdf$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($4b9278870268bcdf$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $53EVt.getEventDescription)(event)}`);
            return true;
        }
    }
    return false;
}
function $4b9278870268bcdf$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $7aWfK.getPossibleEventMessages)(event).some((message)=>(0, $6YXbs.stringMatchesSomePattern)(message, ignoreErrors));
}
function $4b9278870268bcdf$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $6YXbs.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $4b9278870268bcdf$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $4b9278870268bcdf$var$_getEventFilterUrl(event);
    return !url ? false : (0, $6YXbs.stringMatchesSomePattern)(url, denyUrls);
}
function $4b9278870268bcdf$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $4b9278870268bcdf$var$_getEventFilterUrl(event);
    return !url ? true : (0, $6YXbs.stringMatchesSomePattern)(url, allowUrls);
}
function $4b9278870268bcdf$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $4b9278870268bcdf$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $4b9278870268bcdf$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).error(`Cannot extract url for event ${(0, $53EVt.getEventDescription)(event)}`);
        return null;
    }
}
function $4b9278870268bcdf$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}

});
parcelRegister("7aWfK", function(module, exports) {
$parcel$export(module.exports, "getPossibleEventMessages", () => $5396a767c197a77c$export$d55a97c329cacfcc);
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $5396a767c197a77c$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}

});


parcelRegister("5fV9k", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $3d3aaf2416806438$export$5333c3f1c58d9bc1);

var $gGGDG = parcelRequire("gGGDG");

var $bQQos = parcelRequire("bQQos");

var $gtcuO = parcelRequire("gtcuO");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $3d3aaf2416806438$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $bQQos.DEBUG_BUILD) (0, $gtcuO.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $gtcuO.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $gGGDG.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $3d3aaf2416806438$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $3d3aaf2416806438$export$ecb76f41d43c0e43(client) {
    (0, $gGGDG.getCurrentScope)().setClient(client);
}

});

parcelRegister("7bsnO", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $53af93c8fd219543$export$1df9218a526d318d);

var $1Bl5D = parcelRequire("1Bl5D");
var $gJTnt = parcelRequire("gJTnt");
var $iPHMx = parcelRequire("iPHMx");
var $50ZDQ = parcelRequire("50ZDQ");
var $6PzCs = parcelRequire("6PzCs");

var $f0UHX = parcelRequire("f0UHX");

var $quYvH = parcelRequire("quYvH");
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ const $53af93c8fd219543$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $53af93c8fd219543$export$1df9218a526d318d extends (0, $50ZDQ.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $53af93c8fd219543$export$4e107b20a7f977(options);
        const sdkSource = (0, $quYvH.WINDOW).SENTRY_SDK_SOURCE || (0, $6PzCs.getSDKSource)();
        (0, $iPHMx.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, _experiments: _experiments } = this._options;
        const enableLogs = _experiments?.enableLogs;
        if ((0, $quYvH.WINDOW).document && (sendClientReports || enableLogs)) (0, $quYvH.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $quYvH.WINDOW).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $1Bl5D._INTERNAL_flushLogsBuffer)(this);
            }
        });
        if (enableLogs) {
            this.on('flush', ()=>{
                (0, $1Bl5D._INTERNAL_flushLogsBuffer)(this);
            });
            this.on('afterCaptureLog', ()=>{
                if (this._logFlushIdleTimeout) clearTimeout(this._logFlushIdleTimeout);
                this._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $1Bl5D._INTERNAL_flushLogsBuffer)(this);
                }, $53af93c8fd219543$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            this.on('postprocessEvent', (0, $gJTnt.addAutoIpAddressToUser));
            this.on('beforeSendSession', (0, $gJTnt.addAutoIpAddressToSession));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $f0UHX.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $f0UHX.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $53af93c8fd219543$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $quYvH.WINDOW).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}

});
parcelRegister("1Bl5D", function(module, exports) {
$parcel$export(module.exports, "_INTERNAL_flushLogsBuffer", () => $12a99b2dfa1c4fd9$export$f8ed83d3b6a0b504);

var $50ZDQ = parcelRequire("50ZDQ");

var $gGGDG = parcelRequire("gGGDG");

var $bQQos = parcelRequire("bQQos");

var $7Yg8V = parcelRequire("7Yg8V");

var $kTCdD = parcelRequire("kTCdD");

var $ipyIh = parcelRequire("ipyIh");

var $gtcuO = parcelRequire("gtcuO");

var $kxreP = parcelRequire("kxreP");

var $hQaCR = parcelRequire("hQaCR");

var $GExIy = parcelRequire("GExIy");

var $6WZlT = parcelRequire("6WZlT");
const $12a99b2dfa1c4fd9$var$MAX_LOG_BUFFER_SIZE = 100;
// The reference to the Client <> LogBuffer map is stored to ensure it's always the same
(0, $hQaCR.GLOBAL_OBJ)._sentryClientToLogBufferMap = new WeakMap();
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $12a99b2dfa1c4fd9$export$84cb46f4adfc5d14(value) {
    switch(typeof value){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $12a99b2dfa1c4fd9$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $12a99b2dfa1c4fd9$export$743ba6f7ec19225f(client, serializedLog) {
    const logBuffer = $12a99b2dfa1c4fd9$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) (0, $hQaCR.GLOBAL_OBJ)._sentryClientToLogBufferMap?.set(client, [
        serializedLog
    ]);
    else {
        (0, $hQaCR.GLOBAL_OBJ)._sentryClientToLogBufferMap?.set(client, [
            ...logBuffer,
            serializedLog
        ]);
        if (logBuffer.length >= $12a99b2dfa1c4fd9$var$MAX_LOG_BUFFER_SIZE) $12a99b2dfa1c4fd9$export$f8ed83d3b6a0b504(client, logBuffer);
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $12a99b2dfa1c4fd9$export$3ab3d16b9eebd986(beforeLog, client = (0, $gGGDG.getClient)(), currentScope = (0, $gGGDG.getCurrentScope)(), captureSerializedLog = $12a99b2dfa1c4fd9$export$743ba6f7ec19225f) {
    if (!client) {
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn('No client available to capture log.');
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments ?? {};
    if (!enableLogs) {
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $50ZDQ._getTraceInfoFromScope)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: user } = $12a99b2dfa1c4fd9$var$getMergedScopeData(currentScope);
    // Only attach user to log attributes if sendDefaultPii is enabled
    if (client.getOptions().sendDefaultPii) {
        const { id: id, email: email, username: username } = user;
        $12a99b2dfa1c4fd9$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
        $12a99b2dfa1c4fd9$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
        $12a99b2dfa1c4fd9$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    }
    $12a99b2dfa1c4fd9$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $12a99b2dfa1c4fd9$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $12a99b2dfa1c4fd9$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $12a99b2dfa1c4fd9$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const beforeLogMessage = beforeLog.message;
    if ((0, $ipyIh.isParameterizedString)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $kTCdD._getSpanForScope)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $12a99b2dfa1c4fd9$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    const log = beforeSendLog ? beforeSendLog(processedLog) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        timestamp: (0, $kxreP.timestampInSeconds)(),
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $GExIy.SEVERITY_TEXT_TO_SEVERITY_NUMBER)[level],
        attributes: Object.keys(attributes).reduce((acc, key)=>{
            acc[key] = $12a99b2dfa1c4fd9$export$84cb46f4adfc5d14(attributes[key]);
            return acc;
        }, {})
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $12a99b2dfa1c4fd9$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $12a99b2dfa1c4fd9$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $6WZlT.createLogEnvelope)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    (0, $hQaCR.GLOBAL_OBJ)._sentryClientToLogBufferMap?.set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $12a99b2dfa1c4fd9$export$5365c9902fb9e770(client) {
    return (0, $hQaCR.GLOBAL_OBJ)._sentryClientToLogBufferMap?.get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $12a99b2dfa1c4fd9$var$getMergedScopeData(currentScope) {
    const scopeData = (0, $gGGDG.getGlobalScope)().getScopeData();
    (0, $7Yg8V.mergeScopeData)(scopeData, (0, $gGGDG.getIsolationScope)().getScopeData());
    (0, $7Yg8V.mergeScopeData)(scopeData, currentScope.getScopeData());
    return scopeData;
}

});
parcelRegister("50ZDQ", function(module, exports) {
$parcel$export(module.exports, "Client", () => $3a6cc49a96093d98$export$1f2bb630327ac4b6);
$parcel$export(module.exports, "_getTraceInfoFromScope", () => $3a6cc49a96093d98$export$fb7d833b3fdedf5f);

var $ci9Sv = parcelRequire("ci9Sv");

var $bj6HP = parcelRequire("bj6HP");

var $gGGDG = parcelRequire("gGGDG");

var $bQQos = parcelRequire("bQQos");

var $4ORZn = parcelRequire("4ORZn");

var $byod0 = parcelRequire("byod0");

var $k0zpN = parcelRequire("k0zpN");

var $l37aq = parcelRequire("l37aq");

var $7aWfK = parcelRequire("7aWfK");

var $lOSPh = parcelRequire("lOSPh");

var $5h8Gr = parcelRequire("5h8Gr");

var $bjThL = parcelRequire("bjThL");

var $LH0Iq = parcelRequire("LH0Iq");

var $iyw1T = parcelRequire("iyw1T");

var $jMEVy = parcelRequire("jMEVy");

var $dN60t = parcelRequire("dN60t");

var $6iv17 = parcelRequire("6iv17");

var $ipyIh = parcelRequire("ipyIh");

var $gtcuO = parcelRequire("gtcuO");

var $53EVt = parcelRequire("53EVt");

var $h8Lht = parcelRequire("h8Lht");
/* eslint-disable max-lines */ const $3a6cc49a96093d98$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $3a6cc49a96093d98$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $3a6cc49a96093d98$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $3a6cc49a96093d98$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $3a6cc49a96093d98$var$_makeInternalError(message) {
    return {
        message: message,
        [$3a6cc49a96093d98$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $3a6cc49a96093d98$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$3a6cc49a96093d98$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $3a6cc49a96093d98$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $3a6cc49a96093d98$var$INTERNAL_ERROR_SYMBOL in error;
}
function $3a6cc49a96093d98$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $3a6cc49a96093d98$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $3a6cc49a96093d98$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $dN60t.makeDsn)(options.dsn);
        else (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $ci9Sv.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $53EVt.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $53EVt.checkOrSetAlreadyCaught)(exception)) {
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).log($3a6cc49a96093d98$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $53EVt.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $ipyIh.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $ipyIh.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $53EVt.uuid4)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $53EVt.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).log($3a6cc49a96093d98$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $k0zpN.updateSession)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $h8Lht.resolvedSyncPromise)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $byod0.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $byod0.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $4ORZn.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $6iv17.addItemToEnvelope)(env, (0, $6iv17.createAttachmentEnvelopeItem)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $bj6HP.DEFAULT_ENVIRONMENT) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn($3a6cc49a96093d98$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn($3a6cc49a96093d98$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $4ORZn.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).error('Transport disabled');
        return (0, $h8Lht.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $byod0.setupIntegrations)(this, integrations);
        (0, $byod0.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $k0zpN.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $h8Lht.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $bjThL.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $gGGDG.getTraceContextFromScope)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $l37aq.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $gGGDG.getCurrentScope)(), isolationScope = (0, $gGGDG.getIsolationScope)()) {
        if ((0, $bQQos.DEBUG_BUILD) && $3a6cc49a96093d98$var$isErrorEvent(event)) (0, $gtcuO.logger).log(`Captured error event \`${(0, $7aWfK.getPossibleEventMessages)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $bQQos.DEBUG_BUILD) {
                if ($3a6cc49a96093d98$var$_isDoNotSendEventError(reason)) (0, $gtcuO.logger).log(reason.message);
                else if ($3a6cc49a96093d98$var$_isInternalError(reason)) (0, $gtcuO.logger).warn(reason.message);
                else (0, $gtcuO.logger).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $3a6cc49a96093d98$var$isTransactionEvent(event);
        const isError = $3a6cc49a96093d98$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $5h8Gr.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $h8Lht.rejectedSyncPromise)($3a6cc49a96093d98$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $3a6cc49a96093d98$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $3a6cc49a96093d98$var$processBeforeSend(this, options, prepared, hint);
            return $3a6cc49a96093d98$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $3a6cc49a96093d98$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($3a6cc49a96093d98$var$_isDoNotSendEventError(reason) || $3a6cc49a96093d98$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $3a6cc49a96093d98$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $jMEVy.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $dN60t.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $3a6cc49a96093d98$export$4f22f74eddb7716a = $3a6cc49a96093d98$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $3a6cc49a96093d98$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $ipyIh.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $ipyIh.isPlainObject)(event) && event !== null) throw $3a6cc49a96093d98$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $3a6cc49a96093d98$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $ipyIh.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw $3a6cc49a96093d98$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $3a6cc49a96093d98$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($3a6cc49a96093d98$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($3a6cc49a96093d98$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $iyw1T.convertTransactionEventToSpanJson)(processedEvent));
            if (!processedRootSpanJson) (0, $LH0Iq.showSpanDropWarning)();
            else // update event with processed root span values
            processedEvent = (0, $lOSPh.merge)(event, (0, $iyw1T.convertSpanJsonToTransactionEvent)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $LH0Iq.showSpanDropWarning)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $3a6cc49a96093d98$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $3a6cc49a96093d98$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $3a6cc49a96093d98$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $gGGDG.withScope)(scope, ()=>{
        const span = (0, $LH0Iq.getActiveSpan)();
        const traceContext = span ? (0, $LH0Iq.spanToTraceContext)(span) : (0, $gGGDG.getTraceContextFromScope)(scope);
        const dynamicSamplingContext = span ? (0, $l37aq.getDynamicSamplingContextFromSpan)(span) : (0, $l37aq.getDynamicSamplingContextFromScope)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}

});
parcelRegister("4ORZn", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $3825b5fe31ffd66e$export$124b03c077baa2f3);
$parcel$export(module.exports, "createEventEnvelope", () => $3825b5fe31ffd66e$export$c31057337a18010f);

var $l37aq = parcelRequire("l37aq");

var $LH0Iq = parcelRequire("LH0Iq");

var $dN60t = parcelRequire("dN60t");

var $6iv17 = parcelRequire("6iv17");


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $3825b5fe31ffd66e$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $3825b5fe31ffd66e$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $6iv17.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $dN60t.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $6iv17.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $3825b5fe31ffd66e$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $6iv17.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $3825b5fe31ffd66e$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $6iv17.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $6iv17.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $3825b5fe31ffd66e$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $l37aq.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $dN60t.dsnToString)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $LH0Iq.spanToJSON)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $LH0Iq.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $LH0Iq.spanToJSON);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $6iv17.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $6iv17.createEnvelope)(headers, items);
}

});
parcelRegister("6iv17", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $495c7be19248e756$export$f93f7f385160c44e);
$parcel$export(module.exports, "addItemToEnvelope", () => $495c7be19248e756$export$d650323442802f6f);
$parcel$export(module.exports, "forEachEnvelopeItem", () => $495c7be19248e756$export$c56c55acf0136fd3);
$parcel$export(module.exports, "serializeEnvelope", () => $495c7be19248e756$export$32f9b428425aac85);
$parcel$export(module.exports, "createSpanEnvelopeItem", () => $495c7be19248e756$export$655cf139bc8b8afd);
$parcel$export(module.exports, "createAttachmentEnvelopeItem", () => $495c7be19248e756$export$d8fc80952cc31fa4);
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", () => $495c7be19248e756$export$b11169581eeaf237);
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", () => $495c7be19248e756$export$d369f3b2758f6743);
$parcel$export(module.exports, "createEventEnvelopeHeaders", () => $495c7be19248e756$export$92b6093782fe661b);

var $9wtZQ = parcelRequire("9wtZQ");

var $dN60t = parcelRequire("dN60t");

var $kTrk3 = parcelRequire("kTrk3");

var $hQaCR = parcelRequire("hQaCR");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $495c7be19248e756$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $495c7be19248e756$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $495c7be19248e756$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $495c7be19248e756$export$604a45d95a155e2b(envelope, types) {
    return $495c7be19248e756$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $495c7be19248e756$var$encodeUTF8(input) {
    const carrier = (0, $9wtZQ.getSentryCarrier)((0, $hQaCR.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $495c7be19248e756$var$decodeUTF8(input) {
    const carrier = (0, $9wtZQ.getSentryCarrier)((0, $hQaCR.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $495c7be19248e756$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $495c7be19248e756$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $495c7be19248e756$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $kTrk3.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $495c7be19248e756$var$concatBuffers(parts);
}
function $495c7be19248e756$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $495c7be19248e756$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $495c7be19248e756$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($495c7be19248e756$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $495c7be19248e756$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $495c7be19248e756$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $495c7be19248e756$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $495c7be19248e756$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $495c7be19248e756$export$b11169581eeaf237(type) {
    return $495c7be19248e756$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $495c7be19248e756$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $495c7be19248e756$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $dN60t.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}

});


parcelRegister("iyw1T", function(module, exports) {
$parcel$export(module.exports, "convertTransactionEventToSpanJson", () => $d8243f5ce7e6120e$export$d9c6b2464b0a687e);
$parcel$export(module.exports, "convertSpanJsonToTransactionEvent", () => $d8243f5ce7e6120e$export$f2d8fce5ae150e92);

var $5F3Lb = parcelRequire("5F3Lb");
/**
 * Converts a transaction event to a span JSON object.
 */ function $d8243f5ce7e6120e$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $5F3Lb.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[0, $5F3Lb.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $d8243f5ce7e6120e$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $5F3Lb.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $5F3Lb.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}

});

parcelRegister("jMEVy", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $e6723f57d9f2f519$export$f3b9ed77c03eeb00);

var $6iv17 = parcelRequire("6iv17");

var $kxreP = parcelRequire("kxreP");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $e6723f57d9f2f519$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $kxreP.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $6iv17.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});


parcelRegister("GExIy", function(module, exports) {
$parcel$export(module.exports, "SEVERITY_TEXT_TO_SEVERITY_NUMBER", () => $08035f51fca46aca$export$4fb50c0840d636d1);
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $08035f51fca46aca$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};

});

parcelRegister("6WZlT", function(module, exports) {
$parcel$export(module.exports, "createLogEnvelope", () => $50f7c01d50d14826$export$cdcd668e6516443f);

var $dN60t = parcelRequire("dN60t");

var $6iv17 = parcelRequire("6iv17");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $50f7c01d50d14826$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $50f7c01d50d14826$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $dN60t.dsnToString)(dsn);
    return (0, $6iv17.createEnvelope)(headers, [
        $50f7c01d50d14826$export$efdf3b13edb1118e(logs)
    ]);
}

});


parcelRegister("gJTnt", function(module, exports) {
$parcel$export(module.exports, "addAutoIpAddressToUser", () => $c2fbce2270a9f4cb$export$3e12ad68afa434ac);
$parcel$export(module.exports, "addAutoIpAddressToSession", () => $c2fbce2270a9f4cb$export$e8e2d07ba63e2b6c);
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $c2fbce2270a9f4cb$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $c2fbce2270a9f4cb$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}

});

parcelRegister("iPHMx", function(module, exports) {
$parcel$export(module.exports, "applySdkMetadata", () => $db5ef393d88f7a83$export$b9f95b027256052c);

var $1jIno = parcelRequire("1jIno");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $db5ef393d88f7a83$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $1jIno.SDK_VERSION)
            })),
        version: (0, $1jIno.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("6PzCs", function(module, exports) {
$parcel$export(module.exports, "getSDKSource", () => $4f9322c3e1f13fda$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $4f9322c3e1f13fda$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $4f9322c3e1f13fda$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});

parcelRegister("f0UHX", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $aee2d820ca204849$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $aee2d820ca204849$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $aee2d820ca204849$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $aee2d820ca204849$export$5425b53185d13d6c);

var $53EVt = parcelRequire("53EVt");
var $5qWPd = parcelRequire("5qWPd");
var $gGGDG = parcelRequire("gGGDG");
var $ipyIh = parcelRequire("ipyIh");
var $kTrk3 = parcelRequire("kTrk3");
var $h8Lht = parcelRequire("h8Lht");
/**
 * This function creates an exception from a JavaScript Error
 */ function $aee2d820ca204849$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $aee2d820ca204849$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $aee2d820ca204849$export$2e9ae379995d99e3(ex),
        value: $aee2d820ca204849$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $aee2d820ca204849$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $gGGDG.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $aee2d820ca204849$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $kTrk3.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $aee2d820ca204849$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $ipyIh.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $aee2d820ca204849$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $aee2d820ca204849$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $aee2d820ca204849$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $aee2d820ca204849$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $aee2d820ca204849$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $aee2d820ca204849$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $aee2d820ca204849$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $aee2d820ca204849$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $aee2d820ca204849$var$getSkipFirstStackStringLines(ex) {
    if (ex && $aee2d820ca204849$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $aee2d820ca204849$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $aee2d820ca204849$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $aee2d820ca204849$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $aee2d820ca204849$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $aee2d820ca204849$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($aee2d820ca204849$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $aee2d820ca204849$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $aee2d820ca204849$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $53EVt.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $h8Lht.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $aee2d820ca204849$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $aee2d820ca204849$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $h8Lht.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $aee2d820ca204849$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $ipyIh.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $aee2d820ca204849$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $ipyIh.isDOMError)(exception) || (0, $ipyIh.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $aee2d820ca204849$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $ipyIh.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $aee2d820ca204849$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $53EVt.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $ipyIh.isError)(exception)) // we have a real Error object, do nothing
    return $aee2d820ca204849$var$eventFromError(stackParser, exception);
    if ((0, $ipyIh.isPlainObject)(exception) || (0, $ipyIh.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $aee2d820ca204849$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $53EVt.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $aee2d820ca204849$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $53EVt.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $53EVt.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $aee2d820ca204849$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $aee2d820ca204849$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $53EVt.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $ipyIh.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $aee2d820ca204849$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $5qWPd.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $ipyIh.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $ipyIh.isEvent)(exception)) {
        const className = $aee2d820ca204849$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $aee2d820ca204849$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $aee2d820ca204849$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}

});


parcelRegister("6akPy", function(module, exports) {
$parcel$export(module.exports, "breadcrumbsIntegration", () => $47d3d5bf795f90a0$export$c079d904b326663a);

var $bvaV0 = parcelRequire("bvaV0");
var $koqec = parcelRequire("koqec");
var $lHL6l = parcelRequire("lHL6l");
var $byod0 = parcelRequire("byod0");
var $jRndf = parcelRequire("jRndf");
var $gGGDG = parcelRequire("gGGDG");
var $bgZ7T = parcelRequire("bgZ7T");
var $53EVt = parcelRequire("53EVt");
var $gtcuO = parcelRequire("gtcuO");
var $1JYNh = parcelRequire("1JYNh");
var $6YXbs = parcelRequire("6YXbs");
var $eOXYF = parcelRequire("eOXYF");

var $iMR8j = parcelRequire("iMR8j");
var $1m4Y4 = parcelRequire("1m4Y4");
var $i7ndJ = parcelRequire("i7ndJ");

var $faoOk = parcelRequire("faoOk");

var $quYvH = parcelRequire("quYvH");
/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $47d3d5bf795f90a0$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $47d3d5bf795f90a0$var$INTEGRATION_NAME = 'Breadcrumbs';
const $47d3d5bf795f90a0$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $47d3d5bf795f90a0$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $koqec.addConsoleInstrumentationHandler)($47d3d5bf795f90a0$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $iMR8j.addClickKeypressInstrumentationHandler)($47d3d5bf795f90a0$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $i7ndJ.addXhrInstrumentationHandler)($47d3d5bf795f90a0$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $lHL6l.addFetchInstrumentationHandler)($47d3d5bf795f90a0$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $1m4Y4.addHistoryInstrumentationHandler)($47d3d5bf795f90a0$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $47d3d5bf795f90a0$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $47d3d5bf795f90a0$export$c079d904b326663a = (0, $byod0.defineIntegration)($47d3d5bf795f90a0$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $47d3d5bf795f90a0$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $gGGDG.getClient)() !== client) return;
        (0, $bvaV0.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $53EVt.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $47d3d5bf795f90a0$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $gGGDG.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $47d3d5bf795f90a0$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $faoOk.DEBUG_BUILD) && (0, $gtcuO.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$47d3d5bf795f90a0$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$47d3d5bf795f90a0$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $47d3d5bf795f90a0$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $47d3d5bf795f90a0$var$_isEvent(event) ? event.target : event;
            target = (0, $bgZ7T.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $bgZ7T.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $bvaV0.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $47d3d5bf795f90a0$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $gGGDG.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $eOXYF.severityLevelFromString)(handlerData.level),
            message: (0, $6YXbs.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $6YXbs.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $bvaV0.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $47d3d5bf795f90a0$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $gGGDG.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $i7ndJ.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $jRndf.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $bvaV0.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $47d3d5bf795f90a0$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $gGGDG.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $bvaV0.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $jRndf.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $bvaV0.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $47d3d5bf795f90a0$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $gGGDG.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $1JYNh.parseUrl)((0, $quYvH.WINDOW).location.href);
        let parsedFrom = from ? (0, $1JYNh.parseUrl)(from) : undefined;
        const parsedTo = (0, $1JYNh.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $bvaV0.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $47d3d5bf795f90a0$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("bvaV0", function(module, exports) {
$parcel$export(module.exports, "addBreadcrumb", () => $85fb0f25fbcd3011$export$efda9a273d7a036d);

var $gGGDG = parcelRequire("gGGDG");

var $gtcuO = parcelRequire("gtcuO");

var $kxreP = parcelRequire("kxreP");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $85fb0f25fbcd3011$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $85fb0f25fbcd3011$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $gGGDG.getClient)();
    const isolationScope = (0, $gGGDG.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $85fb0f25fbcd3011$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $kxreP.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $gtcuO.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

});

parcelRegister("koqec", function(module, exports) {
$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $ed8a64e0e55819cb$export$1d6e0d073f9e6723);

var $gtcuO = parcelRequire("gtcuO");

var $5qWPd = parcelRequire("5qWPd");

var $hQaCR = parcelRequire("hQaCR");

var $7L3j6 = parcelRequire("7L3j6");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ed8a64e0e55819cb$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $7L3j6.addHandler)(type, handler);
    (0, $7L3j6.maybeInstrument)(type, $ed8a64e0e55819cb$var$instrumentConsole);
}
function $ed8a64e0e55819cb$var$instrumentConsole() {
    if (!('console' in (0, $hQaCR.GLOBAL_OBJ))) return;
    (0, $gtcuO.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $hQaCR.GLOBAL_OBJ).console)) return;
        (0, $5qWPd.fill)((0, $hQaCR.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $gtcuO.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $7L3j6.triggerHandlers)('console', handlerData);
                const log = (0, $gtcuO.originalConsoleMethods)[level];
                log?.apply((0, $hQaCR.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("jRndf", function(module, exports) {
$parcel$export(module.exports, "getBreadcrumbLogLevelFromHttpStatusCode", () => $e754f91b39c5990a$export$b8cfcc4175694bcc);
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $e754f91b39c5990a$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

});

parcelRegister("1JYNh", function(module, exports) {
$parcel$export(module.exports, "parseUrl", () => $144926cceefb8256$export$7a5253c0f62e0150);

var $5F3Lb = parcelRequire("5F3Lb");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $144926cceefb8256$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $144926cceefb8256$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $144926cceefb8256$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $144926cceefb8256$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $144926cceefb8256$export$5339fcdc8e2a427c(url) {
    if ($144926cceefb8256$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $144926cceefb8256$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $144926cceefb8256$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $144926cceefb8256$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $5F3Lb.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $5F3Lb.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $5F3Lb.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request?.method) attributes[0, $5F3Lb.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $5F3Lb.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!$144926cceefb8256$export$e258e13805402ba7(urlObject)) {
            attributes[0, $5F3Lb.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $144926cceefb8256$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $144926cceefb8256$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $144926cceefb8256$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $144926cceefb8256$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("eOXYF", function(module, exports) {
$parcel$export(module.exports, "severityLevelFromString", () => $aca4427aba6f717e$export$d771ef054122c30a);
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $aca4427aba6f717e$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}

});

parcelRegister("iMR8j", function(module, exports) {
$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", () => $dad5ecca0222c04c$export$5aeffd3db2cf9df7);

var $7L3j6 = parcelRequire("7L3j6");
var $5qWPd = parcelRequire("5qWPd");
var $53EVt = parcelRequire("53EVt");

var $bw7iO = parcelRequire("bw7iO");
const $dad5ecca0222c04c$var$DEBOUNCE_DURATION = 1000;
let $dad5ecca0222c04c$var$debounceTimerID;
let $dad5ecca0222c04c$var$lastCapturedEventType;
let $dad5ecca0222c04c$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $dad5ecca0222c04c$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $7L3j6.addHandler)(type, handler);
    (0, $7L3j6.maybeInstrument)(type, $dad5ecca0222c04c$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $dad5ecca0222c04c$export$3014bbf0af0e1d4a() {
    if (!(0, $bw7iO.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $7L3j6.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $dad5ecca0222c04c$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $bw7iO.WINDOW).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $bw7iO.WINDOW).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $bw7iO.WINDOW);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $5qWPd.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $dad5ecca0222c04c$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $5qWPd.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $dad5ecca0222c04c$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $dad5ecca0222c04c$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $dad5ecca0222c04c$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $dad5ecca0222c04c$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $dad5ecca0222c04c$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $dad5ecca0222c04c$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($dad5ecca0222c04c$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $5qWPd.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $5qWPd.addNonEnumerableProperty)(target, '_sentryId', (0, $53EVt.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$dad5ecca0222c04c$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $dad5ecca0222c04c$var$lastCapturedEventType = event.type;
            $dad5ecca0222c04c$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($dad5ecca0222c04c$var$debounceTimerID);
        $dad5ecca0222c04c$var$debounceTimerID = (0, $bw7iO.WINDOW).setTimeout(()=>{
            $dad5ecca0222c04c$var$lastCapturedEventTargetId = undefined;
            $dad5ecca0222c04c$var$lastCapturedEventType = undefined;
        }, $dad5ecca0222c04c$var$DEBOUNCE_DURATION);
    };
}
function $dad5ecca0222c04c$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("1m4Y4", function(module, exports) {
$parcel$export(module.exports, "addHistoryInstrumentationHandler", () => $0fcbb307c2bdc775$export$3f18c56c58114e75);

var $7L3j6 = parcelRequire("7L3j6");
var $5qWPd = parcelRequire("5qWPd");
var $aQI6w = parcelRequire("aQI6w");

var $bw7iO = parcelRequire("bw7iO");
let $0fcbb307c2bdc775$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0fcbb307c2bdc775$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $7L3j6.addHandler)(type, handler);
    (0, $7L3j6.maybeInstrument)(type, $0fcbb307c2bdc775$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $0fcbb307c2bdc775$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $bw7iO.WINDOW).addEventListener('popstate', ()=>{
        const to = (0, $bw7iO.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $0fcbb307c2bdc775$var$lastHref;
        $0fcbb307c2bdc775$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $7L3j6.triggerHandlers)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $aQI6w.supportsHistory)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $0fcbb307c2bdc775$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $0fcbb307c2bdc775$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $0fcbb307c2bdc775$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $7L3j6.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $5qWPd.fill)((0, $bw7iO.WINDOW).history, 'pushState', historyReplacementFunction);
    (0, $5qWPd.fill)((0, $bw7iO.WINDOW).history, 'replaceState', historyReplacementFunction);
}
function $0fcbb307c2bdc775$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $bw7iO.WINDOW).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}

});


parcelRegister("kueAu", function(module, exports) {
$parcel$export(module.exports, "browserApiErrorsIntegration", () => $eea1ecc2297dee8d$export$59bfe9f1c76150e);

var $byod0 = parcelRequire("byod0");
var $5qWPd = parcelRequire("5qWPd");
var $e19TC = parcelRequire("e19TC");

var $quYvH = parcelRequire("quYvH");
const $eea1ecc2297dee8d$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $eea1ecc2297dee8d$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $eea1ecc2297dee8d$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $eea1ecc2297dee8d$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $5qWPd.fill)((0, $quYvH.WINDOW), 'setTimeout', $eea1ecc2297dee8d$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $5qWPd.fill)((0, $quYvH.WINDOW), 'setInterval', $eea1ecc2297dee8d$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $5qWPd.fill)((0, $quYvH.WINDOW), 'requestAnimationFrame', $eea1ecc2297dee8d$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $quYvH.WINDOW)) (0, $5qWPd.fill)(XMLHttpRequest.prototype, 'send', $eea1ecc2297dee8d$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $eea1ecc2297dee8d$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$eea1ecc2297dee8d$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $eea1ecc2297dee8d$export$59bfe9f1c76150e = (0, $byod0.defineIntegration)($eea1ecc2297dee8d$var$_browserApiErrorsIntegration);
function $eea1ecc2297dee8d$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $quYvH.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $e19TC.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $eea1ecc2297dee8d$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $quYvH.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $e19TC.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $eea1ecc2297dee8d$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $5qWPd.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $e19TC.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $5qWPd.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $e19TC.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $quYvH.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $eea1ecc2297dee8d$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $quYvH.WINDOW);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $5qWPd.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($eea1ecc2297dee8d$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $quYvH.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $e19TC.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $eea1ecc2297dee8d$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $quYvH.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $e19TC.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $5qWPd.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $eea1ecc2297dee8d$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $eea1ecc2297dee8d$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}

});

parcelRegister("aMtRl", function(module, exports) {
$parcel$export(module.exports, "browserSessionIntegration", () => $7d958c869eb9350d$export$1baa7880e357371c);

var $9QeFV = parcelRequire("9QeFV");
var $byod0 = parcelRequire("byod0");
var $gtcuO = parcelRequire("gtcuO");

var $1m4Y4 = parcelRequire("1m4Y4");

var $faoOk = parcelRequire("faoOk");

var $quYvH = parcelRequire("quYvH");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $7d958c869eb9350d$export$1baa7880e357371c = (0, $byod0.defineIntegration)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $quYvH.WINDOW).document === 'undefined') {
                (0, $faoOk.DEBUG_BUILD) && (0, $gtcuO.logger).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $9QeFV.startSession)({
                ignoreDuration: true
            });
            (0, $9QeFV.captureSession)();
            // We want to create a session for every navigation as well
            (0, $1m4Y4.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $9QeFV.startSession)({
                        ignoreDuration: true
                    });
                    (0, $9QeFV.captureSession)();
                }
            });
        }
    };
});

});

parcelRegister("lfYGT", function(module, exports) {
$parcel$export(module.exports, "globalHandlersIntegration", () => $f79a139c1a443fc9$export$66acc70e8cf2b71a);

var $hxMct = parcelRequire("hxMct");
var $lqPVD = parcelRequire("lqPVD");
var $9QeFV = parcelRequire("9QeFV");
var $byod0 = parcelRequire("byod0");
var $gGGDG = parcelRequire("gGGDG");
var $bgZ7T = parcelRequire("bgZ7T");
var $ipyIh = parcelRequire("ipyIh");
var $gtcuO = parcelRequire("gtcuO");
var $e19TC = parcelRequire("e19TC");

var $faoOk = parcelRequire("faoOk");

var $f0UHX = parcelRequire("f0UHX");

var $quYvH = parcelRequire("quYvH");
const $f79a139c1a443fc9$var$INTEGRATION_NAME = 'GlobalHandlers';
const $f79a139c1a443fc9$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $f79a139c1a443fc9$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $f79a139c1a443fc9$var$_installGlobalOnErrorHandler(client);
                $f79a139c1a443fc9$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $f79a139c1a443fc9$var$_installGlobalOnUnhandledRejectionHandler(client);
                $f79a139c1a443fc9$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $f79a139c1a443fc9$export$66acc70e8cf2b71a = (0, $byod0.defineIntegration)($f79a139c1a443fc9$var$_globalHandlersIntegration);
function $f79a139c1a443fc9$var$_installGlobalOnErrorHandler(client) {
    (0, $hxMct.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $f79a139c1a443fc9$var$getOptions();
        if ((0, $gGGDG.getClient)() !== client || (0, $quYvH.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $f79a139c1a443fc9$var$_enhanceEventWithInitialFrame((0, $f0UHX.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $9QeFV.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $f79a139c1a443fc9$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $lqPVD.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $f79a139c1a443fc9$var$getOptions();
        if ((0, $gGGDG.getClient)() !== client || (0, $quYvH.shouldIgnoreOnError)()) return;
        const error = $f79a139c1a443fc9$var$_getUnhandledRejectionError(e);
        const event = (0, $ipyIh.isPrimitive)(error) ? $f79a139c1a443fc9$var$_eventFromRejectionWithPrimitive(error) : (0, $f0UHX.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $9QeFV.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $f79a139c1a443fc9$var$_getUnhandledRejectionError(error) {
    if ((0, $ipyIh.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $f79a139c1a443fc9$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $f79a139c1a443fc9$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $ipyIh.isString)(url) && url.length > 0 ? url : (0, $bgZ7T.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $e19TC.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $f79a139c1a443fc9$var$globalHandlerLog(type) {
    (0, $faoOk.DEBUG_BUILD) && (0, $gtcuO.logger).log(`Global Handler attached: ${type}`);
}
function $f79a139c1a443fc9$var$getOptions() {
    const client = (0, $gGGDG.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("hxMct", function(module, exports) {
$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $cc5ae8446604a75a$export$55b5c3ba2194f0c6);

var $hQaCR = parcelRequire("hQaCR");

var $7L3j6 = parcelRequire("7L3j6");
let $cc5ae8446604a75a$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $cc5ae8446604a75a$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $7L3j6.addHandler)(type, handler);
    (0, $7L3j6.maybeInstrument)(type, $cc5ae8446604a75a$var$instrumentError);
}
function $cc5ae8446604a75a$var$instrumentError() {
    $cc5ae8446604a75a$var$_oldOnErrorHandler = (0, $hQaCR.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $hQaCR.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $7L3j6.triggerHandlers)('error', handlerData);
        if ($cc5ae8446604a75a$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $cc5ae8446604a75a$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $hQaCR.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("lqPVD", function(module, exports) {
$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $f9a44ea249211fa0$export$8bf4fc6858821a4e);

var $hQaCR = parcelRequire("hQaCR");

var $7L3j6 = parcelRequire("7L3j6");
let $f9a44ea249211fa0$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f9a44ea249211fa0$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $7L3j6.addHandler)(type, handler);
    (0, $7L3j6.maybeInstrument)(type, $f9a44ea249211fa0$var$instrumentUnhandledRejection);
}
function $f9a44ea249211fa0$var$instrumentUnhandledRejection() {
    $f9a44ea249211fa0$var$_oldOnUnhandledRejectionHandler = (0, $hQaCR.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $hQaCR.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $7L3j6.triggerHandlers)('unhandledrejection', handlerData);
        if ($f9a44ea249211fa0$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $f9a44ea249211fa0$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $hQaCR.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("l7aEi", function(module, exports) {
$parcel$export(module.exports, "httpContextIntegration", () => $f5f28318f05f3afe$export$1378794447170364);

var $byod0 = parcelRequire("byod0");

var $quYvH = parcelRequire("quYvH");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $f5f28318f05f3afe$export$1378794447170364 = (0, $byod0.defineIntegration)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $quYvH.WINDOW).navigator && !(0, $quYvH.WINDOW).location && !(0, $quYvH.WINDOW).document) return;
            const reqData = (0, $quYvH.getHttpRequestData)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        }
    };
});

});

parcelRegister("8hb3R", function(module, exports) {
$parcel$export(module.exports, "linkedErrorsIntegration", () => $60687dcb8c4e8ab9$export$ebabb00eb7f3a395);

var $fsBuF = parcelRequire("fsBuF");
var $byod0 = parcelRequire("byod0");

var $f0UHX = parcelRequire("f0UHX");
const $60687dcb8c4e8ab9$var$DEFAULT_KEY = 'cause';
const $60687dcb8c4e8ab9$var$DEFAULT_LIMIT = 5;
const $60687dcb8c4e8ab9$var$INTEGRATION_NAME = 'LinkedErrors';
const $60687dcb8c4e8ab9$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $60687dcb8c4e8ab9$var$DEFAULT_LIMIT;
    const key = options.key || $60687dcb8c4e8ab9$var$DEFAULT_KEY;
    return {
        name: $60687dcb8c4e8ab9$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $fsBuF.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $f0UHX.exceptionFromError), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $60687dcb8c4e8ab9$export$ebabb00eb7f3a395 = (0, $byod0.defineIntegration)($60687dcb8c4e8ab9$var$_linkedErrorsIntegration);

});
parcelRegister("fsBuF", function(module, exports) {
$parcel$export(module.exports, "applyAggregateErrorsToEvent", () => $b4168e020cb8cd94$export$b91c38ed7d8ae9b2);

var $ipyIh = parcelRequire("ipyIh");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $b4168e020cb8cd94$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $ipyIh.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $b4168e020cb8cd94$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $b4168e020cb8cd94$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $ipyIh.isInstanceOf)(error[key], Error)) {
        $b4168e020cb8cd94$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $b4168e020cb8cd94$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $b4168e020cb8cd94$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $ipyIh.isInstanceOf)(childError, Error)) {
            $b4168e020cb8cd94$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $b4168e020cb8cd94$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $b4168e020cb8cd94$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $b4168e020cb8cd94$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $b4168e020cb8cd94$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}

});


parcelRegister("7vT6J", function(module, exports) {
$parcel$export(module.exports, "defaultStackParser", () => $57862cdf085b267f$export$2b2b997d81bf3907);

var $e19TC = parcelRequire("e19TC");
const $57862cdf085b267f$var$OPERA10_PRIORITY = 10;
const $57862cdf085b267f$var$OPERA11_PRIORITY = 20;
const $57862cdf085b267f$var$CHROME_PRIORITY = 30;
const $57862cdf085b267f$var$WINJS_PRIORITY = 40;
const $57862cdf085b267f$var$GECKO_PRIORITY = 50;
function $57862cdf085b267f$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $e19TC.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $57862cdf085b267f$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $57862cdf085b267f$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $57862cdf085b267f$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $57862cdf085b267f$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $57862cdf085b267f$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $57862cdf085b267f$var$createFrame(filename, (0, $e19TC.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $57862cdf085b267f$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $57862cdf085b267f$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $57862cdf085b267f$var$extractSafariExtensionDetails(parts[1] || (0, $e19TC.UNKNOWN_FUNCTION), parts[2]);
        return $57862cdf085b267f$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $57862cdf085b267f$export$263a749fff749872 = [
    $57862cdf085b267f$var$CHROME_PRIORITY,
    $57862cdf085b267f$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $57862cdf085b267f$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $57862cdf085b267f$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $57862cdf085b267f$var$gecko = (line)=>{
    const parts = $57862cdf085b267f$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $57862cdf085b267f$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $e19TC.UNKNOWN_FUNCTION);
        [func, filename] = $57862cdf085b267f$var$extractSafariExtensionDetails(func, filename);
        return $57862cdf085b267f$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $57862cdf085b267f$export$cdba47a5dd2804d = [
    $57862cdf085b267f$var$GECKO_PRIORITY,
    $57862cdf085b267f$var$gecko
];
const $57862cdf085b267f$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $57862cdf085b267f$var$winjs = (line)=>{
    const parts = $57862cdf085b267f$var$winjsRegex.exec(line);
    return parts ? $57862cdf085b267f$var$createFrame(parts[2], parts[1] || (0, $e19TC.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $57862cdf085b267f$export$179460296da408e8 = [
    $57862cdf085b267f$var$WINJS_PRIORITY,
    $57862cdf085b267f$var$winjs
];
const $57862cdf085b267f$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $57862cdf085b267f$var$opera10 = (line)=>{
    const parts = $57862cdf085b267f$var$opera10Regex.exec(line);
    return parts ? $57862cdf085b267f$var$createFrame(parts[2], parts[3] || (0, $e19TC.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $57862cdf085b267f$export$f892b52c880ffc7a = [
    $57862cdf085b267f$var$OPERA10_PRIORITY,
    $57862cdf085b267f$var$opera10
];
const $57862cdf085b267f$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $57862cdf085b267f$var$opera11 = (line)=>{
    const parts = $57862cdf085b267f$var$opera11Regex.exec(line);
    return parts ? $57862cdf085b267f$var$createFrame(parts[5], parts[3] || parts[4] || (0, $e19TC.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $57862cdf085b267f$export$af11af13f09fb0dc = [
    $57862cdf085b267f$var$OPERA11_PRIORITY,
    $57862cdf085b267f$var$opera11
];
const $57862cdf085b267f$export$7197c0fe6554c079 = [
    $57862cdf085b267f$export$263a749fff749872,
    $57862cdf085b267f$export$cdba47a5dd2804d
];
const $57862cdf085b267f$export$2b2b997d81bf3907 = (0, $e19TC.createStackParser)(...$57862cdf085b267f$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $57862cdf085b267f$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $e19TC.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("4OMEk", function(module, exports) {
$parcel$export(module.exports, "makeFetchTransport", () => $382191b35a199ee2$export$b2311068c46d7cc8);

var $8hRZZ = parcelRequire("8hRZZ");
var $h8Lht = parcelRequire("h8Lht");

var $aiz30 = parcelRequire("aiz30");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $382191b35a199ee2$export$b2311068c46d7cc8(options, nativeFetch = (0, $aiz30.getNativeImplementation)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $aiz30.clearCachedImplementation)('fetch');
            return (0, $h8Lht.rejectedSyncPromise)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $aiz30.clearCachedImplementation)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $h8Lht.rejectedSyncPromise)(e);
        }
    }
    return (0, $8hRZZ.createTransport)(options, makeRequest);
}

});
parcelRegister("8hRZZ", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $6089cc4dcd37b392$export$d09f50d9ab7f7b69);

var $bQQos = parcelRequire("bQQos");

var $6iv17 = parcelRequire("6iv17");

var $gtcuO = parcelRequire("gtcuO");

var $gaPjr = parcelRequire("gaPjr");

var $7lMKo = parcelRequire("7lMKo");

var $h8Lht = parcelRequire("h8Lht");
const $6089cc4dcd37b392$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $6089cc4dcd37b392$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $gaPjr.makePromiseBuffer)(options.bufferSize || $6089cc4dcd37b392$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $6iv17.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $6iv17.envelopeItemTypeToDataCategory)(type);
            if ((0, $7lMKo.isRateLimited)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $h8Lht.resolvedSyncPromise)({});
        const filteredEnvelope = (0, $6iv17.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $6iv17.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $6iv17.envelopeItemTypeToDataCategory)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $6iv17.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $7lMKo.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $gaPjr.SENTRY_BUFFER_FULL_ERROR)) {
                (0, $bQQos.DEBUG_BUILD) && (0, $gtcuO.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $h8Lht.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}

});
parcelRegister("gaPjr", function(module, exports) {
$parcel$export(module.exports, "SENTRY_BUFFER_FULL_ERROR", () => $bc65621fc2b0a1b5$export$c8667f1887a128dc);
$parcel$export(module.exports, "makePromiseBuffer", () => $bc65621fc2b0a1b5$export$85a4f67f852183e6);

var $h8Lht = parcelRequire("h8Lht");
const $bc65621fc2b0a1b5$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $bc65621fc2b0a1b5$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $h8Lht.rejectedSyncPromise)($bc65621fc2b0a1b5$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $h8Lht.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $h8Lht.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});

parcelRegister("7lMKo", function(module, exports) {
$parcel$export(module.exports, "isRateLimited", () => $55a04ec6a1969a9b$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $55a04ec6a1969a9b$export$699aff705e0d49d4);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $55a04ec6a1969a9b$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $55a04ec6a1969a9b$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $55a04ec6a1969a9b$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $55a04ec6a1969a9b$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $55a04ec6a1969a9b$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $55a04ec6a1969a9b$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $55a04ec6a1969a9b$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $55a04ec6a1969a9b$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});


parcelRegister("aiz30", function(module, exports) {
$parcel$export(module.exports, "getNativeImplementation", () => $77f6c58368850045$export$e464f4a514ac28a8);
$parcel$export(module.exports, "clearCachedImplementation", () => $77f6c58368850045$export$8aa36702e8c8978);

var $aQI6w = parcelRequire("aQI6w");
var $gtcuO = parcelRequire("gtcuO");

var $4FuA0 = parcelRequire("4FuA0");

var $bw7iO = parcelRequire("bw7iO");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $77f6c58368850045$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $77f6c58368850045$export$e464f4a514ac28a8(name) {
    const cached = $77f6c58368850045$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $bw7iO.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, $aQI6w.isNativeFunction)(impl)) return $77f6c58368850045$var$cachedImplementations[name] = impl.bind((0, $bw7iO.WINDOW));
    const document = (0, $bw7iO.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $4FuA0.DEBUG_BUILD) && (0, $gtcuO.logger).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $77f6c58368850045$var$cachedImplementations[name] = impl.bind((0, $bw7iO.WINDOW));
}
/** Clear a cached implementation. */ function $77f6c58368850045$export$8aa36702e8c8978(name) {
    $77f6c58368850045$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $77f6c58368850045$export$e7aa7bc5c1b3cfb3(...rest) {
    return $77f6c58368850045$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $77f6c58368850045$export$831dc9f2ab0a617b(...rest) {
    return $77f6c58368850045$export$e464f4a514ac28a8('setTimeout')(...rest);
}

});
parcelRegister("4FuA0", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $3662b63e03484430$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $3662b63e03484430$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});



parcelRegister("cYOqF", function(module, exports) {
$parcel$export(module.exports, "checkAndWarnIfIsEmbeddedBrowserExtension", () => $973234cc024afdd2$export$dc236a86065879fc);

var $gtcuO = parcelRequire("gtcuO");
var $bgZ7T = parcelRequire("bgZ7T");

var $faoOk = parcelRequire("faoOk");

var $quYvH = parcelRequire("quYvH");
/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $973234cc024afdd2$export$dc236a86065879fc() {
    if ($973234cc024afdd2$var$_isEmbeddedBrowserExtension()) {
        if (0, $faoOk.DEBUG_BUILD) (0, $gtcuO.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $973234cc024afdd2$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $quYvH.WINDOW).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $quYvH.WINDOW);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $bgZ7T.getLocationHref)();
    const extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $quYvH.WINDOW) === (0, $quYvH.WINDOW).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}

});



parcelRegister("6r4PX", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("dk9MR")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("dk9MR")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("l5nIk")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("l5nIk")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("bqFtF")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("bqFtF")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => (parcelRequire("aRa1h")).MEDIA_CONTEXT);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("9kHBl")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => (parcelRequire("9kHBl")).PeopleTeamsAnalyticsContext);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("6lHdS")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => (parcelRequire("6lHdS")).NotificationsAnalyticsContext);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("8l1L9")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => (parcelRequire("8l1L9")).RecentWorkAnalyticsContext);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("bco7U")).ATLAS_CONTEXT);
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => (parcelRequire("6dYrq")).TOWNSQUARE_HOME_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("1OSIV")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("1pTsB")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => (parcelRequire("1pTsB")).PostOfficeAnalyticsContext);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("7RZOc")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => (parcelRequire("7RZOc")).AIMateAnalyticsContext);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("avy8H")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("i9ClG")).GROWTH_CONTEXT);
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => (parcelRequire("6dirE")).OMNI_CHANNEL_CONTEXT);
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => (parcelRequire("4YJTV")).ROVO_EXTENSION_CONTEXT);

var $dk9MR = parcelRequire("dk9MR");

var $l5nIk = parcelRequire("l5nIk");

var $bqFtF = parcelRequire("bqFtF");

var $aRa1h = parcelRequire("aRa1h");

var $9kHBl = parcelRequire("9kHBl");

var $6lHdS = parcelRequire("6lHdS");

var $8l1L9 = parcelRequire("8l1L9");

var $bco7U = parcelRequire("bco7U");

var $6dYrq = parcelRequire("6dYrq");

var $1OSIV = parcelRequire("1OSIV");

var $1pTsB = parcelRequire("1pTsB");

var $7RZOc = parcelRequire("7RZOc");

var $avy8H = parcelRequire("avy8H");

var $i9ClG = parcelRequire("i9ClG");

var $6dirE = parcelRequire("6dirE");

var $4YJTV = parcelRequire("4YJTV");

});
parcelRegister("dk9MR", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $47fdf5026f1f91ad$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $47fdf5026f1f91ad$export$3fe25500478a635c);

var $8xwjd = parcelRequire("8xwjd");
const $47fdf5026f1f91ad$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $47fdf5026f1f91ad$export$3fe25500478a635c = (0, $8xwjd.default)($47fdf5026f1f91ad$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("8xwjd", function(module, exports) {
$parcel$export(module.exports, "default", () => $e16ae88fef547cfa$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $50OLG = parcelRequire("50OLG");
const $e16ae88fef547cfa$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $50OLG.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $e16ae88fef547cfa$export$2e2bcd8739ae039 = $e16ae88fef547cfa$var$createNamespaceContext;

});


parcelRegister("l5nIk", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $d4ebd3e41aae7c8a$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $d4ebd3e41aae7c8a$export$d0a82da1a0b94929);

var $8xwjd = parcelRequire("8xwjd");
const $d4ebd3e41aae7c8a$export$1fd3aad76a7c6788 = 'navigationCtx';
const $d4ebd3e41aae7c8a$export$d0a82da1a0b94929 = (0, $8xwjd.default)($d4ebd3e41aae7c8a$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("bqFtF", function(module, exports) {
$parcel$export(module.exports, "EDITOR_CONTEXT", () => $fdda61b8e0d582a9$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $fdda61b8e0d582a9$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $fdda61b8e0d582a9$export$629cada6c5e621e1);

var $8xwjd = parcelRequire("8xwjd");
const $fdda61b8e0d582a9$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $fdda61b8e0d582a9$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $fdda61b8e0d582a9$export$629cada6c5e621e1 = (0, $8xwjd.default)($fdda61b8e0d582a9$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

parcelRegister("aRa1h", function(module, exports) {
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $e06e37243215b4bd$export$70df29c238ba7306);
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $e06e37243215b4bd$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});

parcelRegister("9kHBl", function(module, exports) {
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $e63174af0df338f4$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $e63174af0df338f4$export$4119ddb38ccbfb87);

var $8xwjd = parcelRequire("8xwjd");
const $e63174af0df338f4$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $e63174af0df338f4$export$4119ddb38ccbfb87 = (0, $8xwjd.default)($e63174af0df338f4$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("6lHdS", function(module, exports) {
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $9f933939b5f6e321$export$da1befb791e93c7e);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => $9f933939b5f6e321$export$6f8e7ff1e3feafd7);

var $8xwjd = parcelRequire("8xwjd");
const $9f933939b5f6e321$export$da1befb791e93c7e = 'NotificationsCtx';
const $9f933939b5f6e321$export$6f8e7ff1e3feafd7 = (0, $8xwjd.default)($9f933939b5f6e321$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("8l1L9", function(module, exports) {
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $c44fa851dd4169ad$export$fc7a65795610cb71);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => $c44fa851dd4169ad$export$745926731087ebe2);

var $8xwjd = parcelRequire("8xwjd");
const $c44fa851dd4169ad$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $c44fa851dd4169ad$export$745926731087ebe2 = (0, $8xwjd.default)($c44fa851dd4169ad$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("bco7U", function(module, exports) {
$parcel$export(module.exports, "ATLAS_CONTEXT", () => $a77b3f4b684140d3$export$4906017439f33fc0);

var $8xwjd = parcelRequire("8xwjd");
const $a77b3f4b684140d3$export$4906017439f33fc0 = 'atlasCtx';
const $a77b3f4b684140d3$export$43ebbe41370d4543 = (0, $8xwjd.default)($a77b3f4b684140d3$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("6dYrq", function(module, exports) {
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => $fd73bf6df865673f$export$aa18ab4fff926c9e);

var $8xwjd = parcelRequire("8xwjd");
const $fd73bf6df865673f$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
const $fd73bf6df865673f$export$d283110f5d85c8f2 = (0, $8xwjd.default)($fd73bf6df865673f$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');

});

parcelRegister("1OSIV", function(module, exports) {
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $e8bbb6e8e57edc15$export$3240443bf2b83834);

var $8xwjd = parcelRequire("8xwjd");
const $e8bbb6e8e57edc15$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $e8bbb6e8e57edc15$export$6d568da622ce0a08 = (0, $8xwjd.default)($e8bbb6e8e57edc15$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("1pTsB", function(module, exports) {
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $6202b782b88a9f26$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $6202b782b88a9f26$export$dcd232f3be312f94);

var $8xwjd = parcelRequire("8xwjd");
const $6202b782b88a9f26$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $6202b782b88a9f26$export$dcd232f3be312f94 = (0, $8xwjd.default)($6202b782b88a9f26$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("7RZOc", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $87091a09ef07147c$export$5c3a6fd8b96e8b66);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => $87091a09ef07147c$export$de3826c30468da26);

var $8xwjd = parcelRequire("8xwjd");
const $87091a09ef07147c$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $87091a09ef07147c$export$de3826c30468da26 = (0, $8xwjd.default)($87091a09ef07147c$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("avy8H", function(module, exports) {
$parcel$export(module.exports, "AVP_CONTEXT", () => $ceac39eebdca990f$export$c2a811a4e42f4af5);

var $8xwjd = parcelRequire("8xwjd");
const $ceac39eebdca990f$export$c2a811a4e42f4af5 = 'avpCtx';
const $ceac39eebdca990f$export$da383e8879a25b03 = (0, $8xwjd.default)($ceac39eebdca990f$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("i9ClG", function(module, exports) {
$parcel$export(module.exports, "GROWTH_CONTEXT", () => $00683dc97744ce9a$export$82023f2f4bfb06c1);

var $8xwjd = parcelRequire("8xwjd");
const $00683dc97744ce9a$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $00683dc97744ce9a$export$84980182680018f = (0, $8xwjd.default)($00683dc97744ce9a$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});

parcelRegister("6dirE", function(module, exports) {
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => $14a01b102120b751$export$6d3c48fd1b3e4f3b);

var $8xwjd = parcelRequire("8xwjd");
const $14a01b102120b751$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
const $14a01b102120b751$export$e4e6df99270bbbb1 = (0, $8xwjd.default)($14a01b102120b751$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');

});

parcelRegister("4YJTV", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => $2c126e619ad3b1b5$export$fae437eb1dd9520c);

var $8xwjd = parcelRequire("8xwjd");
const $2c126e619ad3b1b5$export$fae437eb1dd9520c = 'rovoExtensionCtx';
const $2c126e619ad3b1b5$export$7fcecc25ee38fbef = (0, $8xwjd.default)($2c126e619ad3b1b5$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');

});


parcelRegister("he8Cl", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $f7a20338f8bd907f$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $f7a20338f8bd907f$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $f7a20338f8bd907f$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $f7a20338f8bd907f$export$12346a674644c156);
$parcel$export(module.exports, "DEFAULT_SOURCE", () => $f7a20338f8bd907f$export$b055de0e665cb20c);
// same types defined in analytics-web-client but avoid creating dependency with that
const $f7a20338f8bd907f$export$a1562d08625f5d7e = 'ui';
const $f7a20338f8bd907f$export$947dac6c72b26f81 = 'track';
const $f7a20338f8bd907f$export$f1d537d508d2945a = 'screen';
const $f7a20338f8bd907f$export$12346a674644c156 = 'operational';
const $f7a20338f8bd907f$export$b055de0e665cb20c = 'unknown';

});

parcelRegister("ljGdY", function(module, exports) {
$parcel$export(module.exports, "fireCustomCrossAppAnalytic", () => $e7dd634259f5a0ec$export$f182130953438e47);
const $e7dd634259f5a0ec$export$f182130953438e47 = ({ tags: tags, destinationApp: destinationApp, createAnalyticsEvent: createAnalyticsEvent, analyticsEventFireName: analyticsEventFireName, bridge: bridge, source: source, actionSubjectId: actionSubjectId })=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'customCrossAppExperience',
        actionSubject: 'viewed',
        actionSubjectId: actionSubjectId,
        eventType: 'ui',
        tags: tags,
        attributes: {
            bridge: bridge,
            source: source,
            destinationApp: destinationApp
        }
    });
    analyticsEvent.fire(analyticsEventFireName);
};

});

parcelRegister("a33Jc", function(module, exports) {
$parcel$export(module.exports, "default", () => $83780b983bb41284$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $cn7A7 = parcelRequire("cn7A7");

var $Hyfcf = parcelRequire("Hyfcf");

var $kDPHl = parcelRequire("kDPHl");

var $3X3Vo = parcelRequire("3X3Vo");

var $Fob41 = parcelRequire("Fob41");

var $l5btC = parcelRequire("l5btC");

var $et0fg = parcelRequire("et0fg");

var $bIAtc = parcelRequire("bIAtc");
// Shared helper: decides whether the hook should be active for the current
// runtime. Identical logic to the pre-fix code — kept in one place so both
// the OLD and NEW implementations below stay byte-equivalent on this branch.
function $83780b983bb41284$var$computeIsEnabled() {
    const shouldDisable = (0, $3X3Vo.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $cn7A7.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $kDPHl.isFedrampModerate)();
    return !shouldDisable;
}
/**
 * Legacy implementation (gate `platform_fix_cross_product_url_rerender` OFF).
 *
 * Initialises the session id to an empty string and reads it from the client
 * inside a `useEffect` after mount. This causes one guaranteed re-render of
 * any consumer that depends on the returned wrapper.
 *
 * Kept verbatim so the rollback path is byte-equivalent to the pre-fix code.
 */ function $83780b983bb41284$var$useCrossProductUrlOLD(options) {
    const [interactionSessionId, setInteractionSessionId] = (0, $4tluv.useState)('');
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const isEnabled = $83780b983bb41284$var$computeIsEnabled();
    // Client does not change on re-render - cache with useMemo
    const interactionSessionClient = (0, $4tluv.useMemo)(()=>{
        if (isEnabled) return new (0, $l5btC.default)();
        else return null;
    }, [
        isEnabled
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // Fetch any initial interaction session ID
            const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
            currentSessionId && setInteractionSessionId(currentSessionId);
            // Add event listener that subscribes to any future interaction session ID updates
            const unbind = (0, $Hyfcf.bind)(document, {
                type: (0, $bIAtc.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    if (!isEnabled) return (url)=>url;
    return (url)=>(0, $et0fg.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
}
// Module-level identity wrapper used when the NEW hook is disabled. Stable
// identity avoids causing unnecessary re-renders / effect re-runs in
// downstream consumers.
const $83780b983bb41284$var$identityUrlWrapper = (url)=>url;
/**
 * Fixed implementation (gate `platform_fix_cross_product_url_rerender` ON).
 *
 * - Lazy-initialises the session id from the client on the very first render,
 *   eliminating the post-mount re-render that re-generated the `xpis` query
 *   param.
 * - Returns a stable, memoised wrapper so consumer effects keyed on it do not
 *   re-run on unrelated re-renders.
 *
 * See PIRA-3829.
 */ function $83780b983bb41284$var$useCrossProductUrlNEW(options) {
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const isEnabled = $83780b983bb41284$var$computeIsEnabled();
    const interactionSessionClient = (0, $4tluv.useMemo)(()=>{
        if (isEnabled) return new (0, $l5btC.default)();
        else return null;
    }, [
        isEnabled
    ]);
    const [interactionSessionId, setInteractionSessionId] = (0, $4tluv.useState)(()=>{
        if (isEnabled && interactionSessionClient) return interactionSessionClient.getCurrentInteractionSessionId() ?? '';
        return '';
    });
    (0, $4tluv.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // The lazy useState initializer above already read the session id on the
            // very first render, so we do NOT re-read here — that would cause the
            // avoidable post-mount re-render this fix is removing.
            const unbind = (0, $Hyfcf.bind)(document, {
                type: (0, $bIAtc.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    if (currentSessionId) setInteractionSessionId((prev)=>prev === currentSessionId ? prev : currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    const wrapUrl = (0, $4tluv.useCallback)((url)=>(0, $et0fg.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct), [
        bridge,
        interactionSessionId,
        product,
        subProduct
    ]);
    if (!isEnabled) return $83780b983bb41284$var$identityUrlWrapper;
    return wrapUrl;
}
/**
 * This React hook is called with the correct bridge, product and sub-product parameters.
 * It returns a function that can be used to generate URLs with cross-product interaction parameters.
 *
 * The implementation is selected at call time by the
 * `platform_fix_cross_product_url_rerender` feature gate via `functionWithFG`.
 * This keeps the legacy and fixed code paths fully separated rather than
 * intermixed inside a single hook body. See PIRA-3829.
 *
 * @param options - Properties object that contains the following parameters:
 *
 * @returns A function that appends interaction session ID and other cross-product interaction parameters to a given URL.
 */ const $83780b983bb41284$var$useCrossProductUrl = (0, $Fob41.functionWithFG)('platform_fix_cross_product_url_rerender', $83780b983bb41284$var$useCrossProductUrlNEW, $83780b983bb41284$var$useCrossProductUrlOLD);
var $83780b983bb41284$export$2e2bcd8739ae039 = $83780b983bb41284$var$useCrossProductUrl;

});


//# sourceMappingURL=ConversationAssistant.1f65baca.js.map
